/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Search results page component. The component displays the Search results page details.
 * 
 * App Name: SDI-Walmart
 * Author: M.Sushmitha
 * Created Date: 09/02/2020 
 */
import React, { Component } from 'react';
import Image from 'react-image-resizer';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import SearchResultsStore from '../stores/SearchResultsStore';
import * as SupplierSuggestionAction from '../actions/SupplierSuggestionAction';
import SupplierSuggestionStore from '../stores/SupplierSuggestionStore';
import * as MenuAction from '../actions/MenuAction';
import SDIConstants from '../SDIConstants';
import CheckboxTree from 'react-checkbox-tree';
import ReactPaginate from 'react-paginate';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import Autocomplete from 'react-autocomplete'; //WW-368_SuggestionCat_for_favItem_PC_
import FavItemMainStore from '../stores/FavItemMainStore';
import * as FavItemMainAction from '../actions/FavItemMainAction';
import SupplierSuggestionComponent from '../components/SupplierSuggestionComponent';
import swal from 'sweetalert';
import { Divider } from '@material-ui/core';
import i18n from '../i18n';
import ImageGallery from 'react-image-gallery';
//CPW-114_PC_01 -Aparna
import Switch from '@material-ui/core/Switch';
import WOPartsComponent from '../components/WOPartsComponent';
let catagoryfilterApplied = 0
let CatalogType = true
let ClientType = false
let rmvAttachindex = -1;
let ImageURL = ""
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
//WW-1216 Precart - Yuvarani K
let ImageFilePath = ""
let FormDataProps = [];
let FormOptionsDataProps = [];
let IsAltPart = ""
let IsPickup = false
let IsImageSearch = false
let ImageFiles = ""
let image = ""
let EnersysItems = "";
let FormItems = "";
let FormFilePath = "";
let ItemArray = [];
let cartpickUp = false;
let mixcartfunction = false;
//WW-1382_WW-1372 variable to find the it from search results - Nandhini L 
let fromSearch = false;
const style = {
    image: {
        position: 'sticky !important',
        display: 'block',
        left: '0px !important',
        top: '0px !important',
        marginLeft: '40px',
        cursor: 'pointer'
    },
}
const styleE = {
    image: {
        position: 'sticky !important',
        display: 'block',
        left: '0px !important',
        top: '0px !important',
        marginLeft: '40px',
        width: '100%',
        height: '100%',
        pointer: 'cursor'

    },
}
const hei = {
    height: '290px',
    overflowY: 'auto'
}
class SearchResults extends Component {

    constructor(props) {
        super(props);
        this.LoadSearchResults = this.LoadSearchResults.bind(this);
        this.BuildSearchResults = this.BuildSearchResults.bind(this);
        this.bindSearchResults = this.bindSearchResults.bind(this);
        this.FavSuccess = this.FavSuccess.bind(this);
        this.AddtocartSuccess = this.AddtocartSuccess.bind(this);
        this.Search = this.Search.bind(this);
        this.AnykeyPress = this.AnykeyPress.bind(this);
        //[2/22/2023, Bug - 3127, Dhevanesam R]
        this.keyPressQTY = this.keyPressQTY.bind(this);
        this.Addtocart = this.Addtocart.bind(this);
        this.CheckCheaperItemResponse = this.CheckCheaperItemResponse.bind(this);
        //WAL-1034_PC_40 -Aparna
        this.AnykeyWOPress = this.AnykeyWOPress.bind(this);
        this.WOText = React.createRef();
        this.handleEquipmentNo = this.handleEquipmentNo.bind(this);
        this.handleEquipmentYes = this.handleEquipmentYes.bind(this);
        //WW-1374 problem code search - Nandhini L 
        this.onChangePC = this.onChangePC.bind(this);

        this.state = {
            DescriptionType: 1,
            showpagination: false,
            ShowSampleMessage: false,
            AddFavPUp: false,
            FavitemImage: "",
            ItemType: "",
            FavItemIdPopUp: "",
            FavSDICatgPopUp: "-",
            FavItemDescripPopUp: "",
            //WW-1216 Precart - Yuvarani K
            FiltItemValue: {}, FiltItemIndex: 0, FormData: "", FormOptionsData: "",
            FavMFGPopUp: "",
            FavMFGPartNUMPopUp: "",
            txtUOMHidePopUp: "",
            FavSupplierPopUp: "",
            txtMfgItemidHidePopUp: "", FavSAP: "",
            txtItemidHidePopUp: "",
            txtMFGHidePopUp: "",
            Manufacture: [],
            AttributeTree: [],
            Attrichecked: [],
            Manuchecked: [],
            SearchKeyWord: "",
            PageLoadSearchResults: [],
            OrderCatalogItem: [],
            OrderNonCatalogItem: [],
            FilteredSearchResults: [],
            PageloadcatalogTree: [],
            CatalogTree: [],
            pageload: 0,
            checked: [],
            expanded: [],
            FilterValuedata: [],
            filterAppliedType: "All",
            FavoritesMenu: [],
            expanded: [],
            pageNo: 1,
            filterApplied: 0,
            filterAttri: 0,
            filterManu: 0,
            pageCount: 0,
            itemperpage: 10,
            cheaperItem: {},
            cheaperItemImage: "",
            cheaperQty: '',
            cheapershipby: '',
            cheaperIndex: '',
            cheaperClientId: '',
            cheaperItemAttr: '',
            cheaperManf: '',
            TotalItemCount: 0,
            FavoritesSubMenu: [],
            ManufactureTable: [],
            CatagoryTable: [],
            GridType: 1,
            FilterValue: 1,
            pageresqty: "",
            filterseachqty: "",
            DidyouMean1: "",
            DidyouMean2: "",
            DidyouMean3: "",
            SupplierChecked: [],
            SupplierTree: [],
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            ShowDidyoumean: false, QuantityOrdered: "", SelectedItemForCheaper: {}, SelectedItemForCheaperImg: "", Itemdetailfav: false, selectedItemdetailfav: false, cheaperResponse: [],
            WorkOrderNo: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "", WOmsg: false, StoreValue: localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "",
            mfgpartstboolean: false,
            //[12/30/21], PC_SR_14, WW-286, Dhevanesam R
            CheapItemMinQty: "", CheapItemMaxQty: "", cheaperItemIndex: "", EditedQuantity: false, showCoreCharge: false,
            index1CC: "", catalogIdCC: "", ManuPartNumCC: "", manufacturerCC: "", ItemPriceCC: "", suppliernameCC: "", addtocartCoreCharge: false, QtyChCoreCharge: false,
            /*[01/30/22, PC_EF_04, Priyanka.D]*/
            EnersysFormVaue: "", EnersysForm: false, EnersysEmp: "",
            /*[04/01/22,PC_DF_03,WW-371], Priyanka D */
            autocompleteData: [], autocompleteDataRstl: [], //WW-368_SuggestionCat_for_searchresult_PC_04 -Aparna
            attachmentPathArr: [], SelectedValueImg: "", DoorFormValue: "", DoorForm: false, WarehousecheckBOX: false, ItemAddedtoCart: {}, CategoryErr: false,
            SupplierSuugMFG: "", SupplierSugMfgName: "", SuppIsFromFav: "", SuppFavItemPage: "", SuppLongDesc: "", ShowSupplierSugg: false,
            FavSubCategory: "", subCategoryResults: [], subCategory: [], SubCategoryErr: false, IsDotClick: false, IsDotClickIndex: [],
            selectallMfg: true, selectallAtt: true, selectallSup: true, pickUp: localStorage.getItem("pickupcheck") == "true" ? true : false, inventory: localStorage.getItem("inventorycheck") != null ? JSON.parse(localStorage.getItem("inventorycheck")) : false, equParts: [],
            WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [],  //Bug :3618
            isValidWO: localStorage.getItem("WONum") != null ? true : false,//WAL-1034_PC_07 
            WONum: localStorage.getItem("WONum") != null ? localStorage.getItem("WONum") : "", AddValue: [], FavKit_Components: "",
            KIT_Components: "", ISCoreCharge: false,
            TruckStock: localStorage.getItem("truckStockcheck") != null && localStorage.getItem("truckStockcheck") != undefined ? JSON.parse(localStorage.getItem("truckStockcheck")) : false, //CPW-114_PC_02 -Aparna
            IsDotClickEquiPartIndex: [], IsDotClickEquiPart: false, /*[30/10/23, PC_WW_850_06, Vishwa S]*/
            ManufacturerPartsList: [],
            isPageloadValidWO: localStorage.getItem("WONum") != null ? true : false,//WW-1231 -Vishwa S
            //WW-1216 Precart - Yuvarani K
            ReasonType: "", Comments: "", AddIndex: 0, AddValue: [],
            isPageloadValidWO: localStorage.getItem("WONum") != null ? true : false, //WW-1231 -Vishwa S
            cartConfirmationPopupTxt: "", //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            IsProblemCodeSearch: CookieService.getLocalStorageValues("IsProblemCodeSearch") ? CookieService.getLocalStorageValues("IsProblemCodeSearch") : false,
            ProblemCodeSearch: false,
            isExpanded: false
        }
        mixcartfunction = false;
        cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        //WW-1216 Precart - Yuvarani K
        cartpickUp = localStorage.getItem("pickupcheck") == "true" ? true : false
    }

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        CookieService.updateLocalStorageValues("itemDetailUrl", "");

        //if (this.state.pageload == 0) {
        //    const queryParams = new URLSearchParams(window.location.search)
        //    const QS_src = queryParams.get('key');
        //    console.log(QS_src)
        //    this.setState({ SearchKeyWord: QS_src })
        //}
        if (localStorage.getItem("WONum") != null) {
            {/**A1QA-131PC_02 Users Without WO Should Not Be Able To See Inventory Items -Aparna*/ }
            //$("#WONUM").addClass("disabledbutton");
            //$("#WOOK").addClass("disabledbutton");
            $('#WONUM').val(JSON.parse(localStorage.getItem("WONum")))
        }
        //WW-1216 Precart - Yuvarani K

        let imagesearch = CookieService.getLocalStorageValues("ImageSearch") ? CookieService.getLocalStorageValues("ImageSearch") : this.props?.location?.state?.ImageSearch

        if ((CookieService.getLocalStorageValues("IsProblemCodeSearch") == true) || (CookieService.getLocalStorageValues("fromSearch") && CookieService.getLocalStorageValues("FilePath") && CookieService.getLocalStorageValues("FileName"))) {
            this.LoadSearchResults()
        }
        else if (imagesearch) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let ImgFiles = this.props ?.location ?.state ?.ImageFiles;
            SearchResultsAction.ImgaddAttachment(ImgFiles);

        }
        else {
            this.LoadSearchResults()
        }
        /*A1QA-206 -Pavithra-Scrolled to the top of the page when pagination is clicked   */
        window.scrollTo(0, 0)
        SearchResultsStore.on('Searchresult', this.BuildSearchResults); /*26/09/23, PC_WW_826_01 - Removed the bind instance for the event listener, Vishwa S]*/
        SearchResultsStore.on('Status', this.AddtocartSuccess);
        SearchResultsStore.on('SrchFavitemAdd', this.FavSuccess);
        SearchResultsStore.on('Search_DynamicForm', this.dynamicFormReponse);
        SearchResultsStore.on('AddToCartBypass', this.CoreChargeResponseClick);
        SearchResultsStore.on('CheaperItem', this.CheckCheaperItemResponse);
        SearchResultsStore.on('workordercheck', this.Workorderresponse);
        SearchResultsStore.on('WOfail', this.workorderfail);
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
        NonCatalogStore.on('attachmentResponse', this.loadAttachments);
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
        FavItemMainStore.on('DeleteItem', this.DelFavItem);
        SearchResultsStore.on('ImgUploadAttachments', this.loadAttachmentsImgsearch);
    }
    componentWillUnmount() {
        SearchResultsStore.removeListener('Searchresult', this.BuildSearchResults); /*26/09/23, PC_WW_826_02 - Removed the bind instance for the remove event listener, Vishwa S]*/
        SearchResultsStore.removeListener('Status', this.AddtocartSuccess);
        SearchResultsStore.removeListener('SrchFavitemAdd', this.FavSuccess);
        SearchResultsStore.removeListener('CheaperItem', this.CheckCheaperItemResponse);
        SearchResultsStore.removeListener('AddToCartBypass', this.CoreChargeResponseClick);
        SearchResultsStore.removeListener('workordercheck', this.Workorderresponse);
        SearchResultsStore.removeListener('Search_DynamicForm', this.dynamicFormReponse);
        SearchResultsStore.removeListener('WOfail', this.workorderfail);
        ShoppingCartStore.removeListener('Warehousecheck', this.warehouseqtyresponse);
        NonCatalogStore.removeListener('attachmentResponse', this.loadAttachments);
        FavItemMainStore.removeListener('DeleteItem', this.DelFavItem);
        SearchResultsStore.removeListener('ImgUploadAttachments', this.loadAttachmentsImgsearch);

    }

    //bindEquParts = () => {
    //    debugger
    //    if (this.state.equParts != undefined && this.state.equParts != null) {
    //        return this.state.equParts.map((val, index) => {
    //            return (
    //                <span>
    //                    <a href="#" className="category-search-iditemHyperlink equparts ml-1"  onClick={(e) => this.navigateItemdetails(val.Supplier_Part_Num, val.MANUFACTURER, val.MFG_PART_NUM, val.Vendor_Id, e)}>{val.MFG_PART_NUM}</a>
    //                    {index != this.state.equParts.length - 1 ?
    //                        <label className="float-left itemHyperlink mr-1 equparts">,</label> : null}
    //                </span>
    //            )
    //        });
    //    }
    //}
    //WW-1216 Precart - Yuvarani K

    CoreChargeProceedClick = (e) => {
        $('#CoreChargePopUp').modal('hide');
        let Index = this.state.AddIndex;
        let GridArray = ItemArray
        CookieService.updateLocalStorageValues("ItemAddedToCart", GridArray[Index]);
        this.setState({ FiltItemValue: GridArray[Index] });
        let AddToCartBO = this.FormCartBO(Index, GridArray);
        SearchResultsAction.AddCart_Bypass(AddToCartBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }

    //WW-1216 Precart - Yuvarani K
    FormCartBO = (Index, Value) => {
        let GridArray = ItemArray;
        let OrderNonCatalogItemL = [];
        let suppllier_part_num = GridArray.supplier_part_number;
        if (suppllier_part_num == "" || suppllier_part_num == undefined || suppllier_part_num == null) {
            suppllier_part_num = GridArray.clientPartNumber;
        };
        let ItemDetails = {
            ItemId: GridArray.clientPartNumber,
            txtSupplier: GridArray.supplierName,
            txtSupplierID: GridArray.vendor_id,
            txtSuppPartNum: suppllier_part_num,
            txtEstPrice: GridArray.ItemPrice,
            txtDesc: GridArray.Description + " " + "-InvItemIcon-" + GridArray.hasBenItemVal,
            txtMfgPartNum: GridArray.manfPartNumber,
            txtMfgName: GridArray.manufacturer,
            txtQty: GridArray.QuantityOrdered,
            image_url: GridArray.ThumbnailImagefile,
            DropUOM: GridArray.UOM,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: null,
            EMPCC: "",
            DUeDate: GridArray.DeliverDate,
            Type: "",
            MachineNo: "",
            Notes: "",
            Priority: "",
            SAP_ARTCILE_NUMBER: GridArray.customer_part_number_woprefix,
            ItemCat: GridArray.UNSPSC,
            MIN_ORD_QTY: GridArray.min_order_qty,
            CORE_CHARGE: GridArray.core_charges,
            REASON_TYPE: this.state.ReasonType,
            COMMENTS: this.state.Comments
        };
        OrderNonCatalogItemL.push(ItemDetails);
        let AddToCartBO = {
            ItemDetails: [],
            NonItemDetails: OrderNonCatalogItemL,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_USERID: this.state.Login_UserId,
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: "",
            Session_PUNCHIN: "False",
            MobileAPICall: false,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),
            SOURCE: "WEB",
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false,
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
        }
        return AddToCartBO;
    }

    //WW-1216 Precart - Yuvarani K

    CheckFormExistsInCart = (value) => {
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        CartStorage.forEach((val) => {
            if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath != " ") {
                if (val.FilePath[0].toLowerCase().includes('enersys')) {
                    EnersysItems = EnersysItems.concat(val.Itemid);
                }
                else if (val.FilePath != null && val.FilePath[0].toUpperCase().includes(value.form.trim())) {
                    FormItems = FormItems.concat(val.Itemid);
                    FormFilePath = FormFilePath.concat(val.FilePath[0]);
                }

            }
        });
    }

    //WW-1216 Precart - Yuvarani K
    AddToCart = (value, index, fromCorePopup, ReasonType, Comments) => {
        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
        const {t}= this.props
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        let hasEquipmentItem = [];
        let hasQuoteItem = [];
        mixcartfunction = true;
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        }
        //WW-694_PC_02 -Aparna
        if (value != undefined && value != null) {
            this.setState({ AddIndex: index, AddValue: value })
        } else {
            value = this.state.AddValue
            index = this.state.AddIndex
        }
        // Equipment item add to cart issue fixing - Nandhini L
        let AdjQtySupplierArray = value;
        let form = "";
        let actualQty = "";
        if (AdjQtySupplierArray.actual_qty != null && AdjQtySupplierArray.actual_qty != undefined) {
            let QuantityOnhandL = AdjQtySupplierArray.actual_qty;
            actualQty = QuantityOnhandL.split('^');
        }



        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        if ((parseInt(AdjQtySupplierArray.QuantityOrdered) > actualQty && AdjQtySupplierArray.vendor_id == "W999999999")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered quantity is greater than the available quantity ')
            });
            return;
        }
        // let Index = this.state.PageLoadSearchResults.findIndex(x => x.clientPartNumber == value.clientPartNumber && x.manfPartNumber == value.manfPartNumber && x.mfg_std == value.mfg_std && x.ItemPrice == value.ItemPrice && x.supplierName.trim().toUpperCase() == value.supplierName.trim().toUpperCase());
        // let PageLSearchResults = this.state.PageLoadSearchResults;
        // let val = (parseInt(this.state.QuantityOrdered) / parseInt(PageLSearchResults[Index].min_order_qty));
        else if (parseInt(AdjQtySupplierArray.QuantityOrdered) < parseInt(AdjQtySupplierArray.min_order_qty)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Entered Is Below The Minimum Order Quantity')
            });
            return;
        }
        else if ((parseInt(AdjQtySupplierArray.QuantityOrdered) % parseInt(AdjQtySupplierArray.min_order_qty)) != 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered Quantity Does Not Match the Minimum Order Quantity Sequence')
            });
            return;
        } else if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
            $('#SearchMixedOrderConfirmPopup').modal('show');
            this.setState({ value: value, index: index, fromCorePopup: fromCorePopup, ReasonType: ReasonType, Comments: Comments, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
            return;
        }
        else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            $('#SearchMixedOrderConfirmPopup').modal('show');
            this.setState({ value: value, index: index, fromCorePopup: fromCorePopup, ReasonType: ReasonType, Comments: Comments, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
            return;
        }
        else if (AdjQtySupplierArray.AttributeValue.indexOf("BATTERY") > -1 || AdjQtySupplierArray.AttributeValue.indexOf("CHARGER") > -1) {
            //let EnersysFormVaue = value.AttributeValue;
            let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));

            let EnersysItem = []
            EnersysItem = CartStorage.filter((item, index) => item.Itemid == value.clientPartNumber);

            if (EnersysItem.length > 0 && EnersysItem != undefined && EnersysItem != null && EnersysItem != []) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("This")+" "+ value.form.trim() + t(" Item is already added in the cart ")
                });
                return;
            }
        }

        //WW-694_PC_02(if the method is called from core charge popup then it should not display) -Aparna
        if (AdjQtySupplierArray.hasCoreCharge && fromCorePopup == false) {
            $('#CoreChargePopUp').modal('show');
            return;
        }
        //[12/15/22], PC_WW-552_FE_10, Dhevanesam R
        else if (FormDataProps.length > 0 && FormDataProps != "" && FormDataProps != undefined && FormDataProps != []) {
            if (AdjQtySupplierArray.AttributeName.includes('FORM') || AdjQtySupplierArray.AttributeName.includes(' FORM')) {
                this.CheckFormExistsInCart(ItemArray);
                let AddToCartBO = this.FormCartBO(index, ItemArray);

                //[1/11/23, WW-552, Dhevanesam R]

                // this.setState({ EnersysFormVaue: EnersysFormVaue, EnersysForm: true, EnersysEmp: "Are you working on an enersys(nextsys) " + EnersysFormVaue.toLowerCase() });
                // CookieService.updateLocalStorageValues("EnersysFormVaue", EnersysFormVaue)
                //CookieService.updateLocalStorageValues("EnersysForm", true)
                //if (CookieService.getLocalStorageValues("EnersysForm") == true) {
                //    if (EnersysItems != undefined) {
                //        if ((EnersysItems.indexOf(value.clientPartNumber) == -1)) {
                //            $('#EnersysEmployee').modal('show');
                //            return;

                //        }

                //    }
                //    else {
                //        $('#EnersysEmployee').modal('show');
                //        return;
                //    }
                //}
                // }
                //else {
                //[1/20/23, PC_WW-552_FE_41, Dhevanesam R]
                if (FormItems != undefined && FormItems != null && FormFilePath != undefined && FormFilePath != null && value.form != undefined && value.form != null) {

                    if (value.form.trim() == "KENSTAN-KEY" && FormFilePath.includes("KENSTAN-KEY")) {
                        //debugger
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: t("KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity")
                        });
                        FormItems = "";
                        FormFilePath = "";
                        return;
                    }
                    else {
                        let CartStorage = JSON.parse(localStorage.getItem("CartStorage")) || [];
                        let itemInCart = CartStorage.filter(item => item.Itemid === value.clientPartNumber && item.SupplierPartNumber === value.supplier_part_number && item.SupplierID == value.vendor_id && item.Manufacturerpartnumber === value.manufacturer_part_number && item.Manufacturer === value.manufacturer_name);
                        if (itemInCart.length == 0) {
                            FormItems = "";
                            FormFilePath = "";

                            //WW-1378_WW-1382- Update search properties to local storage - Nandhini L
                            let SearchUrl = window.location.href
                            CookieService.updateLocalStorageValues("SearchUrl", SearchUrl);
                            CookieService.updateLocalStorageValues('fromSearch', true);
                            CookieService.updateLocalStorageValues('pageNo', this.state.pageNo);
                            CookieService.updateLocalStorageValues('GridType', this.state.GridType);
                            CookieService.updateLocalStorageValues('itemperpage', this.state.itemperpage);
                            CookieService.updateLocalStorageValues('DescriptionType', this.state.DescriptionType);

                            this.props.history.push({
                                pathname: "/forms",
                                state: {
                                    item: AddToCartBO, qty: value.QuantityOrdered, WO: this.state.WorkOrderNo, pagename: 'SearchResult', searchKey: this.state.SearchKeyWord, form: form, FormData: FormDataProps, FormOptionsData: FormOptionsDataProps, FormName: value.form.trim()
                                }
                            });
                        }
                        else if (itemInCart.length > 0 && itemInCart[0].FilePath && itemInCart[0].FilePath.length == 10) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: t('This item is already in the cart and has reached the maximum number of 10 forms')
                            });
                            return true;
                        }
                        else {
                            let AddToCartBO = this.FormCartBO(index);
                            CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                            this.setState({ FiltItemValue: value });
                            SearchResultsAction.AddCart_Bypass(AddToCartBO);
                            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        }
                    }

                } else {
                    if (FormDataProps != "" || FormDataProps != undefined || FormDataProps != []) {

                        //WW-1378_WW-1382- Update search properties to local storage - Nandhini L
                        let SearchUrl = window.location.href
                        CookieService.updateLocalStorageValues("SearchUrl", SearchUrl);
                        CookieService.updateLocalStorageValues('fromSearch', true);
                        CookieService.updateLocalStorageValues('pageNo', this.state.pageNo);
                        CookieService.updateLocalStorageValues('GridType', this.state.GridType);
                        CookieService.updateLocalStorageValues('itemperpage', this.state.itemperpage);
                        CookieService.updateLocalStorageValues('DescriptionType', this.state.DescriptionType);

                        this.props.history.push({
                            pathname: "/forms",
                            state: { item: AddToCartBO, qty: value.QuantityOrdered, WO: this.state.WorkOrderNo, pagename: 'SearchResult', searchKey: this.state.SearchKeyWord, form: form, FormData: FormDataProps, FormOptionsData: FormOptionsDataProps, FormName: value.form.trim() }
                        });
                    }
                    else {
                        let AddToCartBO = this.FormCartBO(index);
                        CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                        this.setState({ FiltItemValue: value });
                        SearchResultsAction.AddCart_Bypass(AddToCartBO);
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide')
                    }
                }



                // }

            }
            else {

                let AddToCartBO = this.FormCartBO(index);
                CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                this.setState({ FiltItemValue: value });
                SearchResultsAction.AddCart_Bypass(AddToCartBO);
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
        }
        else {

            let AddToCartBO = this.FormCartBO(index);
            CookieService.updateLocalStorageValues("ItemAddedToCart", value);
            this.setState({ FiltItemValue: value });
            SearchResultsAction.AddCart_Bypass(AddToCartBO);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }

    };
    //WW-1216 Precart - Yuvarani K

    CoreChargeResponseClick = () => {
        //debugger
        const { t }=this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Status = JSON.parse(SearchResultsStore.AddToCartBypass);
        let itemstatus = Status._FlagDt;
        let iteminsertstatus = Status.SuccessFLag;
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        let FromNonCat = "";
        if (this.props.location.state.FromNonCat === "noncat") {  //[10/3/2023] - 4252 - PC_WW_826_06 - Vishwa S
            FromNonCat = "noncat"
        }
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {
                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }




                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Item")+" "+ itemidnotinserted + t(" is not added to cart due to technical issue. Contact SDI customer care.")
                    });
                    return;
                }
                if (iteminsertstatus[0].CORE_CHARGE != "" && iteminsertstatus[0].CORE_CHARGE != " " && iteminsertstatus[0].CORE_CHARGE != null) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Item successfully added to cart and added item applies core charges")



                        //state: { ImageSearch: false, ImageFiles: "", image: "" }
                    });

                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Item successfully added to cart")
                    });
                }

                $(`#${SDIConstants.SDILoader}`).addClass('hide');

                PageLSearchResults[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                FilterdValue[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                PageLSearchResults[this.state.cheaperIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperIndex].min_order_qty;
                FilterdValue[this.state.cheaperIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperIndex].min_order_qty;
                console.log(PageLSearchResults, FilterdValue)
                this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });


            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t(" Item cannot be added to cart due to technical issue. Contact SDI customer care.")
                });
                return;
            }
        }
    };

    //WW-1216 Precart - Yuvarani K
    dynamicFormReponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //debugger
        let DynamicFormResData = JSON.parse(SearchResultsStore.Search_DynamicForm);
        let FormDataDtArr = []
        let OptionsDataDtArr = []
        if (DynamicFormResData.ErrorMessageDT != null && DynamicFormResData.ErrorMessageDT != undefined) {
            //debugger
            if (DynamicFormResData.ErrorMessageDT.length > 0) {
                //debugger
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: DynamicFormResData.ErrorMessageDT[0].ErrorMessage
                });
                return;
            }
        }
        else {
            if (DynamicFormResData.FormDataDt != null && DynamicFormResData.FormDataDt != undefined) {
                if (DynamicFormResData.FormDataDt.length > 0) {
                    FormDataDtArr = DynamicFormResData.FormDataDt
                }
            }
            if (DynamicFormResData.OptionsDataDt != null && DynamicFormResData.OptionsDataDt != undefined) {
                if (DynamicFormResData.OptionsDataDt.length > 0) {
                    OptionsDataDtArr = DynamicFormResData.OptionsDataDt
                }
            }
        }
        FormDataProps = FormDataDtArr
        FormOptionsDataProps = OptionsDataDtArr
        this.setState({ FormData: FormDataDtArr, FormOptionsData: OptionsDataDtArr });
        let AddValue = CookieService.getLocalStorageValues("AddValue");
        let AddIndex = CookieService.getLocalStorageValues("AddIndex");
        this.AddToCart(this.state.AddValue, this.state.AddIndex, false);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
    }
    bindEquParts = (value, ItemIndex) => {
        debugger
        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        let equParts = JSON.parse(value)
        if (equParts != undefined && equParts != null) {
            /*[30/10/23, PC_WW_850_07, Vishwa S]*/
            let moreClick = false;
            let moreClickIndex = 0;
            return equParts.map((val, index) => {
                let partNumber = val.MFG_PART_NUM
                //let Manufacturer = val.MfgName
                //let manufacturer_partnum = val.MfgPartNum

                //let vendor_id = val.VendorID

                /*[30/10/23, PC_WW_850_08, Vishwa S]*/
                let firstNumber = ((this.state.pageNo - 1) * this.state.itemperpage) + index;
                let concatenatedString = firstNumber.toString() + ItemIndex.toString();
                let concatenatedInteger = parseInt(concatenatedString);

                /*[30/10/23, PC_WW_850_09, Vishwa S]*/
                if (equParts.length > 8) {
                    if (index >= 7 && this.state.IsDotClickEquiPartIndex.includes(concatenatedInteger)) {
                        moreClick = true;
                    }
                    if (index == 7) {
                        moreClickIndex = concatenatedInteger;
                    }
                    return (
                        //<span>
                        //    <a className="category-search-iditemHyperlink equparts ml-1" >{partNumber}</a>
                        //    {index != equParts.length - 1 ?
                        //        <label className="itemHyperlink equparts">,</label> : null}
                        //</span >
                        <span>
                            {
                                index <= 7 && !this.state.IsDotClickEquiPartIndex.includes(concatenatedInteger) ?
                                    <React.Fragment>
                                        < span >
                                            <a className={`category-search-iditemHyperlink equparts ml-1 ${
                                                index === 0 && this.state.SearchKeyWord === partNumber ? 'equivalent-highlight' : ''
                                                }`} >{partNumber}</a>
                                            {
                                                index != equParts.length - 1 ?
                                                    <label className="itemHyperlink equparts">,</label> : null
                                            }
                                        </span ><span>
                                            {index == 7 && !this.state.IsDotClickEquiPartIndex.includes(concatenatedInteger) ? <span className="expand-collapse-style" onClick={(e) => this.handleEquiPartDotclick(concatenatedInteger, 'More')} >...<Trans>More</Trans></span> : null}
                                        </span>
                                    </React.Fragment>
                                    : <>{!this.state.IsDotClickEquiPartIndex.includes(concatenatedInteger) && moreClick !== true ? null
                                        : <React.Fragment> < span >
                                            <a className={`category-search-iditemHyperlink equparts ml-1 ${
                                                index === 0 && this.state.SearchKeyWord === partNumber ? 'equivalent-highlight' : ''
                                                }`} >{partNumber}</a>
                                            {
                                                index != equParts.length - 1 ?
                                                    <label className="itemHyperlink equparts">,</label> : null
                                            }
                                        </span > <span>
                                                {index == equParts.length - 1 ? <span className="expand-collapse-style" onClick={(e) => this.handleEquiPartDotclick(moreClickIndex, 'Less')} ><Trans>Less</Trans></span> : null}
                                            </span>
                                        </React.Fragment>}</>
                            }
                        </span>
                    )
                }
                /*[30/10/23, PC_WW_850_10, Vishwa S]*/
                else {
                    return (
                        <span>
                            <a className={`category-search-iditemHyperlink equparts ml-1 ${
                                index === 0 && this.state.SearchKeyWord === partNumber ? 'equivalent-highlight' : ''
                                }`} >{partNumber}</a>
                            {index != equParts.length - 1 ?
                                <label className="itemHyperlink equparts">,</label> : null}
                        </span >
                    )
                }

            });
        }

    }
    loadAttachmentsImgsearch = () => {
        const {t}=this.props
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');

        let isValid = SearchResultsStore.ImgattachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {

            let attachmentResponse = JSON.parse(SearchResultsStore.ImgattachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {

                let currentPath = this.props.location.pathname;
                if (currentPath.toLowerCase() == "/searchresults") {
                    window.history.go(-1)

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("You can choose only the Image files!!")
                    }).then(function () {
                        window.location.reload();
                    });
                    return;
                } else {
                    window.history.go(-1)
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("You can choose only the Image files!!")
                    })
                }

                return;
            }

            else {
                ImageFilePath = attachmentResponse
                this.LoadSearchResults()

            }


        } else {

            window.history.go(-1)
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });


        }
    }
    /*[30/10/23, PC_WW_850_11, Vishwa S]*/
    handleEquiPartDotclick = (moreClickIndex, Action) => {
        if (Action === "More") {
            this.state.IsDotClickEquiPartIndex.push(moreClickIndex)
            this.setState({ IsDotClickEquiPart: true })
        }
        else if (Action === "Less") {
            let index = this.state.IsDotClickEquiPartIndex.indexOf(moreClickIndex);

            if (index !== -1) {
                this.state.IsDotClickEquiPartIndex.splice(index, 1);
                this.setState({ IsDotClickEquiPart: false })
            }
        }
    }

    navigateItemdetails = (supplierPartNum, Manufacturer, ManufacturerPart, vendor_id, event) => {
        const queryParams = new URLSearchParams(window.location.search)
        const previtemid = queryParams.get('ItemId');
        const prevvendor = queryParams.get('SupplierID');
        if (event) {
            event.preventDefault();
        }
        this.props.history.push({
            pathname: `\itemdetailnew`,
            search: `?ItemId=${supplierPartNum}&ManufacturePartNumber=${ManufacturerPart}&ManufactureName=${Manufacturer}&SupplierID=${vendor_id}&origin=search&searchkey= ${this.state.SearchKeyWord}`,
            state: { searchkey: `?key=${this.state.SearchKeyWord}&Make=&Model=&AssetId=&`, Suggesstions: false, ItemId: supplierPartNum, ManufacturePartNumber: ManufacturerPart, ManufactureName: Manufacturer, SupplierID: vendor_id, LAST_ITEM_VENDOR_ID: previtemid, LAST_ITEM_VENDOR_ITEM_ID: prevvendor, IsAltPart: true, equhighlight: this.state.SearchKeyWord }
        });
    }
    DelFavItem = () => {
        const {t}= this.props
        let PageLoadResponse = JSON.parse(FavItemMainStore.PageLoadData);
        //alert("Favorite item removed sucessfully")
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: t('Favorite item removed sucessfully')
        });
        //return;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        MenuAction.refreshMasterData()
        let favsub = PageLoadResponse.FavSubMenu
        CookieService.updateLocalStorageValues("FavSubMenu", favsub);

        // console.log("CookieService.getLocalStorageValues", CookieService.getLocalStorageValues("Fav_Item_Cat"));
        this.setState({ FavoritesSubMenu: favsub })
    }
    loadAttachments = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            /*[03/23/22,PC_32,WAL-511], Priyanka D */
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                alert("You can choose only the Image files!!")
                return;
            }
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    LoadSearchResults = () => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let CatagoryList = []
        if (catagoryfilterApplied == 1) {
            CatagoryList = this.state.checked
        }
        const queryParams = new URLSearchParams(window.location.search)
        //const QS_src = queryParams.get('key');
        //*******getting cookie value for the saerch key**
        let QS_srcs = queryParams.get('key');
        /******NEW*********wal-158* */
        //const Sup = queryParams.get('sup');
        const Make = queryParams.get('Make');
        const Model = queryParams.get('Model');
        const AssetId = queryParams.get('AssetId');
        let sup = [];
        let SupplierSelected = [];
        let cat = [];
        let CattreeSelected = [];
        let mfg = [];
        let ManfNameSelected = [];
        let SuppNameSelected = [];
        let PFCcount = JSON.parse(localStorage.getItem("PFCatCount"));
        let PFScount = JSON.parse(localStorage.getItem("PFSuppCount"));
        let PFMcont = JSON.parse(CookieService.getLocalStorageValues("PFMFGCount"));
        let ImageFiles = []
        let FilePath = ""
        let FileName = ""
        //WW-1216 Precart - Yuvarani K
        let imagesearch = CookieService.getLocalStorageValues("ImageSearch") ? CookieService.getLocalStorageValues("ImageSearch") : this.props?.location?.state?.ImageSearch
        if (!CookieService.getLocalStorageValues("fromSearch") && imagesearch) {
            ImageFiles = ImageFilePath;
            if (ImageFiles[0].FileName != undefined && ImageFiles[0].FileName != [] && ImageFiles[0].FileName != null) {

                FilePath = ImageFiles[0].FilePath
                FileName = ImageFiles[0].FileName
            }
            Image = this.props.location.state.image
            ImageURL = URL.createObjectURL(Image)

            CookieService.updateLocalStorageValues("FilePath", FilePath)
            CookieService.updateLocalStorageValues("FileName", FileName)
            CookieService.updateLocalStorageValues("ImageSearch", imagesearch)
            CookieService.updateLocalStorageValues("ImageURL", ImageURL)

        }
        else {
            ImageURL = CookieService.getLocalStorageValues("ImageURL")
            FilePath = CookieService.getLocalStorageValues("FilePath")
            FileName = CookieService.getLocalStorageValues("FileName")
        }



        if (PFScount > 0) {
            //console.log("sup", sup);
            sup = JSON.parse(localStorage.getItem("PFSupplier"))

            sup = sup.filter((x) => x.checked == true)
            console.log("sup", sup);
            sup.forEach((val) => {
                SupplierSelected.push(val.VENDOR_ID)
                /*WW-508-trade service revert back changes-Priyanka */
                SuppNameSelected.push(val.NAME1.toUpperCase())
            });
        }
        else if (PFCcount > 0) {
            cat = JSON.parse(localStorage.getItem("PFCategory"))

            cat = cat.filter((x) => x.checked == true)
            console.log("cat", cat);
            cat.forEach((val) => {
                CattreeSelected.push(val.FIELDNAME)
            });
        }
        if (PFMcont > 0) {
            mfg = CookieService.getLocalStorageValues("PFMFG")

            //mfg = mfg.filter((x) => x.checked == true)
            console.log("mfg", mfg);
            mfg.forEach((val) => {
                ManfNameSelected.push(val.MFG_ID)
            });
        }

        /*****END*************** */

        console.log(QS_srcs)
        this.setState({ SearchKeyWord: QS_srcs })
        let SearchBO = {
            Session_USERID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            CurrentPage_URL: "/SDIXZEUS/searchResults",
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_SearchQuery: QS_srcs,
            Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
            SearchValue: QS_srcs,
            Query_SITE: "",
            Query_USERID: this.state.Login_UserId,
            Query_Key: QS_srcs,
            Query_Opt: "",
            chbCat: true,
            chbNonCat: true,
            Catagorylist: CattreeSelected,//CatagoryList,	
            Make: Make != null ? Make : "",
            Model: Model != null ? Model : "",
            AssetId: AssetId,
            Quantity: "",
            SupplierIdList: SupplierSelected,
            ManufacturerList: ManfNameSelected,
            WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "", //WAL-767 -Aparna
            /*[12/24/21, PC_SC_06], Priyanka D//Passing the Location value */
            /*Location: CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("LOCATION").substring(0, 2) : "",*/
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 -Vishwa S
            FavYourCatg: "",
            Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
            SOURCE: "WEB",
            IsSupplierSearch: true,
            IsPickupSupplier: localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false,
            IsImageSearch: imagesearch,
            Files: FilePath,
            ImgByteCode: "",
            ImageName: FileName,
            SearchType: CookieService.getLocalStorageValues("SearchType") === "Sup P.#" ? "supplier part #" : CookieService.getLocalStorageValues("SearchType") === "MFG P.#" ? "manufacturer part #" : "all",
            UserId: this.state.Login_UserId,
            ProblemCodeDescription: CookieService.getLocalStorageValues("ProblemCodeDescription") ? CookieService.getLocalStorageValues("ProblemCodeDescription") : "",
            IsProblemCodeSearch: CookieService.getLocalStorageValues("IsProblemCodeSearch") ? CookieService.getLocalStorageValues("IsProblemCodeSearch") : false,
            // Files: ImageURL
        }
        SearchResultsAction.GetpageLoad(SearchBO)
        //WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna 
        let autoCompleteDataRes = []
        let locsugg = []
        let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
        console.log("Fav_Item_Cat", suggestionsStr)
        if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
            suggestionsStr.forEach((sugg, index) => {
                autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
            });
        }



        let locSubCat = []
        let locSubCatSGG = []
        let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
        console.log("Fav_Item_SubCat", subcatsuggestion)
        if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
            subcatsuggestion.forEach((sugg, index) => {
                //WW-516_PC_04  (9/30/2022)-Aparna
                if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                    locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                }

            });
        }
        if (locSubCat.length > 0) {
            locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.label != null && t.label != " ")) === i)

        }
        console.log("locSubCat", locSubCat)
        console.log("locSubCatSGG", locSubCatSGG)
        this.setState({ autocompleteData: autoCompleteDataRes, SupplierChecked: SuppNameSelected, Manuchecked: ManfNameSelected, subCategory: locSubCatSGG });

    }
    //WW-368_SuggestionCat_for_searchresult_PC_03 -Aparna
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    //WW-368_SuggestionCat_for_searchresult_PC_03 -Aparna
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }

    bindCat = () => {
        const {t}=this.props
        let locCat = []
        let locCatSGG = []
        let result = [];
        let FavYourCatg = this.state.FavYourCatg
        if (FavYourCatg != undefined && FavYourCatg != "" && FavYourCatg != null) {
            FavYourCatg = this.state.FavYourCatg.toUpperCase()
        }
        let catsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
        console.log("Fav_Item_SubCat", catsuggestion)
        if (catsuggestion != null && catsuggestion != "" && catsuggestion != undefined) {
            catsuggestion.forEach((sugg, index) => {
                //WW-516_PC_04  (9/30/2022)-Aparna
                if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                    locCat.push({ label: sugg.ISA_FAVS_CATEGORY.toUpperCase(), value: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                }

            });
        }
        if (locCat.length > 0) {
            locCatSGG = locCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.label != null && t.label != " ")) === i)
            locCatSGG = locCatSGG.sort((a, b) =>
                a.value > b.value ? 1 : -1,
            );
        }
        if (locCatSGG != undefined && locCatSGG != null) {
            if (locCatSGG.length != 0) {
                result = locCatSGG.filter(name => name.label.toUpperCase().includes(FavYourCatg))

            }
        }

        return (
            <Autocomplete
                getItemValue={this.getItemValue}
                items={result}
                renderItem={this.renderItem}
                value={this.state.FavYourCatg}
                onChange={e => this.onChange(e, "Cat")}
                onSelect={e => this.onSelect(e, "Cat")}
                inputProps={{ placeholder: t("Search"), className: "form-control float-left" }}
                maxLength="40"
            />);
    }
    //WW-368_SuggestionCat_for_searchresult_PC_03 -Aparna
    onSelect(val, name) {
        let result = []
        let locSubCatSGG = this.getCategory()
        if (name == "Cat") {
            if (val != "") {
                locSubCatSGG.forEach((x, i) => {
                    if (val == x.category) {
                        result.push({ label: x.value, value: x.value })
                    }
                }
                )
            }
            this.setState({
                FavYourCatg: val, subCategoryResults: result, CategoryErr: false, subCategory: locSubCatSGG
            });
        }
        else {
            this.setState({
                FavSubCategory: val, SubCategoryErr: false
            });
        }

    }
    getCategory = () => {
        let result = [];
        let locSubCat = [];
        let locSubCatSGG = []
        let locCat = []
        let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
        console.log("Fav_Item_SubCat", subcatsuggestion)
        if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
            subcatsuggestion.forEach((sugg, index) => {
                //WW-516_PC_04  (9/30/2022)-Aparna
                if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                    locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                }

            });
        }
        if (locSubCat.length > 0) {
            locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.category === v.category && t.label != null && t.label != " ")) === i)
            locSubCatSGG = locSubCatSGG.sort((a, b) =>
                a.value > b.value ? 1 : -1,
            );
        }
        return locSubCatSGG;

    }
    //WW-368_SuggestionCat_for_searchresult_PC_03 -Aparna
    onChange = (e, name) => {
        let val = e.target.value.toUpperCase()
        let len = e.target.value;
        let result = [];
        let subcatresult = [];
        let locSubCat = [];
        let locSubCatSGG = this.getCategory()
        //WW-516_PC_19
        //1/25/2023, WW-542, Dhevanesam R
        let re = /^[a-zA-Z0-9_-\s\x20 &, :;=?@#|'<>.{}"*()%!`%^$+~[/\]\\]+$/;
        if (val === '' || re.test(val)) {
            if (name == "Cat") {
                if (e.target.value == "") {
                    //let result = this.state.autocompleteItemData.filter(name => name.label.toUpperCase().includes(val))

                    this.setState({
                        FavYourCatg: e.target.value, autocompleteItemDataRstl: this.state.autocompleteItemData, subCategoryResults: []
                    });
                }
                else if (len.length <= 40) {
                    if (locSubCatSGG != undefined && locSubCatSGG != null) {
                        if (locSubCatSGG.length != 0) {
                            result = locSubCatSGG.filter(name => name.label.toUpperCase().includes(val))
                            console.log("yourcat autocomplete", result)
                        }
                    }
                    if (e.target.value != "") {
                        locSubCatSGG.forEach((x, i) => {
                            if (e.target.value.toUpperCase() == x.category) {
                                subcatresult.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                    }
                    //let result = this.state.autocompleteItemData.filter(name => name.label.toUpperCase().includes(val))
                    this.setState({
                        FavYourCatg: e.target.value, autocompleteItemDataRstl: result, subCategoryResults: subcatresult, CategoryErr: false, autocompleteItemData: locSubCatSGG
                    });

                }
            }
            else {
                if (e.target.value == "") {
                    //let result = this.state.subCategory.filter(name => name.label.toUpperCase().includes(val))
                    if (this.state.FavYourCatg != "") {
                        locSubCatSGG.forEach((x, i) => {
                            if (this.state.FavYourCatg.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }
                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result
                    });
                }
                else if (len.length <= 40) {
                    if (this.state.FavYourCatg != "") {
                        locSubCatSGG.forEach((x, i) => {
                            if (this.state.FavYourCatg.toUpperCase() == x.category) {
                                result.push({ label: x.value, value: x.value })
                            }
                        }
                        )
                        result = result.filter(name => name.label.toUpperCase().includes(val))
                    }

                    this.setState({
                        FavSubCategory: e.target.value, subCategoryResults: result, SubCategoryErr: false, subCategory: locSubCatSGG
                    });
                }
            }
        }
        /**
         * Handle the remote request with the current text !
         */

    }

    BuildSearchResults = () => {

        let PageLaod_Data = JSON.parse(SearchResultsStore.SearchresultList);
        console.log("PageLaod_Data", PageLaod_Data)
        let Favsub = []
        {/**A1QA-131PC_02 Users Without WO Should Not Be Able To See Inventory Items -Aparna*/ }
        if (this.state.FavoritesSubMenu != null && this.state.FavoritesSubMenu != undefined && this.state.FavoritesSubMenu.length > 0) {
            Favsub = this.state.FavoritesSubMenu
        }
        else {
            Favsub = PageLaod_Data.FavSubMenu;
        }
        let checkqty = false
        let Favmenu = PageLaod_Data.FavMenu;
        let showpaginationL = false

        let TradeTree = PageLaod_Data.TradeCatalogList;
        let TradeValue = []
        let Searchdata = PageLaod_Data.SearchItemTable;
        let ManufacturerPartsList = []
        if (PageLaod_Data.Matching_Part_Details != undefined && PageLaod_Data.Matching_Part_Details != null) {
            ManufacturerPartsList = PageLaod_Data.Matching_Part_Details;
            // localStorage.setItem("Manufacturer_part_details", ManufacturerPartsList);

        }
        //if (reuse) {
        //    Searchdata=this.state.PageLoadSearchResults
        //}
        let EquParts;
        //[11/30/22], Bug - 2933 - To check undefined or null condition for search item not available, Dhevanesam R

        if (Searchdata != undefined && Searchdata != null) {
            EquParts = Searchdata.Equvialent_partno;
            Searchdata.forEach((value, index) => {
                value.IsQtyChanged = false;
                //Minimum Order Quantity Issue - WW-243, A1QA-136 - Deepthi N H
                value.EditedQuantity = false;
                value.QuantityOrdered = value.min_order_qty;
            });

            //let locqty = [];
            //Searchdata.forEach((x) => {
            //    x.QuantityOrdered = x.min_order_qty;
            //    locqty.push(x);
            //})
            //Searchdata = locqty;

            let locsearch = []
            Searchdata.forEach((x) => {
                //if (this.state.WorkOrderNo == "") {
                //    if (x.vendor_id != "W999999999") {
                //        locsearch.push(x);
                //    }
                //}
                if (x.ItemPrice.toUpperCase() != "PRICE ON REQUEST" || x.IsKit == true) {
                    locsearch.push(x);
                }


            })
            Searchdata = locsearch
        }
        /*******NEW********************wal-158*******/
        let filtermap = Searchdata;
        let pickupcheck = localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false
        let inventorycheck = localStorage.getItem("inventorycheck") != null ? JSON.parse(localStorage.getItem("inventorycheck")) : false
        let truckCheck = localStorage.getItem("truckStockcheck") != null && localStorage.getItem("truckStockcheck") != undefined ? JSON.parse(localStorage.getItem("truckStockcheck")) : false //CPW-114_PC_03 -Aparna
        console.log("search page pickupcheck", pickupcheck);

        if (pickupcheck) {
            let loc = [];
            let vndr = JSON.parse(localStorage.getItem("PickupVendor"))
            if (Searchdata != undefined && Searchdata != null) {
                Searchdata.forEach((x) => {
                    vndr.forEach((y) => {
                        if (x.vendor_id == y.VENDOR_ID) {
                            loc.push(x);
                        }
                    })

                })
                console.log("loc", loc);
                Searchdata = loc;
            }
            Searchdata = Searchdata.filter((val) => val.shipping_specs == 'PUO ONLY' || val.shipping_specs == 'PU ONLY')

        } else {
            Searchdata = Searchdata ? Searchdata.filter((val) => val.shipping_specs == 'NA' || val.shipping_specs == 'PU ONLY'): []
        }
        //CPW-114_PC_03 -Aparna
        if (inventorycheck || truckCheck) {
            let loc = [];
            let vndr = "W999999999";
            let ManuSupfil = [];
            let filteredArray = this.state.FilterValuedata;
            filteredArray.forEach((line) => {
                if (inventorycheck) {
                    if (line.hasBenItemVal == "W" || line.hasBenItemVal == "C") {
                        ManuSupfil.push(line);

                    }
                }
                if (truckCheck) {
                    if (line.hasBenItemVal == "T") {
                        ManuSupfil.push(line);

                    }
                }
                //if (line.vendor_id == vndr) {
                //    ManuSupfil.push(line);
                //}

            });
            if (Searchdata != undefined && Searchdata != null) {
                Searchdata.forEach((x) => {
                    if (x.vendor_id == vndr) {
                        if (inventorycheck) {
                            if (x.InventoryType == "w" || x.InventoryType == "c" || x.InventoryType == null || x.InventoryType == "") {
                                loc.push(x);
                            }
                        }
                        if (truckCheck) {
                            if (x.InventoryType == "t") {
                                loc.push(x);
                            }
                        }

                    }
                })
                Searchdata = loc;
            }
            //Searchdata = ManuSupfil; 
        }
        console.log("filtermap", filtermap);
        /****END**********/
        let AttributeValue = []
        let Attributelist = PageLaod_Data.Session_dctm;
        let ManuValue = []
        let Manufacturelist = PageLaod_Data.ManufactureTable;
        let ShowDidyoumean = false; //***NEW***added***(1/27/2021)****
        let Didyoumean = PageLaod_Data.DidyoumeanTable
        let DidyouMean1L = Didyoumean[0].Did_you_Mean == null || Didyoumean[0].Did_you_Mean == "" || Didyoumean[0].Did_you_Mean == undefined ? "" : Didyoumean[0].Did_you_Mean
        let DidyouMean2L = Didyoumean[1].Did_you_Mean == null || Didyoumean[1].Did_you_Mean == "" || Didyoumean[1].Did_you_Mean == undefined ? "" : Didyoumean[1].Did_you_Mean
        let DidyouMean3L = Didyoumean[2].Did_you_Mean == null || Didyoumean[2].Did_you_Mean == "" || Didyoumean[2].Did_you_Mean == undefined ? "" : Didyoumean[2].Did_you_Mean
        if (DidyouMean1L != "" || DidyouMean2L != "" || DidyouMean3L != "") {
            ShowDidyoumean = true
        }
        let DescriptionPref = CookieService.getLocalStorageValues("Session_PROD_DESCPREFERENCE");
        let DescripType = this.state.DescriptionType
        if (DescriptionPref == "P") {
            CatalogType = false
            ClientType = true
            //document.getElementById("ClientDesp").checked = true
            //document.getElementById("CatalogDesp").checked = false
            DescripType = 0
        }
        else if (DescriptionPref == "C") {
            CatalogType = true
            ClientType = false
            //document.getElementById("ClientDesp").checked = true
            //document.getElementById("CatalogDesp").checked = false
            DescripType = 1
        }
        //else {
        //    CatalogType = CatalogType
        //    ClientType = false
        //    //document.getElementById("ClientDesp").checked = false
        //    //document.getElementById("CatalogDesp").checked = true
        //}

        console.log("DescriptionPref", DescriptionPref)
        console.log("desctype", CatalogType, ClientType)
        let UpdateSession = PageLaod_Data.Update_Session;
        let GridArrResponse = []
        if (Searchdata) {
            let itemperpageval = this.state.itemperpage
            let filterSearchData = Searchdata.filter((val, idx) => idx < itemperpageval) //14/08/2023, 3966 - number of items should be selected dropdown value, Divis Kumar R K
            let PageCountList = this.getpagecount(Searchdata.length, itemperpageval)//14/08/2023, 3966 - number of pages should be selected dropdown value, Divis Kumar R K
            if (PageCountList > 1) {
                showpaginationL = true
            }
            if (TradeTree != null) {
                TradeTree.map((val, index) => {
                    let ParentNode = {
                        value: val.FIELDNAME,
                        label: val.DESCR,
                        key: val.FIELDNAME,
                        disabled: false
                    }
                    TradeValue.push(ParentNode)
                });
            }
            let ManfNameSelected = [];
            if (Manufacturelist != null) {
                Manufacturelist.map((val, index) => {
                    /****NEW****wal-158*** the val.manufacturer column in the table is changed to mfg_std */
                    //let ParentNode = {
                    //    value: val.manufacturer,
                    //    label: val.manufacturer
                    //}
                    let ind = Searchdata.findIndex(t => (t.mfg_std.trim().toUpperCase() === val.mfg_std.trim().toUpperCase()));
                    if (ind != -1) {
                        let ParentNode = {
                            value: val.mfg_std.toUpperCase(),
                            label: val.mfg_std.toUpperCase()
                        }
                        let mfg = CookieService.getLocalStorageValues("PFMFG")
                        let manind = mfg.findIndex(t => (t.MFG_ID.trim().toUpperCase() === val.mfg_std.trim().toUpperCase()));
                        if (manind != -1) {
                            ManfNameSelected.push(val.mfg_std.toUpperCase())
                        }
                        /**END***/
                        ManuValue.push(ParentNode)
                    }

                });
            }
            //**new***wal-158
            console.log("ManuValue", ManuValue);
            console.log("Manufacturelist", Manufacturelist);
            if (Attributelist != null) {
                let AttributeDropdown = Attributelist
                let filteredAttributes = AttributeDropdown.filter((v, i, a) => a.findIndex(t => (t.AttributeName === v.AttributeName)) === i)

                let sortedAttribute = filteredAttributes.sort(function (a, b) {
                    if (a.AttributeName > b.AttributeName) {
                        return 1;
                    }
                    if (b.AttributeName > a.AttributeName) {
                        return -1;
                    }
                    return 0;
                });
                console.log("Attributelist", sortedAttribute)
                console.log("filteredAttributes", filteredAttributes)
                console.log("Attributelist", Attributelist)
                sortedAttribute.map((val, index) => {

                    let childAttribut = Attributelist.filter((item, index) => item.AttributeName == val.AttributeName);
                    let DuplicateAttribute = childAttribut.filter((v, i, a) => a.findIndex(t => (t.AttributeValue === v.AttributeValue)) === i)
                    let ChildrenValue = []
                    if (DuplicateAttribute.length > 0) {
                        DuplicateAttribute.map((value, index) => {
                            let localArray = {
                                value: value.AttributeValue + "|" + value.AttributeName,
                                label: value.AttributeValue,
                                Parent: value.AttributeName
                            }
                            ChildrenValue.push(localArray)
                        })
                        let ParentNode = {
                            value: val.AttributeName,
                            label: val.AttributeName,
                            Parent: "0",
                            children: ChildrenValue,
                            showCheckbox: false,
                        }
                        AttributeValue.push(ParentNode)
                    }

                });
            }
            console.log("AttributeValue", AttributeValue)
            let SupplierFIlterValue = []
            if (Searchdata) {
                let SortedSupplier = []
                if (Searchdata.length > 0) {
                    SortedSupplier = Searchdata.filter((v, i, a) => a.findIndex(t => (t.supplierName.trim().toUpperCase() === v.supplierName.trim().toUpperCase())) === i)
                }
                SortedSupplier = SortedSupplier.sort(function (a, b) {
                    if (a.supplierName > b.supplierName) {
                        return 1;
                    }
                    if (b.supplierName > a.supplierName) {
                        return -1;
                    }
                    return 0;
                });
                SortedSupplier.map((val, index) => {
                    let SupplierName = {
                        value: val.supplierName,
                        label: val.supplierName
                    }
                    SupplierFIlterValue.push(SupplierName)
                })
            }
            //[12/30/21], PC_SR_14, WW-286, Dhevanesam R

            GridArrResponse = Searchdata;
            GridArrResponse.forEach((value, index) => {

                value.hasCoreCharge = false;
                if (GridArrResponse[index].core_charges == "\\N" || GridArrResponse[index].core_charges == "" || GridArrResponse[index].core_charges == undefined) {
                }
                else {
                    if (GridArrResponse[index].core_charges.length > 0) {

                        value.hasCoreCharge = true;
                    }
                }

            });
            GridArrResponse.forEach((value, index) => {
                value.hasBenItemVal = "";

            });
            console.log("GridArrResponse-search", GridArrResponse);

            let warehouse_item = Searchdata.filter((x) => x.vendor_id == "W999999999")
            let loacalloc = JSON.parse(localStorage.getItem("StoreValue"))

            if (warehouse_item.length > 0) {
                checkqty = true;
            }
            if (checkqty) {
                let itemids = []
                warehouse_item.map((val, index) => {

                    itemids.push(val.clientPartNumber)
                });
                //if (warehouse_item.length == Searchdata.length) {
                //    localStorage.setItem("inventorycheck", true);
                //}
                //else {
                //    localStorage.setItem("inventorycheck", false);
                //}
                if (itemids.length > 0) {

                    let BO = {
                        shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//loacalloc, //WAL-767-Aparna
                        supplier_part_number: itemids,
                        User_Id: CookieService.getLocalStorageValues("Session_UserID")
                    }

                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ShoppingCartAction.WarehouseQTYCheck(BO)
                }

            }
            let PFSupCount = "";
            let PFMfgCount = "";
            let SupplierCheckedVal = [];
            if (JSON.parse(localStorage.getItem("PFSuppCount")) > 0) {
                PFSupCount = SupplierFIlterValue.length;
                //[11/25/22], Bug - 2931 - To To check the supplier checkbixes which are already selected in the home page, Dhevanesam R                
                if (SupplierFIlterValue.length > 0) {
                    SupplierFIlterValue.map((val, index) => {
                        SupplierCheckedVal.push(val.value)
                    });
                }
            }
            if (JSON.parse(CookieService.getLocalStorageValues("PFMFGCount")) == 0 || CookieService.getLocalStorageValues("PFMFGCount") == "") {
                PFMfgCount = 0;
            }
            if (ManfNameSelected.length > 0) {
                PFMfgCount = ManfNameSelected.length
            }

            //let MFGChecked = [];
            //if (this.state.Manuchecked.length > 0) {
            //    this.state.Manuchecked.map((manval, index) => {
            //        let a = manval;
            //        let ind = ManuValue.findIndex(t => (t.value.trim().toUpperCase() === manval.trim().toUpperCase()));
            //        if (ind == -1) {
            //            PFMfgCount = PFMfgCount - 1;
            //        }
            //        else {
            //            MFGChecked.push(manval);
            //        }
            //       })
            //}
            //WW-383_PC_03 (5/10/2022)-Aparna

            //WW-1378_WW-1382 Update the value of fromSearch - Nandhini L
            fromSearch = CookieService.getLocalStorageValues("fromSearch")
            let pageNo = fromSearch ? CookieService.getLocalStorageValues("pageNo") : 1
            let itemperpage = fromSearch ? CookieService.getLocalStorageValues("itemperpage") : 10
            let GridType = fromSearch ? CookieService.getLocalStorageValues("GridType") : 1
            DescripType = fromSearch ? CookieService.getLocalStorageValues("DescriptionType") : DescripType
            if (DescripType != 1) {
                CatalogType = false
                ClientType = true
            }
            else {
                CatalogType = true
                ClientType = false
            }

            //WW-1374 problem code search - Nandhini L 
            if (CookieService.getLocalStorageValues("IsProblemCodeSearch")) {
                if (Searchdata) {
                    CookieService.updateLocalStorageValues("IsProblemCodeSearch", true);
                    this.setState({ IsProblemCodeSearch: true })
                }
                else {
                    this.setState({ IsProblemCodeSearch: false })
                    CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);
                }
            }

            this.setState({
                PageLoadSearchResults: GridArrResponse, FilteredSearchResults: filterSearchData, FilterValuedata: Searchdata,
                FavoritesSubMenu: Favsub, ManufactureTable: Manufacturelist, pageCount: PageCountList, TotalItemCount: Searchdata.length, CatalogTree: TradeValue, pageload: 1,
                PageloadcatalogTree: TradeTree, filterAppliedType: "All", Manufacture: ManuValue, AttributeTree: AttributeValue, SupplierTree: SupplierFIlterValue,
                showpagination: showpaginationL, DescriptionType: DescripType, DidyouMean1: DidyouMean1L, DidyouMean2: DidyouMean2L, DidyouMean2: DidyouMean3L, ShowDidyoumean: ShowDidyoumean, WarehousecheckBOX: checkqty, //WW-383_PC_03
                suppliercount: PFSupCount, mfgcount: PFMfgCount, ManufacturerPartsList: ManufacturerPartsList, SupplierChecked: SupplierCheckedVal, Manuchecked: ManfNameSelected, equParts: EquParts,
                pageNo: pageNo, GridType: GridType, itemperpage: itemperpage
            })


            //WW-1378_WW-1382 Update the page type - Nandhini L
            if (fromSearch) {
                this.handlePageClick()
                fromSearch = false
                CookieService.updateLocalStorageValues("fromSearch", "");
            }
        }
        else {
            this.setState({
                DidyouMean1: DidyouMean1L, DidyouMean2: DidyouMean2L, DidyouMean2: DidyouMean3L, ShowDidyoumean: ShowDidyoumean, PageLoadSearchResults: GridArrResponse
            })
        }
        //debugger
        //WW-243 (12/3/2021)
        let sup = [];
        let mau = [];
        let che = [];
        let ex = [];
        let bool = false;
        let att = []
        const queryParams = new URLSearchParams(window.location.search)
        const QS_src = queryParams.get('key');


        if (CookieService.getLocalStorageValues("QS_src") == QS_src) {
            //[11/18/22], PC_WW_469_05, Dhevanesam R
            let CountFilterMfg = ""
            let CountFilterAtt = ""
            let CountFilterSup = ""
            if (CookieService.getLocalStorageValues("Suppliertree")?.length > 0) {
                CountFilterSup = CookieService.getLocalStorageValues("Suppliertree").length;
            }
            if (CookieService.getLocalStorageValues("Suppliertree") != null && CookieService.getLocalStorageValues("Suppliertree") != undefined && CookieService.getLocalStorageValues("Suppliertree") != "") {
                sup = CookieService.getLocalStorageValues("Suppliertree")
                this.setState({ SupplierChecked: CookieService.getLocalStorageValues("Suppliertree"), suppliercount: CountFilterSup, selectallSup: CookieService.getLocalStorageValues("selectallSup") })
                bool = true;
            }
            if (CookieService.getLocalStorageValues("Manutree")?.length > 0) {
                CountFilterMfg = CookieService.getLocalStorageValues("Manutree").length;
            }
            if (CookieService.getLocalStorageValues("Manutree") != null && CookieService.getLocalStorageValues("Manutree") != undefined && CookieService.getLocalStorageValues("Manutree") != "") {
                mau = CookieService.getLocalStorageValues("Manutree")
                this.setState({ Manuchecked: CookieService.getLocalStorageValues("Manutree"), mfgcount: CountFilterMfg, selectallMfg: CookieService.getLocalStorageValues("selectallMfg") })
                bool = true;
            }
            if (CookieService.getLocalStorageValues("searchTb") != null && CookieService.getLocalStorageValues("searchTb") != undefined && CookieService.getLocalStorageValues("searchTb") != "") {
                $('#searchTb').val(CookieService.getLocalStorageValues("searchTb"))
                bool = true;
            }
            if (CookieService.getLocalStorageValues("AtttreeEx") != null && CookieService.getLocalStorageValues("AtttreeEx") != undefined && CookieService.getLocalStorageValues("AtttreeEx") != "") {
                this.setState({ expanded: CookieService.getLocalStorageValues("AtttreeEx") })
                bool = true;
            }
            if (CookieService.getLocalStorageValues("AtttreeCh") != null && CookieService.getLocalStorageValues("AtttreeCh") != undefined && CookieService.getLocalStorageValues("AtttreeCh") != "") {
                this.setState({ checked: CookieService.getLocalStorageValues("AtttreeCh") })
                bool = true;
            }
            if (CookieService.getLocalStorageValues("att")?.length > 0) {
                CountFilterAtt = CookieService.getLocalStorageValues("att").length;
            }
            if (CookieService.getLocalStorageValues("att") != null && CookieService.getLocalStorageValues("att") != undefined && CookieService.getLocalStorageValues("att") != "") {
                this.setState({ Attrichecked: CookieService.getLocalStorageValues("att"), attricount: CountFilterAtt, selectallAtt: CookieService.getLocalStorageValues("selectallAtt") })
                att = CookieService.getLocalStorageValues("att")
                bool = true;
            }

            if (bool == true) {
                let tb = $('#searchTb').val() == undefined ? "" : $('#searchTb').val()
                this.ApplyFilter(tb, "", mau, att, false, sup)
            }
        }
        //debugger
        if (!checkqty) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        //WW-1231 to display the Wo parts popup on WO validation -Vishwa S
        if (this.state.isPageloadValidWO == false && this.state.isValidWO && this.state.WO_Parts.length > 0) {
            $('#WO_Parts_Popup').modal('show');
        }

    }
    warehouseqtyresponse = () => {
        //   $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);
        let local = Workorderresponse.Table
        let st = []
        //WW-243_PC_AddingItemToCart_01 (it will append the hasBenItemVal to the inventory item)(5/6/2022) -Aparna
        let searchTotalResult = this.state.PageLoadSearchResults
        let GridArrResponse = searchTotalResult.filter((x) => x.vendor_id == "W999999999")
        if (local.length > 0) {

            local.forEach((x) => {

                if (x.QTY != null) {
                    //st = x.QTY.includes("^T");
                    //if (st) {
                    //    GridArrResponse.forEach((value, index) => {                            
                    //        if (GridArrResponse[index].clientPartNumber == x.INV_ITEM_ID) {
                    //            value.hasCribItem = true;
                    //        }
                    //        else {
                    //            value.hasCribItem = false;
                    //        }

                    //    });
                    //}
                    console.log("hasBenItemVal", x.QTY.slice(-1))
                    GridArrResponse.forEach((value, index) => {
                        if (GridArrResponse[index].clientPartNumber == x.INV_ITEM_ID) {
                            value.hasBenItemVal = x.QTY.slice(-1);
                        } //else {
                        //    value.hasBenItemVal ="W"
                        //}

                    });
                }
            })
        }
        let PageLaod_Data = JSON.parse(SearchResultsStore.SearchresultList);
        PageLaod_Data.SearchItemTable = searchTotalResult
        console.log("searchTotalResult", searchTotalResult.filter((x) => x.vendor_id == "W999999999"))
        this.setState({
            PageLoadSearchResults: searchTotalResult, //GridArrResponse
        })

        //WW-1378_WW-1382 Update the page type - Nandhini L
        if (fromSearch) {
            this.handlePageClick()
            fromSearch = false
            CookieService.updateLocalStorageValues("fromSearch", "");
        }

        console.log("GridArrResponseCrib", GridArrResponse)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    /******NEW*****CheaperOption API call****/
    CheckCheaperItem = (e, value, qt) => {
        //debugger
        const {t} = this.props
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        CookieService.updateLocalStorageValues("Search_AttributeName", value.AttributeName);
        /*[04/01/22,PC_DF,WW-371],Replace spl character in Attribute value for Door Priyanka D */
        CookieService.updateLocalStorageValues("Search_AttributeValue", value.AttributeValue.replace(" ", "-"));
        CookieService.updateLocalStorageValues("QTY_KENSTAN", value.QuantityOrdered);
        CookieService.updateLocalStorageValues("QTY", value.QuantityOrdered);

        let DoorItem = "";
        /*[04/26/22,PC_A1QA-168_01], Priyanka D */
        let EnersysItem = "";
        CartStorage.forEach((val) => {
            if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath != " ") {
                if (val.FilePath[0].includes('Enersys')) {
                    EnersysItem = EnersysItem.concat(val.Itemid);
                } else if (val.FilePath != null && val.FilePath[0].includes('Doorform')) {
                    DoorItem = DoorItem.concat(val.Itemid);
                }
            }
        });
        console.log("directcart", value);
        let Index = this.state.PageLoadSearchResults.findIndex(x => x.clientPartNumber == value.clientPartNumber && x.manfPartNumber == value.manfPartNumber && x.mfg_std == value.mfg_std && x.ItemPrice == value.ItemPrice && x.supplierName.trim().toUpperCase() == value.supplierName.trim().toUpperCase());
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let val = (parseInt(this.state.QuantityOrdered) / parseInt(PageLSearchResults[Index].min_order_qty));
        if (parseInt(PageLSearchResults[Index].QuantityOrdered) < parseInt(PageLSearchResults[Index].min_order_qty)) {
            alert(t('Quantity Entered Is Below The Minimum Order Quantity'));
            return;
        }
        else if ((parseInt(PageLSearchResults[Index].QuantityOrdered) % parseInt(PageLSearchResults[Index].min_order_qty)) != 0) {
            alert(t('Entered Quantity Does Not Match the Minimum Order Quantity Sequence'));
            return;
        }
        if (CookieService.getLocalStorageValues("EnersysList") != undefined) {
            let arr = CookieService.getLocalStorageValues("EnersysList")
            if ((CookieService.getLocalStorageValues("EnersysList").indexOf(PageLSearchResults[Index].clientPartNumber) > -1)) {
                alert(t("This Enersys Item is already added in the cart"))
                return
            }
            /*[04/26/22,PC_A1QA-168_02], Priyanka D */
        } else if (EnersysItem.indexOf(PageLSearchResults[Index].clientPartNumber) > -1) {
            alert(t("This Enersys Item is already added in the cart. Please go to cart to increase quantity !"))
            return
        }
        /*[04/01/22,PC_DF,WW-371],Restricting adding same Door item to cart Priyanka D */

        else if (CookieService.getLocalStorageValues("Doorlist") != undefined) {
            let arr = CookieService.getLocalStorageValues("Doorlist")
            if ((CookieService.getLocalStorageValues("Doorlist").indexOf(PageLSearchResults[Index].clientPartNumber) > -1) || DoorItem.indexOf(PageLSearchResults[Index].clientPartNumber) > -1) {
                alert(t("This Door Item is already added in the cart. Please go to cart to increase quantity !"))
                return
            }
        } else if (DoorItem.indexOf(PageLSearchResults[Index].clientPartNumber) > -1) {
            alert(t("This Door Item is already added in the cart. Please go to cart to increase quantity !"))
            return
        }



        if (value.IsQtyChanged == false) {
            this.AddOrder(e, Index, value.clientPartNumber, value.manfPartNumber, value.mfg_std, value.ItemPrice, value.supplierName, "", "", "")
            //[12/30/21], PC_SR_14, WW-286, Dhevanesam R
            if (this.state.showCoreCharge == true) {
                this.state.showCoreCharge = false
                this.setState({ SelectedItemForCheaper: value });
                return;
            }
        }
        else {
            //debugger
            if (PageLSearchResults[Index].hasCoreCharge == true && this.state.showCoreCharge == false && this.state.addtocartCoreCharge == false) {
                $('#CoreChargePopUp').modal('show')
                this.state.showCoreCharge = true;
                this.setState({ index1CC: Index, catalogIdCC: value.clientPartNumber, ManuPartNumCC: value.manfPartNumber, manufacturerCC: value.mfg_std, ItemPriceCC: value.ItemPrice, suppliernameCC: value.supplierName, QtyChCoreCharge: true, SelectedItemForCheaper: value });
                return;
            }
        }
        if (value.QuantityOrdered == "" || value.QuantityOrdered == null) {
            //NEWCHANGE
            if (value.vendor_id == "W999999999") {
                if (this.state.WorkOrderNo == "") {
                    $('#WorkOrder').modal('show');
                    return;
                }
                else {
                    alert("Enter Quantity for at least one item")
                    return
                }
            }
            else {
                alert("Enter Quantity for at least one item")
                return;
            }
        }
        else {
            if (value.vendor_id == "W999999999") {
                if (parseInt(qt) < value.QuantityOrdered) {
                    let str = 'Available quantity for this item: ' + qt
                    alert(str);
                    return;
                }
            }
        }
        //CookieService.updateLocalStorageValues("Search_AttributeName", value.AttributeName);
        ///*[04/01/22,PC_DF,WW-371],Replace spl character in Attribute value for Door Priyanka D */
        //CookieService.updateLocalStorageValues("Search_AttributeValue", value.AttributeValue.replace(" ", "-"));
        //CookieService.updateLocalStorageValues("QTY_KENSTAN", value.QuantityOrdered);
        //CookieService.updateLocalStorageValues("QTY", value.QuantityOrdered);

        if (value.manfPartNumber != "" && value.manfPartNumber != null && value.manfPartNumber != undefined) {
            let mfgpart = value.manfPartNumber
            if (value.mfg_part_std != "" && value.mfg_part_std != null && value.mfg_part_std != undefined && value.mfg_part_std != "NA") {
                mfgpart = value.mfg_part_std
                this.state.mfgpartstboolean = true
            }
            //WW-362 (CLONE - Remove Cheaper Item Pop Up) - Deepthi
            //let SearchBO = {
            //    Session_USERID: this.state.Login_UserId,
            //    Session_BUSUNIT: this.state.Login_UserBU,
            //    AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            //    AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            //    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            //    Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            //    CurrentPage_URL: "/SDIXZEUS/searchResults",
            //    Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            //    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            //    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            //    Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            //    Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            //    Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            //    Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            //    Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            //    Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            //    Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            //    Session_SearchQuery: value.manfPartNumber,
            //    Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
            //    SearchValue: mfgpart,//WW-536
            //    Query_SITE: "",
            //    Query_USERID: this.state.Login_UserId,
            //    Query_Key: mfgpart, //WW-536
            //    Query_Opt: "",
            //    chbCat: true,
            //    chbNonCat: true,
            //    Catagorylist: [],//CatagoryList,
            //    Make: "",
            //    Model: "",
            //    AssetId: "",
            //    SupplierIdList: [],
            //    ManufacturerList: []
            //}
            //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //SearchResultsAction.GetCheaperItem(SearchBO)
            let imagePath = "";
            if (value.ThumbnailImagefile) {
                value.Image = value.ThumbnailImagefile.replace('\\', '/');
                if (value.Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = value.ThumbnailImagefile;
                } else {
                    imagePath = value.ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? value.ThumbnailImagefile.substring(value.ThumbnailImagefile.lastIndexOf("/") + 1, value.ThumbnailImagefile.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
            this.setState({ SelectedItemForCheaper: value, SelectedItemForCheaperImg: imagePath });
            //WW-362 (CLONE - Remove Cheaper Item Pop Up) - Deepthi
            this.Addtocart(value.clientPartNumber, value.manfPartNumber, "1", "", value)
            //WW-243_AddToCart_PC_02 adding parameter ->value (3/7/2022)-Aparna
        }
    }
    CheckCheaperItemResponse = () => {

        let PageLaod_Data = JSON.parse(SearchResultsStore.SearchresultList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Searchdata = PageLaod_Data.SearchItemTable;
        let filtercheaper = [];
        let cheaperitem = [];
        //*[12/13/21, PC_SRC_01, WW-275- Gettting Min & Max qty to display in cheaper popup & added inc, decr in popup, Poornima S]
        //*[02/26/21, WW-359- Declare MinOrdQty and MaxOrdQty, Priyanka D]
        let MinOrdQty = 1;
        let MaxOrdQty = 1;
        //*[[02/26/21,WW-359-Assign the value of min and Max Ord qty only if the Searchdata is not null,Priyanka D]
        if (Searchdata[0] != null && Searchdata[0] != undefined && Searchdata[0] != "") {
            MinOrdQty = "" + Searchdata[0].min_order_qty;
            MaxOrdQty = "" + (parseInt(Searchdata[0].min_order_qty) + parseInt(Searchdata[0].min_order_qty));
        }


        if (Searchdata != null && Searchdata != undefined && Searchdata != "") {
            //Searchdata = Searchdata.filter((x) => x.mfg_part_std == this.state.SelectedItemForCheaper.mfg_part_std)//WAL-536
            if (this.state.SelectedItemForCheaper.vendor_id == "W999999999") {
                if (this.state.mfgpartstboolean) {
                    Searchdata = Searchdata = Searchdata.filter((x) => x.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.vendor_id == "W999999999")//WW-536 //*[11/24/21, PC_SR_01, WW-275- Added Manufacturer in condition to check correct cheaper item, Poornima S]

                }
                else {
                    Searchdata = Searchdata = Searchdata.filter((x) => x.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.vendor_id == "W999999999")//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]

                }
            }
            if (Searchdata.length > 1) {
                if (this.state.mfgpartstboolean) {
                    Searchdata.filter((item) => item.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (item.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(item.manufacturer.toUpperCase())) && parseFloat(item.ItemPrice) < parseFloat(this.state.SelectedItemForCheaper.ItemPrice))//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]
                        .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
                        .map((item, index) =>
                            cheaperitem.push(item)
                        );
                }
                else {
                    Searchdata.filter((item) => item.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") && (item.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(item.manufacturer.toUpperCase())) && parseFloat(item.ItemPrice) < parseFloat(this.state.SelectedItemForCheaper.ItemPrice))//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]
                        .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
                        .map((item, index) =>
                            cheaperitem.push(item)
                        );
                }

                if (cheaperitem.length > 0) {
                    let indexval = -1
                    let cheapindexval = -1
                    if (this.state.mfgpartstboolean) {
                        indexval = this.state.PageLoadSearchResults.findIndex(x => x.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.mfg_std == this.state.SelectedItemForCheaper.mfg_std);//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]
                        //*[12/13/21, PC_SRC_02, WW-275- Getting cheaper item's index to reset its min ord qty after adding to cart, Poornima S]
                        cheapindexval = this.state.PageLoadSearchResults.findIndex(x => x.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.mfg_std == this.state.SelectedItemForCheaper.mfg_std && parseFloat(x.ItemPrice) < parseFloat(this.state.SelectedItemForCheaper.ItemPrice));//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]
                    }
                    else {
                        indexval = this.state.PageLoadSearchResults.findIndex(x => x.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.manfPartNumber.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.mfg_std == this.state.SelectedItemForCheaper.mfg_std);//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]
                        cheapindexval = this.state.PageLoadSearchResults.findIndex(x => x.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") == this.state.SelectedItemForCheaper.mfg_part_std.replace(/[^a-zA-Z0-9 ]/g, "") && (x.manufacturer.toUpperCase().includes(this.state.SelectedItemForCheaper.manufacturer.toUpperCase()) || this.state.SelectedItemForCheaper.manufacturer.toUpperCase().includes(x.manufacturer.toUpperCase())) && x.mfg_std == this.state.SelectedItemForCheaper.mfg_std && parseFloat(x.ItemPrice) < parseFloat(this.state.SelectedItemForCheaper.ItemPrice))//WW-536 //*[11/24/21, PC_SR_01, WW-275, Poornima S]
                    }

                    if (indexval != -1) {

                        this.CheaperPopup(Searchdata[0].manfPartNumber, Searchdata[0].ItemPrice, indexval, cheaperitem, MinOrdQty, MaxOrdQty, cheapindexval)
                    }


                }
                else {

                    this.Addtocart(this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.manfPartNumber, "1", "")
                }
            }
            else {

                this.Addtocart(this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.manfPartNumber, "1", "")
            }
        } else {

            this.Addtocart(this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.manfPartNumber, "1", "")
        }

    }
    handleEditQuantity = (e, index, value) => {

        let val = e.target.value;
        if (val.length > 5) {
            return;
        }
        let PageLSearchResults = this.state.PageLoadSearchResults
        let FilterdValue = this.state.FilteredSearchResults
        let Index = PageLSearchResults.findIndex(x => x.clientPartNumber == value.clientPartNumber && x.manfPartNumber == value.manfPartNumber && x.mfg_std == value.mfg_std && x.supplierName.trim().toUpperCase() == value.supplierName.trim().toUpperCase());
        let Index2 = FilterdValue.findIndex(x => x.clientPartNumber == value.clientPartNumber && x.manfPartNumber == value.manfPartNumber && x.mfg_std == value.mfg_std && x.supplierName.trim().toUpperCase() == value.supplierName.trim().toUpperCase());
        let re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            let QtyToBeChanged = e.target.value;
            PageLSearchResults[Index].QuantityOrdered = QtyToBeChanged
            FilterdValue[Index2].QuantityOrdered = QtyToBeChanged
            this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
        }

    }
    //[2/22/2023, Bug - 3127, Dhevanesam R]
    keyPressQTY(e) {
        const invalidChars = [".", "-", "+", "e"];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };
    //WW-1284 quantity increased drastically 1/27/2024 
    handleMinOrderQuantity = (e, index, value) => {
        const {t}=this.props
        let QtyToBeChanged = "";
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        let Index = PageLSearchResults.findIndex(x => x.clientPartNumber == value.clientPartNumber && x.manfPartNumber == value.manfPartNumber && x.mfg_std == value.mfg_std && x.supplierName.trim().toUpperCase() == value.supplierName.trim().toUpperCase());
        let Index2 = FilterdValue.findIndex(x => x.clientPartNumber == value.clientPartNumber && x.manfPartNumber == value.manfPartNumber && x.mfg_std == value.mfg_std && x.supplierName.trim().toUpperCase() == value.supplierName.trim().toUpperCase());

        if (Index2 === -1 || Index === -1) return; // Early return if index is not found

        let qtycheck = parseInt(FilterdValue[Index2].QuantityOrdered, 10); // Ensure this is a number
        let minOrderQty = parseInt(FilterdValue[Index2].min_order_qty, 10); // Ensure this is a number

        if (isNaN(qtycheck)) {
            qtycheck = 0; // Default to 0 if qtycheck is not a number
        }

        if (isNaN(minOrderQty)) {
            minOrderQty = 1; // Default to 1 if min_order_qty is not a number
        }

        // Check if the quantity ordered is not a valid number or less than min_order_qty
        if ((qtycheck % minOrderQty) !== 0 || FilterdValue[Index2].QuantityOrdered === "" || FilterdValue[Index2].QuantityOrdered === null) {
            if (qtycheck < minOrderQty || FilterdValue[Index2].QuantityOrdered === "" || FilterdValue[Index2].QuantityOrdered === null) {
                QtyToBeChanged = minOrderQty; // Set to minimum order quantity if invalid
                PageLSearchResults[Index].QuantityOrdered = QtyToBeChanged;
                FilterdValue[Index2].QuantityOrdered = QtyToBeChanged;
                this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
            } else if (qtycheck > minOrderQty) {
                let IsValidqty = false;
                let MinQty = minOrderQty;
                while (!IsValidqty) {
                    if (MinQty < qtycheck) {
                        MinQty = MinQty + minOrderQty;
                    } else if (MinQty > qtycheck) {
                        let diff = MinQty - qtycheck;
                        if (diff <= minOrderQty) {
                            QtyToBeChanged = MinQty;
                            PageLSearchResults[Index].QuantityOrdered = QtyToBeChanged;
                            FilterdValue[Index2].QuantityOrdered = QtyToBeChanged;
                            this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
                            IsValidqty = true;
                        }
                    }
                }
            }
        } else {
            // If the quantity is valid
            if (e.target.value === "+") {
                // Increment by the min_order_qty value
                QtyToBeChanged = qtycheck + minOrderQty;
                PageLSearchResults[Index].QuantityOrdered = QtyToBeChanged;
                FilterdValue[Index2].QuantityOrdered = QtyToBeChanged;
                this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
            } else if (e.target.value === "-") {
                // Decrement by the min_order_qty value
                QtyToBeChanged = qtycheck - minOrderQty;
                if (QtyToBeChanged < minOrderQty) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t('You cannot decrement Below the minimum order quantity')
                    });
                    return;
                } else if (QtyToBeChanged === 0 || QtyToBeChanged === "0") {
                    e.preventDefault();
                } else {
                    PageLSearchResults[Index].QuantityOrdered = QtyToBeChanged;
                    FilterdValue[Index2].QuantityOrdered = QtyToBeChanged;
                    this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
                }
            }
        }
    };


    /*****************END****/
    bindSearchResults = (value) => {

        return (value != null && value != '' && value != {} && value != undefined ? this.state.FilteredSearchResults.filter(item => item.manfPartNumber == value.manfPartNumber && item.ItemPrice == value.ItemPrice) : this.state.FilteredSearchResults).map((val, indexval) => {
            let pickupcheck = localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false
            let invenchk = localStorage.getItem("inventorycheck") != null ? JSON.parse(localStorage.getItem("inventorycheck")) : false
            console.log("search page pickupcheck", pickupcheck);
            let ItemIndex = indexval
            let disablein = false
            let qt = []
            console.log('searchresultvalue', value)
            if (val.actual_qty != null) {
                qt = val.actual_qty.split('^')[0];
            }
            let MinOrdQty = "" + val.min_order_qty;
            let MaxOrdQty = "" + (parseInt(val.min_order_qty) + parseInt(val.min_order_qty));
            //if (this.state.WorkOrderNo == "") {
            //    if (val.vendor_id == "W999999999") {
            //        disablein = true
            //        //$('#in' + ItemIndex).attr("readonly", true);
            //        $('#in' + ItemIndex).addClass("disabledbutton");
            //        // document.getElementById("in" + ItemIndex).disabled = false;
            //    }
            //}


            let imagePath = "";
            let imgUrl = SDIConstants.urlRegex;
            let ThumbnailImagefile = val.ThumbnailImagefile.split("|")

            if (ThumbnailImagefile[0]) {
                val.Image = ThumbnailImagefile[0].replace('\\', '/');
                if (val.Image.toLowerCase().indexOf("http") >= 0) {
                    let trimUrl = val.Image.replace(/\s/g, '')
                    //pc-WW-1088-01 S.Sanjay 07/09/2024
                    //if (imgUrl.test(trimUrl)) {
                    imagePath = ThumbnailImagefile[0];
                    //}
                    // else {
                    //  imagePath = `/Images/noimage_new.png`;
                    //}
                } else {
                    imagePath = ThumbnailImagefile[0].lastIndexOf(`/`) >= 0 ? ThumbnailImagefile[0].substring(ThumbnailImagefile[0].lastIndexOf("/") + 1, ThumbnailImagefile[0].length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
            if (imagePath.includes("NoImageAvailable")) {
                imagePath = `/Images/noimage_new.png`;
            }

            let FavItem = false
            let favsubitem = []
            let mfg = ""
            favsubitem = this.state.FavoritesSubMenu
            if (favsubitem.length > 0) {
                mfg = val.manufacturer;
                mfg = mfg.replace("&apos;", "'");
                //9/6/22, Bug - 2565, To show fav item as fav in search, Dhevanesam R] 
                FavItem = favsubitem.filter((item, index) => item.CUSTOMERITEMID == val.clientPartNumber && (item.MANUFACTURER.includes("&apos;") ? item.MANUFACTURER.replace("&apos;", "'") : item.MANUFACTURER.toUpperCase() == mfg.toUpperCase() && item.SUPPLIER_ID == val.vendor_id)).length > 0 ? true : false;
            }
            let IsKitCore = false
            let QuantityOnhand = ""
            let QuantityOnhandL = []
            if (val.CustomColQOH != null) {
                let valqtg = val.CustomColQOH
                QuantityOnhandL = valqtg.match(/[a-zA-Z0-9]/);
                //console.log("QuantityOnhand", QuantityOnhandL)
                if (QuantityOnhandL != null && QuantityOnhandL != undefined) {
                    if (QuantityOnhandL.length > 0) {
                        if (QuantityOnhandL[0] != "Y" && QuantityOnhandL[0] != "y" && QuantityOnhandL[0] == 0) {
                            QuantityOnhand = ""
                            //console.log("QuantityOnhand588758", QuantityOnhand)
                        }
                        else {
                            QuantityOnhand = QuantityOnhandL[0]
                        }
                    }
                }
            }
            let cheaperitem = [];
            if (value == null || value == undefined) {
                if (val.IsKit == false) {
                    if (val.ItemPrice == ' ' || val.ItemPrice == '' || val.ItemPrice == null) { val.ItemPrice = 0; }
                    this.state.FilteredSearchResults.filter((item) => item.manfPartNumber == val.manfPartNumber && item.ItemPrice < val.ItemPrice)
                        .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
                        .map((item, index) =>
                            cheaperitem.push(item)
                        );
                }
            }

            //let message = this.calcWorkingDays(val.ships_within)//*****NEW****wal-158(GetShipwithin()-->calcWorkingDays)


            const style = {
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                },
            }
            let descriptionvalue = val.longdescriptionone != "\N" || val.longdescriptionone != null ? val.longdescriptionone.trim() : "NA"
            let ClientDescription = val.clientDesc != null || val.clientDesc != " " ? val.clientDesc.trim() : "NA" //**client description change Pavithra R 3/22/2023

            console.log("hasBenItemVal2", val.hasBenItemVal)
            console.log("FilteredSearchResults1", this.state.FilteredSearchResults)
            let attributeValue = val.AttributeValue.replace(/\s/g, "")
            let attributeName = val.AttributeName != null && val.AttributeName != undefined ? val.AttributeName.toUpperCase().includes('FORM') ? false : true : true
            return (

                <div className="col-lg-3 col-md-6 col-sm-6 col-12 product-section" key={indexval}>
                    <div className="gridlayout-widget">
                        <div className="col-12 order-summary-image category-search-image" >
                            <button className="border image-background px-0" onClick={() => this.showitemdetails(qt, indexval, val.clientPartNumber, val.ItemAttributeId, val.mfg_std, val.vendor_id, FavItem)}>



                                <img
                                    id={"image" + ItemIndex}
                                    src={imagePath}
                                    width={219}
                                    height={267}
                                    style={style.image}
                                    onError={(e) => { e.target.src = "/Images/noimage_new.png" }}
                                />
                            </button>
                            {/*<img src={imagePath} alt="fav_item" onClick={() => this.showitemdetails(indexval, val.clientPartNumber, val.ItemAttributeId, FavItem)} />*/}

                            {/*[04/01/22,PC_DF,WW-371],Restricting adding same Door item to cart Priyanka D */}
                            {attributeName || val.InventoryType == "t" ? <> {/**CPW-167_PC_01*/}
                                {attributeValue.trim().indexOf('KENSTAN') > -1 || attributeValue.trim().indexOf('BATTERY') > -1 || attributeValue.trim().indexOf('CHARGER') > -1 || attributeValue.trim().indexOf('DOORSINTERIORNON-FIRERATE') > -1 || val.InventoryType == "t" ? null :
                                    <div className="fav-item-maintenance-icon gridfav-icon">
                                        <input type="checkbox" className="checknow" id={ItemIndex} checked={FavItem} onChange={(e) => this.BindFavForm(e, FavItem, val.ItemAttributeId, "No")} data-backdrop="static" data-keyboard="false" />
                                        <label htmlFor={ItemIndex}>
                                            <svg className="heart-svg " viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg" data-backdrop="static" data-keyboard="false">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                }</> : null}
                        </div>
                        {/*//[2/16/22], WW-330, Dhevanesam R*/}
                        {/*15/08/23, 3967 - Style change for ItemID and WarehouseIcon, Vishwa S]*/}
                        <span className="col-12 GridView-ItemID-WIcon-style float-left">
                            <a href="#" className="float-left GridView-ItemID-style itemHyperlink" onClick={(e) => this.showitemdetails(qt, indexval, val.clientPartNumber, val.ItemAttributeId, val.manufacturer, val.vendor_id, FavItem, e)}>{val.manfPartNumber}</a>
                            {(QuantityOnhand == "" || QuantityOnhand == 0 || QuantityOnhand == "0") ? <span className="info-container ml-2">
                                {/*  <img className="info-searchpage my-3" src="Images/info-icon.png" />
                                <span className="Grid-info-icon">{message.Sampletest}</span> */}
                                {val.hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : val.hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : val.vendor_id == "W999999999" ? < span class="i-circlegrid">w</span> : null}                            </span> : null}
                        </span>
                        {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                        <label className="col-md-12 item-details-value">
                            {this.state.DescriptionType == "1" ? descriptionvalue.trim() : ClientDescription.trim()}
                        </label>
                        {/*{QuantityOnhand != "" && QuantityOnhand != "0" && QuantityOnhand != "0" ? <span className="col-md-12 qty-count float-left">Qty Available:<span className="mx-1">{QuantityOnhand}</span></span> : null}*/}

                        <span className="col-md-12  float-left item-detail-suppleir font-Change " >Manufacturer:<span className="mx-1 item-detail-suppleir gridsearch item-details-value" style={{ float: 'none' }}>{val.manufacturer}</span></span>
                        <span className="col-md-12  float-left item-detail-suppleir font-Change">Supplier:<span className="mx-1 item-detail-suppleir gridsearch item-details-value" style={{ float: 'none' }}>{val.supplierName}</span></span>
                        {/*{val.vendor_id == "W999999999" && qt != [] ? <span className="col-md-12 qty-count float-left item-detail-suppleir">qty available:<span className="mx-1 item-detail-suppleir">{qt}</span></span> : null}*/}
                        <span className="col-md-12  float-left item-detail-suppleir font-Change" >Supplier Part#:<span className="mx-1 item-detail-suppleir gridsearch item-details-value" style={{ float: 'none' }}>{val.clientPartNumber}</span></span>
                        {/*{val.vendor_id == "W999999999" && qt != [] ? <span className="col-md-12 qty-count float-left item-detail-suppleir">qty available:<span className="mx-1 item-detail-suppleir">{qt}</span></span> : null}*/}
                        {val.Equvialent_partno != "\\N" && val.Equvialent_partno != [] && val.Equvialent_partno != "[]" && val.Equvialent_partno != "\N" && val.Equvialent_partno != "" && val.Equvialent_partno != " " && val.Equvialent_partno != undefined && val.Equvialent_partno != null ?
                            <span className="col-md-12  float-left mt-1 font-Change">Equivalent Parts: <span className="mx-1 gridsearch " >
                                {this.bindEquParts(val.Equvialent_partno, ItemIndex)}
                            </span></span> : null}
                        <div className="col-md-12 float-left pb-2">
                            <div className="float-left">
                                <span className="float-left my-2 search-rate d-none">{val.ItemPrice}</span>
                            </div>
                            <div className="float-left my-2">
                                <span className="float-left mt-2 price-calc">Qty:</span>
                                {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                <div class="quantity buttons_added" disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER"} style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                    {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                    <input type="button" value="-" class="minus" disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER"} onClick={(e) => this.handleMinOrderQuantity(e, indexval, val)} style={{ "backgroundColor": "white" }} />
                                    {/*[2/22/2023, Bug - 3127, Dhevanesam R]*/}
                                    <input type="number" step={` ${MinOrdQty}`} disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER"} class="minus" min={` ${MinOrdQty}`} max={` ${MaxOrdQty}`} name="quantity" value={val.QuantityOrdered} title="Qty" maxLength={5} pattern="" inputmode="" id={`quantityid${indexval}`} onChange={(e) => this.handleEditQuantity(e, indexval, val)} onKeyDown={(e) => this.keyPressQTY(e)} style={{ "width": "73%", "borderLeft": "0" }} />
                                    <input type="button" value="+" class="plus" disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER" || val.QuantityOrdered == 99999} onClick={(e) => this.handleMinOrderQuantity(e, indexval, val)} style={{ "backgroundColor": "white" }} />  {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}
                                </div>

                                {/*<a className="search-results-cart-button float-left ml-2" disabled={disablein} id={`in${ItemIndex}`} onClick={(e) => this.TradeServiceAddClick(e, val, FavItem)} ><span className="cart-icon" /></a>*/}
                                {/*CPW-167_PC_01 */}
                                <button className={`btn catagoryFilterBtn ${val.InventoryType == "t" ? 'disabled' : ''}`} type="button" style={{ "fontWeight": "bold", "marginTop": "2px" }}

                                    onClick={(e) => {
                                        if (cartpickUp == true || val.cart_bypass == "Y") {
                                            this.AddToCartOrFavClick("Add To Cart", val, indexval, false, this.state.ReasonType, this.state.Comments)
                                        }
                                        else {
                                            this.TradeServiceAddClick(e, val, FavItem, IsKitCore);
                                        }

                                    }}><img src="Images/cart-icon-black.svg" ></img>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            )

        });

    }

    bindSearchResultsGridView = (value) => {

        return (value != null && value != '' && value != {} && value != undefined ? this.state.FilteredSearchResults.filter(item => item.manfPartNumber == value.manfPartNumber && item.ItemPrice == value.ItemPrice) : this.state.FilteredSearchResults).map((val, indexval) => {
            //let filtind = (this.state.pageNo * parseInt($('#itemperpagecount').val())) - parseInt($('#itemperpagecount').val());
            let ItemIndex = indexval
            let disablein = false
            let qt = ""
            if (val.actual_qty != null) {
                qt = val.actual_qty.split('^')[0];
            }
            let MinOrdQty = "" + val.min_order_qty;
            let MaxOrdQty = "" + (parseInt(val.min_order_qty) + parseInt(val.min_order_qty));
            if (this.state.WorkOrderNo == "") {
                if (val.vendor_id == "W999999999") {
                    disablein = true;
                    //$('#in' + ItemIndex).attr("readonly", true);
                    //$('#in' + ItemIndex).addClass("disabledbutton");
                    // document.getElementById("in" + ItemIndex).disabled = false;
                }
            }
            let imgUrl = SDIConstants.urlRegex;
            let imagePath = "";
            let ThumbnailImagefile = val.ThumbnailImagefile.split("|")

            if (ThumbnailImagefile[0]) {
                val.Image = ThumbnailImagefile[0].replace('\\', '/');
                if (val.Image.toLowerCase().indexOf("http") >= 0) {
                    let imgNameWithExtension = val.Image.substring(val.Image.lastIndexOf('/') + 1);
                    let imgExtension = imgNameWithExtension.substring(imgNameWithExtension.lastIndexOf('.'));
                    //pc-WW-1088-02 S.Sanjay 07/09/2024

                    // if (imgUrl.test(imgExtension)) {
                    imagePath = ThumbnailImagefile[0];
                    //}
                    // else {
                    //    // imagePath = `/Images/noimage_new.png`;
                    //}
                } else {
                    imagePath = ThumbnailImagefile[0].lastIndexOf(`/`) >= 0 ? ThumbnailImagefile[0].substring(ThumbnailImagefile[0].lastIndexOf("/") + 1, ThumbnailImagefile[0].length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
            if (imagePath.includes("NoImageAvailable")) {
                imagePath = `/Images/noimage_new.png`;
            }

            let QuantityOnhand = ""
            let QuantityOnhandL = []
            if (val.CustomColQOH != null) {
                let valqtg = val.CustomColQOH
                QuantityOnhandL = valqtg.match(/[a-zA-Z0-9]/);
                //console.log("QuantityOnhand", QuantityOnhandL)
                if (QuantityOnhandL != null && QuantityOnhandL != undefined) {
                    if (QuantityOnhandL.length > 0) {
                        if (QuantityOnhandL[0] != "Y" && QuantityOnhandL[0] != "y" && QuantityOnhandL[0] == 0) {
                            QuantityOnhand = ""
                            //console.log("QuantityOnhand588758", QuantityOnhand)
                        }
                        else {
                            QuantityOnhand = QuantityOnhandL[0]
                        }
                    }
                }
            }
            let cheaperitem = [];
            if (value == null || value == undefined) {
                if (val.IsKit == false) {
                    if (val.ItemPrice == ' ' || val.ItemPrice == '' || val.ItemPrice == null) { val.ItemPrice = 0; }
                    this.state.FilteredSearchResults.filter((item) => item.manfPartNumber == val.manfPartNumber && item.ItemPrice < val.ItemPrice)
                        .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
                        .map((item, index) =>
                            cheaperitem.push(item)
                        );
                }
            }
            let vendorlogo = ""
            if (val.vendor_id) {
                let vendorvalue = val.vendor_id + ".png"
                vendorlogo = `/Images/${vendorvalue}`;
            }
            let FavItem = false
            let favsubitem = []
            favsubitem = this.state.FavoritesSubMenu
            let mfg = ""
            if (favsubitem) {// exception handleing
                if (favsubitem.length > 0) {
                    mfg = val.manufacturer;
                    mfg = mfg.replace("&apos;", "'");
                    //9/6/22, Bug - 2565, To show fav item as fav in search, Dhevanesam R] 
                    FavItem = favsubitem.filter((item, index) => item.CUSTOMERITEMID == val.clientPartNumber && (item.MANUFACTURER.includes("&apos;") ? item.MANUFACTURER.replace("&apos;", "'") : item.MANUFACTURER.toUpperCase() == mfg.toUpperCase() && item.SUPPLIER_ID == val.vendor_id)).length > 0 ? true : false;

                }
            }
            //  console.error("favsubitem", favsubitem)
            console.log("mfg", mfg)
            console.log("mfg", val.manufacturer)
            let message = this.calcWorkingDays(val.ships_within)//*****NEW****wal-158(GetShipwithin()-->calcWorkingDays)
            let DeliversBy = message.Sampletest.substring(12)
            const style = {
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                    cursor: 'pointer'
                },
            }
            let descriptionvalue = val.longdescriptionone != "\N" || val.longdescriptionone != null ? val.longdescriptionone.trim() : "NA"
            let ClientDescription = val.clientDesc != null || val.clientDesc != " " ? val.clientDesc.trim() : "NA"
            console.log("hasBenItemVal1", imagePath)
            console.log("FilteredSearchResults2", this.state.FilteredSearchResults)
            let attributeValue = val.AttributeValue.replace(/\s/g, "")
            let IsKitCore = false;
            let attributeName = val.AttributeName != null && val.AttributeName != undefined ? val.AttributeName.toUpperCase().includes('FORM') ? false : true : true
            return (
                <div className="row mb-1 py-2" key={indexval}>

                    <div className="col-md-4 col-lg-2 order-summary-image category-search-image  mb-2" onClick={() => this.showitemdetails(qt, indexval, val.clientPartNumber, val.ItemAttributeId, val.manufacturer, val.vendor_id, FavItem)}>
                        <div className="row justify-content-center">
                            <img
                                id={`${val.clientPartNumber}imgid`}
                                src={imagePath}
                                width={150}
                                height={150}
                                style={style.image}
                                onError={(e) => { e.target.src = "/Images/noimage_new.png" }}
                            />
                        </div>
                        {/*<img src={imagePath} alt="fav_item" onClick={() => this.showitemdetails(indexval, val.clientPartNumber, val.ItemAttributeId, FavItem)} />*/}
                    </div>
                    <div className="col-md-8 col-lg-10 mobile-catalog mobile-catalog-search">
                        <div className="row">
                            <div className="col-md-12 col-lg-9 p-0 search-content" >
                                <div className="row">
                                    <div className="col-md-12 float-left content-spacing">
                                        <span className="fav-item-title">
                                            <a href="#" className="float-left mt-2 category-id category-search-id itemHyperlink" id={`${val.clientPartNumber}${val.manfPartNumber}id`} onClick={(e) => this.showitemdetails(qt, indexval, val.clientPartNumber, val.ItemAttributeId, val.manufacturer, val.vendor_id, FavItem, e)}>{val.manfPartNumber}</a>
                                        </span>
                                        {/*[04/01/22,PC_DF,WW-371],Restricting adding same Door item to fav Priyanka D */}
                                        {/*CPW-167_PC_02*/}
                                        {attributeName || val.InventoryType == "t" ? <>{attributeValue.trim().indexOf('KENSTAN') > -1 || attributeValue.trim().indexOf('BATTERY') > -1 || attributeValue.trim().indexOf('CHARGER') > -1 || attributeValue.trim().indexOf('DOORSINTERIORNON-FIRERATE') > -1 || val.InventoryType == "t" ? null :
                                            <div className="fav-item-maintenance-icon">
                                                <input type="checkbox" className="checknow" id={ItemIndex} checked={FavItem} onChange={(e) => this.BindFavForm(e, FavItem, val.ItemAttributeId, "No")} data-backdrop="static" data-keyboard="false" />
                                                <label htmlFor={ItemIndex} className="mb-0">
                                                    <svg className="heart-svg heart-icon " viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg" data-backdrop="static" data-keyboard="false">
                                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </label>
                                                {/*{val.hasBenItemVal.toUpperCase() == "C" ? <span class="i-circlegridBlue">C</span> : val.vendor_id == "W999999999" ? <span class="i-circlegrid">w</span> : null}*/}
                                            </div>
                                        }</> : null}
                                        {/*//[2/16/22], WW-330, Dhevanesam R*/}
                                        <div className="fav-item-maintenance-icon">
                                            {val.hasBenItemVal.toUpperCase() == "C" ? <span class="i-circlegridBlue" style={{ top: "2px" }}>C</span> : val.hasBenItemVal.toUpperCase() == "T" ? <span class="i-circlegridYellow" style={{ top: "2px" }}>T</span> : val.vendor_id == "W999999999" ? <span class="i-circlegrid" style={{ top: "2px" }}>w</span> : null}
                                        </div>


                                    </div>
                                    {/* <label id={`${val.clientPartNumber}${val.manfPartNumber}Descid`} className="col-md-12 col-sm-12 col-12 item-details-value content-width">
                                        {this.state.DescriptionType == "1" ? descriptionvalue.trim() : "NA"}
                                    </label>*/}

                                    <div className="col-md-12 float-left">
                                        <div className="row">
                                            <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content">
                                                <label className="catalog-label float-left"><Trans>Manufacturer</Trans><span>:</span></label>
                                                <label className="item-details-value ml-2 Search-Manufac-label textwrapfrsearch searchSupplierwidth" id={`${val.clientPartNumber}${val.manfPartNumber}MFGid`} data-toggle="tooltip" title={val.manufacturer}>{val.manufacturer}</label>

                                            </div>
                                            <div className="col-md-12 col-lg-9 col-12 col-sm-12 fav-maintence custom-search-content">
                                                <label className="catalog-label float-left"><Trans>Supplier</Trans><span>:</span></label>
                                                <label className="item-details-value ml-2 Search-Manufac-label text-nowrap searchSupplierwidth" id={`${val.clientPartNumber}${val.manfPartNumber}supplierid`} data-toggle="tooltip" title={val.supplierName}>{val.supplierName}</label>
                                            </div>
                                            <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content">
                                                <label className="catalog-label float-left"><Trans>Supplier Part#</Trans><span>:</span></label>
                                                <label className="item-details-value ml-2 Search-Manufac-label text-nowrap searchSupplierwidth" id={`${val.clientPartNumber}${val.manfPartNumber}supplierid`} data-toggle="tooltip" title={val.clientPartNumber}>{val.clientPartNumber}</label>
                                            </div>
                                            {/*15/08/23, 3967 - Style change for the span tag containing the Description text, Vishwa S]*/}
                                            {/*18/10/23, PC_WW_850_04, PC_WW_850_05 - To expand and collapse the Description, Vishwa S]*/}
                                            {this.state.DescriptionType == "1" ?
                                                <div id={`${val.clientPartNumber}${val.manfPartNumber}Descid`} className="col-md-12 col-lg-12 col-12 col-sm-12 fav-maintence custom-search-content">
                                                    <label className="catalog-label float-left mb-0" style={{ wordBreak: 'break-all' }}><Trans>Description</Trans><span>:</span></label>
                                                    {descriptionvalue.length > 80 && !this.state.IsDotClickIndex.includes(((this.state.pageNo - 1) * this.state.itemperpage) + ItemIndex) ?
                                                        <React.Fragment><span className="item-details-value ml-2 searchSupplierwidth">{`${descriptionvalue.substring(0, 80)}`}
                                                            <span className="expand-collapse-style" onClick={(e) => this.handleDotclick(ItemIndex, 'More')} >...More</span></span> </React.Fragment>
                                                        : descriptionvalue.length > 80 ? <React.Fragment> <span className="item-details-value ml-2 searchSupplierwidth">{`${descriptionvalue}`} <span className="expand-collapse-style" onClick={(e) => this.handleDotclick(ItemIndex, 'Less')} > Less</span></span> </React.Fragment> : <span className="item-details-value ml-2 searchSupplierwidth">{`${descriptionvalue}`}</span>}
                                                </div> :

                                                <div id={`${val.clientPartNumber}${val.manfPartNumber}Descid`} className="col-md-12 col-lg-12 col-12 col-sm-12 fav-maintence custom-search-content">
                                                    <label className="catalog-label float-left mb-0"><Trans>Description</Trans><span>:</span></label>
                                                    {ClientDescription.length > 80 && !this.state.IsDotClickIndex.includes(((this.state.pageNo - 1) * this.state.itemperpage) + ItemIndex) ?
                                                        <React.Fragment><span className="item-details-value ml-2 searchSupplierwidth"> {`${ClientDescription.substring(0, 80)}`}
                                                            <span className="expand-collapse-style" onClick={(e) => this.handleDotclick(ItemIndex, 'More')} >...More</span></span> </React.Fragment>
                                                        : ClientDescription.length > 80 ? <React.Fragment> <span className="item-details-value ml-2 searchSupplierwidth"> {`${ClientDescription}`} <span className="expand-collapse-style" onClick={(e) => this.handleDotclick(ItemIndex, 'Less')} > Less</span></span> </React.Fragment> : <span className="item-details-value ml-2 searchSupplierwidth">{`${ClientDescription}`}</span>}
                                                </div>}

                                            {val.Equvialent_partno != "\\N" && val.Equvialent_partno != "\N" && val.Equvialent_partno != [] && val.Equvialent_partno != "[]" && val.Equvialent_partno != "" && val.Equvialent_partno != " " && val.Equvialent_partno != undefined && val.Equvialent_partno != null ?
                                                <div className="col-12 col-sm-12 fav-maintence custom-search-content">
                                                    <label className="catalog-label float-left mt-1 mr-1 mb-0"><span><Trans>Equivalent Parts</Trans></span><span>:</span></label>
                                                    {this.bindEquParts(val.Equvialent_partno, ItemIndex)} </div> : null} {/*[30/10/23, PC_WW_850_07, Vishwa S]*/}
                                            {/*<div className="col-md-12 col-lg-4 fav-maintence custom-search-content">
                                                <label className="catalog-label float-none">UOM:</label>
                                                <label className="item-details-value  ml-2" id={`${val.clientPartNumber}${val.manfPartNumber}UOMid`}>{val.UOM}</label>
                                            </div>*/}


                                            {/*<div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content">

                                                <label className="catalog-label float-left"><span>MFG </span><Trans>part number</Trans><span>:</span></label>
                                                <label className="item-details-value  ml-2 Search-ManuPart-label" data-toggle="tooltip" id={`${val.clientPartNumber}${val.manfPartNumber}partNoid`} title={val.manfPartNumber}>{val.manfPartNumber}</label>

                                            </div>*/}
                                            {/*********NEW**wal-158*******/}
                                            {/*{message.Sampletest != "" && (QuantityOnhand == "" || QuantityOnhand == 0 || QuantityOnhand == "0") ?
                                                <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content ">
                                                    <label className="catalog-label float-none">{message.Sampletest}</label>

                                                </div> : null}*/}

                                            {/*******END**********/}


                                            {val.vendor_id == "W999999999" ? <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content">
                                                <label className="catalog-label float-left"><span>Qty </span><Trans>Available</Trans></label>
                                                <label className="item-details-value ml-2 Search-Manufac-label text-nowrap searchSupplierwidth">{qt != [] ? qt : "0"}</label>
                                            </div> : null}


                                            {/* <div className="col-md-12 col-lg-4 col-12 col-sm-12  fav-maintence custom-search-content">
                                                <label className="catalog-label float-left">Min Ord Qty:</label>
                                                <label className="item-details-value ml-2 Search-Manufac-label" data-toggle="tooltip" id={`${val.clientPartNumber}${val.manfPartNumber}minqtyid`} title={val.min_order_qty}>{val.min_order_qty}</label>
                                            </div>*/}
                                            {/* Show qty available even if it is 0- A1QA-206-Pavithra*/}
                                            {/*{val.vendor_id == "W999999999" ? <div className="col-md-3 fav-maintence custom-search-content">
                                                <label className="catalog-label float-none"><span>Qty </span><Trans>Available</Trans></label>
                                                <label className="item-details-value  ml-2">{qt != [] ? qt : "0"}</label>
                                            </div> : null}*/}

                                        </div>


                                    </div>

                                    {/* <div className="col-md-12 float-left custom-search-content ml-1">*/}
                                    {/* <div className="fav-maintence">
                                        <label className="catalog-label float-none">Supplier:</label>
                                        <label className="item-details-value  ml-2 card-product-add-cart-panel mr-2">{val.supplierName}</label>
                                        {/*{message.Sampletest != "" && (QuantityOnhand == "" || QuantityOnhand == 0 || QuantityOnhand == "0") ? <span className="info-container">
                                            <img className="info-searchpage" src="Images/info-icon.png" />
                                            <span className="info-content info-position">{message.Sampletest}</span>
                                        </span> : null}*/}

                                    {/*  </div>   */}


                                    {/*{val.vendor_id == "W999999999" && qt != [] ? <span className="col-md-12 qty-count float-left item-detail-suppleir">Qty Available:<span className="mx-1 item-detail-suppleir">{qt}</span></span> : null}*/}


                                    {/*  </div>*/}
                                    {/*<div className="col-md-12 float-left custom-search-content">

                                        {QuantityOnhand != "" && QuantityOnhand != 0 && QuantityOnhand != "0" ? <span className="qty-count"><span>Qty </span><Trans>Available</Trans><span className="mx-1">{QuantityOnhand}</span>
                                        </span> : null}

                                        {/*<span className="catalog-search-result catalog-search-result-sr">{val.CatlgOrNotCatlg == "NA" ? "SM" : "SR"}</span>*/}

                                    {/*<img className="vendor-logo-img" src={vendorlogo}/>*/}
                                    {/* </div>*/}
                                </div>
                            </div>
                            <div className=" col-md-12 col-lg-3 p-0 OSPD-prices">
                                <div className="float-right">
                                    {/* <div className="w-100 float-left">
                                        <div className="float-right">
                                            <span className="float-left my-2 search-rate">${val.ItemPrice}</span>
                                        </div>
                                    </div>*/}
                                    <div className="w-100 float-left ">
                                        <div className="align-items-center qty-alignment mt-3">
                                            <span className="float-left mt-2 price-calc"><Trans>Qty </Trans>:</span>
                                            <div class="quantity buttons_added" disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER"} style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                                <input type="button" value="-" class="minus" disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER"} onClick={(e) => this.handleMinOrderQuantity(e, indexval, val)} style={{ "backgroundColor": "white" }} />
                                                {/*[2/22/2023, Bug - 3127, Dhevanesam R]*/}
                                                <input type="number" step={` ${MinOrdQty}`} disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER"} class="minus" min={` ${MinOrdQty}`} max={` ${MaxOrdQty}`} name="quantity" value={val.QuantityOrdered} title="Qty" maxLength={5} pattern="" inputmode="" id={`quantityid${indexval}`} onChange={(e) => this.handleEditQuantity(e, indexval, val)} onKeyDown={(e) => this.keyPressQTY(e)} style={{ "width": "73%", "borderLeft": "0" }} />
                                                <input type="button" value="+" class="plus" disabled={val.AttributeValue.trim() == "BATTERY" || val.AttributeValue.trim() == "CHARGER" || val.QuantityOrdered == 99999} onClick={(e) => this.handleMinOrderQuantity(e, indexval, val)} style={{ "backgroundColor": "white" }} /> {/*18/08/2023, 4010 - disabled the + icon if the quantity is 99999 so that the user cant enter more than 5 digits, Divis Kumar R K*/}
                                            </div>
                                            {/*CPW-167_PC_02*/}
                                            <button className={`btn catagoryFilterBtn ${val.InventoryType == "t" ? 'disabled' : ''}`} type="button" style={{ "fontWeight": "bold" }} onClick={(e) => {

                                                if (cartpickUp == true || val.cart_bypass == "Y") {
                                                    this.AddToCartOrFavClick("Add To Cart", val, indexval, false, this.state.ReasonType, this.state.Comments);
                                                }
                                                else {
                                                    this.TradeServiceAddClick(e, val, FavItem, IsKitCore);
                                                }

                                            }}><img src="Images/cart-icon-black.svg" ></img>
                                            </button>
                                            {/* <input type="text" value={val.QuantityOrdered == null ? "" : val.QuantityOrdered} disabled={disablein} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.AddOrder(e, indexval, val.clientPartNumber, val.manfPartNumber, val.mfg_std, val.ItemPrice, val.supplierName, "")} />*/}
                                            {/* <a className="search-results-cart-button float-left ml-2" disabled={disablein} id={`in${ItemIndex}`} onClick={(e) => this.CheckCheaperItem(e, val, qt)}><span className="cart-icon" /></a>*/}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            )

        });

    }
    GetShipwithin = (shipwithin) => {

        let day = "5"
        let Sampletest = ""
        let symbol = "within"
        if (shipwithin != null && shipwithin != undefined) {
            let symbol1 = shipwithin.match(/[+-<>]/);

            let Number = shipwithin.match(/(\d+)/);
            if (symbol1 && Number) {
                if (Number.length > 0 && symbol1.length > 0) {
                    if (Number[0] != "0") {
                        day = Number[0]
                    }
                    if (symbol1[0] == ">" || symbol1[0] == "+") {
                        symbol = "after"
                    }
                    else if (symbol1[0] == "<" || symbol1[0] == "-") {
                        symbol = "within"
                    }
                    Sampletest = "Usually ships " + symbol + " " + day + " days"
                }
                else {
                    Sampletest = "Usually ships " + symbol + " " + day + " days"
                }
            }
            else {
                Sampletest = "Usually ships " + symbol + " " + day + " days"
            }
        }
        else {
            Sampletest = "Usually ships " + symbol + " " + day + " days"
        }
        return ({ Sampletest })
    }
    /****NEW**(catalog search)WAL-158***/
    calcWorkingDays(shipwithin) {

        let count = 0;
        let tomorrow = new Date()
        //[2/10/23, PC_WW-621_APP_01, Dhevanesam R]
        tomorrow.setDate(tomorrow.getDate() + 1); // to exclude today's date
        console.log("tomorrow's date", tomorrow)
        console.log("no.of days", shipwithin)
        while (count < shipwithin) {
            if (tomorrow.getDay() != 0 && tomorrow.getDay() != 6) // Skip weekends
            {
                count++;
            }
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            tomorrow.setDate(tomorrow.getDate() + 1);
        }
        //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
        tomorrow.setDate(tomorrow.getDate() - 1);
        let td = this.handledate(tomorrow);
        console.log("Ship by date", td)
        {/*[WW-458]Change Shipby to Delivers By-Priyanka D*/ }
        let Sampletest = "Delivers By " + td
        return ({ Sampletest })
    }
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    /*******END******/
    GridChange = (Type) => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let itempercurrent = this.state.itemperpage
        let itemperpageval = 10
        if (itempercurrent == 10 || itempercurrent == 12) {
            itemperpageval = Type == 0 ? 12 : 10
        }
        else if (itempercurrent == 20 || itempercurrent == 24) {
            itemperpageval = Type == 0 ? 24 : 20
        }
        else {
            itemperpageval = Type == 0 ? 60 : 50
        }
        let pagenum = this.state.pageNo
        let showpaginationL = false
        let PageLSearchResults = this.state.PageLoadSearchResults
        let FilterValuedataL = this.state.FilterValuedata
        let startpagecount = 0
        let PageCountList = 0
        startpagecount = (pagenum - 1) * itemperpageval
        let endcount = 0
        endcount = (pagenum * itemperpageval) - 1
        let filterSearchData = []
        let ItemTotalCOunt = 0
        let filterAppliedvalue = this.state.filterApplied
        if (filterAppliedvalue == 0) {
            filterSearchData = PageLSearchResults.filter((val, idx) => idx < itemperpageval)
            ItemTotalCOunt = PageLSearchResults.length
            PageCountList = this.getpagecount(ItemTotalCOunt, itemperpageval)
        }
        else {
            filterSearchData = FilterValuedataL.filter((val, idx) => idx < itemperpageval)
            ItemTotalCOunt = FilterValuedataL.length
            PageCountList = this.getpagecount(ItemTotalCOunt, itemperpageval)
        }
        if (PageCountList > 1) {
            showpaginationL = true
        }
        this.setState({
            GridType: Type, FilteredSearchResults: filterSearchData, pageNo: 1, pageCount: PageCountList,
            TotalItemCount: ItemTotalCOunt, itemperpage: itemperpageval, showpagination: showpaginationL
        })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    ApplyFilter = (SearchKeyWord, FilterType, ManufacApplied, AttributeApplied, ShowSample, supplierfilter) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let searchvalue = SearchKeyWord
        let filterAppliedL = this.state.filterApplied
        let filterText = this.state.filterAppliedType
        let PageLSearchResults = this.state.PageLoadSearchResults
        let filteredArray = this.state.FilterValuedata
        let finalfilterarray = []
        let BindGrid = []
        let FilterValueDatatable = PageLSearchResults
        let PageCountList = 0
        finalfilterarray = PageLSearchResults
        if (searchvalue != "") {
            let filterValue = []
            if (FilterType == 1) {
                filterAppliedL = 1
                filterText = "All"
                //let Testsearch = finalfilterarray[1].longdescriptionone.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                //let searchdate = searchvalue.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                //Testsearch = Testsearch.replaceAll(" ", "").toLowerCase()
                //searchdate = searchvalue.replaceAll(" ", "").toLowerCase()
                //console.log("Testsearch", Testsearch)
                //console.log("searchdate", searchdate)
                //filterValue = finalfilterarray.filter((val, idx) => val.UOM.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                //    || val.manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()) ||
                //    val.manufacturer.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                //    || val.longdescriptionone.replaceAll(/(\r\n|\n|\r" ")/gm, "").toLowerCase().includes(searchvalue.replaceAll(/(\r\n|\n|\r" ")/gm, "").toLowerCase()) ||
                //    val.clientPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()) ||
                //    val.supplierName.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                //    || val.manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()))
                let D = 0
                for (D = 0; D < FilterValueDatatable.length; D++) {
                    let Testsearch = FilterValueDatatable[D].longdescriptionone.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                    let searchdate = searchvalue.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                    Testsearch = Testsearch.replaceAll(" ", "").toLowerCase()
                    searchdate = searchvalue.replaceAll(" ", "").toLowerCase()
                    if (FilterValueDatatable[D].UOM.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                        || FilterValueDatatable[D].manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()) ||
                        FilterValueDatatable[D].manufacturer.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                        || Testsearch.includes(searchdate) ||
                        FilterValueDatatable[D].clientPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()) ||
                        FilterValueDatatable[D].supplierName.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                        || FilterValueDatatable[D].manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())) {
                        filterValue.push(FilterValueDatatable[D])
                    }
                }
            }
            //Ticket No-5616 Changing a lable from item id to supplier part number [4/10/2025] - Nachiappan.
            else if (FilterType == 2) {
                filterAppliedL = 1
                filterText = "Supplier part number"
                filterValue = finalfilterarray.filter((val, idx) => val.clientPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()))
            }
            else if (FilterType == 3) {
                filterAppliedL = 1
                filterText = "Description"
                let D = 0
                for (D = 0; D < FilterValueDatatable.length; D++) {
                    let Testsearch = FilterValueDatatable[D].longdescriptionone.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                    let searchdate = searchvalue.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                    Testsearch = Testsearch.replaceAll(" ", "").toLowerCase()
                    searchdate = searchvalue.replaceAll(" ", "").toLowerCase()
                    if (Testsearch.includes(searchdate)) {
                        filterValue.push(FilterValueDatatable[D])
                    }
                }
            }
            else if (FilterType == 4) {
                filterAppliedL = 1
                filterText = "MFG Name"
                filterValue = finalfilterarray.filter((val, idx) => val.manufacturer.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()))
            }
            else if (FilterType == 5) {
                filterAppliedL = 1
                filterText = "MFG Part Number"
                filterValue = finalfilterarray.filter((val, idx) => val.manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()))
            }
            else if (FilterType == 6) {
                filterAppliedL = 1
                filterText = "Supplier"
                filterValue = finalfilterarray.filter((val, idx) => val.supplierName.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()))
            }
            else if (FilterType == 7) {
                filterAppliedL = 1
                filterText = "UOM"
                filterValue = finalfilterarray.filter((val, idx) => val.UOM.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()))
            }
            else {
                //let testfilter = []
                //finalfilterarray.map((iresult, index) => {
                //    
                //    if (iresult.longdescriptionone.trim().toUpperCase() == searchvalue.trim().toUpperCase()) {
                //        testfilter.push(iresult)
                //    }
                //})
                filterText = "All"
                let D = 0
                for (D = 0; D < FilterValueDatatable.length; D++) {
                    let Testsearch = FilterValueDatatable[D].longdescriptionone.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                    let searchdate = searchvalue.replaceAll(/(\r\n|\n|\r)/gm, "").toLowerCase()
                    Testsearch = Testsearch.replaceAll(" ", "").toLowerCase()
                    searchdate = searchvalue.replaceAll(" ", "").toLowerCase()
                    if (FilterValueDatatable[D].UOM.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                        || FilterValueDatatable[D].manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()) ||
                        FilterValueDatatable[D].manufacturer.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                        || Testsearch.includes(searchdate) ||
                        FilterValueDatatable[D].clientPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase()) ||
                        FilterValueDatatable[D].supplierName.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())
                        || FilterValueDatatable[D].manfPartNumber.replaceAll(" ", "").toLowerCase().includes(searchvalue.replaceAll(" ", "").toLowerCase())) {
                        filterValue.push(FilterValueDatatable[D])
                    }
                }
                filterAppliedL = 1
            }
            FilterValueDatatable = filterValue
        }
        else {
            FilterValueDatatable = finalfilterarray
        }
        if (ShowSample == true) {
            let filterSearchData1 = [];
            let M = 0
            for (M = 0; M < FilterValueDatatable.length; M++) {
                let QtyOnHand = null
                let Testquant = ""

                if (FilterValueDatatable[M].CustomColQOH == null || FilterValueDatatable[M].CustomColQOH == undefined) {
                    Testquant = "N"
                    QtyOnHand = "0"//Testquant.match(/[1-9]/)
                }
                else {
                    QtyOnHand = FilterValueDatatable[M].CustomColQOH.match(/[0-9]/)
                    Testquant = FilterValueDatatable[M].CustomColQOH
                }
                if (QtyOnHand != null && QtyOnHand != undefined && QtyOnHand != "" || Testquant == "0") {
                    filterSearchData1.push(FilterValueDatatable[M])
                }
            }
            //filterSearchData1 = FilterValueDatatable.filter((val, idx) => val.qty_on_hand.match(/[nN]/) != null && val.qty_on_hand.match(/[nN]/) != undefined)
            FilterValueDatatable = filterSearchData1
        }
        //if (ShowSample == false) {
        //    let filterSearchData12 = [];
        //    filterSearchData12 = FilterValueDatatable.filter((val, idx) => val.ships_within == null || val.ships_within == undefined)
        //    FilterValueDatatable = filterSearchData12
        //}
        if (ManufacApplied != undefined && ManufacApplied.length > 0) {
            var i = 0
            var j = 0
            let filterSearchData = []
            for (i = 0; i < ManufacApplied.length; i++) {
                filterAppliedL = 1
                for (j = 0; j < FilterValueDatatable.length; j++) {
                    /**NEW******wal-158**the val.manufacturer column in the table is changed to mfg_std**/
                    if (ManufacApplied[i] == FilterValueDatatable[j].mfg_std) {
                        filterSearchData.push(FilterValueDatatable[j])
                    }
                }
            }
            FilterValueDatatable = filterSearchData
        }
        if (supplierfilter != undefined && supplierfilter.length > 0) {
            var i = 0
            var j = 0
            let filterSearchData = []
            for (i = 0; i < supplierfilter.length; i++) {
                filterAppliedL = 1
                for (j = 0; j < FilterValueDatatable.length; j++) {
                    if (supplierfilter[i] == FilterValueDatatable[j].supplierName) {
                        filterSearchData.push(FilterValueDatatable[j])
                    }
                }
            }
            FilterValueDatatable = filterSearchData
        }
        if (AttributeApplied != undefined && AttributeApplied.length > 0) {

            var k = 0
            var l = 0
            let filterSearchData = []
            let finalAttributeListApplied = []
            AttributeApplied.map((val, index) => {
                let AppliedAttribute = val.split("|");
                let applieddata = {
                    AttributeName: AppliedAttribute[1],
                    AttributeValue: AppliedAttribute[0],
                }
                finalAttributeListApplied.push(applieddata)
            })
            console.log("AttributeNameLocal", finalAttributeListApplied)

            for (l = 0; l < FilterValueDatatable.length; l++) {
                let RemoveemptyAttri = FilterValueDatatable[l].AttributeName.split("|");
                let RemoveEmptyAttriValue = FilterValueDatatable[l].AttributeValue.split("|");
                let AttributeNameLocal = RemoveemptyAttri.filter((val, idx) => val != "" && val != null)
                let AttributeValueLocal = RemoveEmptyAttriValue.filter((val, idx) => val != "" && val != null)
                let ItemAttribute = []
                AttributeNameLocal.map((attri4, index2) => {
                    let itemAttributeElement = {
                        AttributeName: attri4,
                        AttributeValue: AttributeValueLocal[index2]
                    }
                    ItemAttribute.push(itemAttributeElement)
                })
                console.log("ItemAttribute", ItemAttribute)
                let ItemAttributeSelected = []
                ItemAttribute.map((attri, index2) => {
                    let SameAttribute = finalAttributeListApplied.filter((val, idex) => val.AttributeName.trim().toUpperCase() == attri.AttributeName.trim().toUpperCase() && val.AttributeValue.trim().toUpperCase() == attri.AttributeValue.trim().toUpperCase())
                    if (SameAttribute != null && SameAttribute != undefined) {
                        if (SameAttribute.length > 0) {
                            //ItemAttributeSelected.push(SameAttribute[0])
                            filterSearchData.push(FilterValueDatatable[l])
                        }
                    }
                })
                console.log("ItemAttributeSelected", ItemAttributeSelected)
                //if (JSON.stringify(ItemAttributeSelected) === JSON.stringify(ItemAttribute)) {
                //    filterSearchData.push(FilterValueDatatable[l])
                //}

            }
            let FinalAttriFilter = filterSearchData.filter((v, i, a) => a.findIndex(t => (t.clientPartNumber === v.clientPartNumber || t.manfPartNumber === v.manfPartNumber)) === i)

            //for (k = 0; k < AttributeApplied.length; k++) {
            //    filterAppliedL = 1
            //    
            //    for (l = 0; l < FilterValueDatatable.length; l++) {
            //        if (AttributeApplied[k] == FilterValueDatatable[l].UNSPSCCategory) {
            //            filterSearchData.push(FilterValueDatatable[l])
            //        }
            //    }
            //}
            FilterValueDatatable = FinalAttriFilter
        }
        //WW-1286 removing sort 1/27/2024 S.Sanjay
        //FilterValueDatatable = this.SortSearchData(FilterValueDatatable)
        BindGrid = FilterValueDatatable.filter((val, idx) => idx < this.state.itemperpage)
        PageCountList = this.getpagecount(FilterValueDatatable.length, this.state.itemperpage)
        let showpaginationL = false
        if (PageCountList > 1) {
            showpaginationL = true
        }
        this.setState({
            FilterValuedata: FilterValueDatatable, FilteredSearchResults: BindGrid, pageCount: PageCountList, filterApplied: filterAppliedL, TotalItemCount: FilterValueDatatable.length,
            filterAppliedType: filterText, filterValue: FilterType, showpagination: showpaginationL, pageNo: fromSearch ? CookieService.getLocalStorageValues("pageNo") : 1
        })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //CPW-114_PC_05 
    SortSearchData = (SearchData) => {
        let SortingTable = CookieService.getLocalStorageValues('Session_SortingTable')

        let sortedDataArray = SearchData.sort((a, b) => {

            // Define the order of conditions
            // const orderOfConditions = ['ISA_TRUCK_SORT', 'ISA_INV_SORT', 'ISA_PREFERRED_SORT', 'ISA_PRICE_SORT', 'ISA_LEAD_SORT'];

            for (const condition of SortingTable) {
                const result = this.compareByCondition(a, b, condition);
                if (result !== 0) {
                    return result;
                }
            }

            return 0; // Objects are considered equal
        });
        return sortedDataArray;
    }
    //CPW-114_PC_06
    compareByCondition = (a, b, condition) => {
        const sortOrder = ['t', 'c', 'w'];
        switch (condition) {
            case 'ISA_TRUCK_SORT':
                if (a.InventoryType === 't' && b.InventoryType !== 't') return -1;
                if (a.InventoryType !== 't' && b.InventoryType === 't') return 1;

            case 'ISA_INV_SORT':
                if (a.vendor_id === 'W999999999' && b.vendor_id !== 'W999999999') return -1;
                if (a.vendor_id !== 'W999999999' && b.vendor_id === 'W999999999') return 1;
            case 'ISA_PREFERRED_SORT':
                const aPreferred = a.supplierName.includes('Preferred');
                const bPreferred = b.supplierName.includes('Preferred');
                if (aPreferred && !bPreferred) return -1;
                if (!aPreferred && bPreferred) return 1;
            case 'ISA_PRICE_SORT':
                if (a.cost_price < b.cost_price) return -1;
                if (a.cost_price > b.cost_price) return 1;
            case 'ISA_LEAD_SORT':
                if (a.ships_within < b.ships_within) return -1;
                if (a.ships_within > b.ships_within) return 1;
            default:
                return 0;
        }
    };
    FilterType = (FilterType, FilterText) => {

        this.setState({ FilterValue: FilterType, filterAppliedType: FilterText })
        //let ShowSample = $('#customCheck9').is(":checked") ? true : false
        //let searchvalue = $('#searchTb').val()
        //let ManuFilter = []
        //ManuFilter = this.state.Manuchecked
        //let AttriFilter = []
        //AttriFilter = this.state.Attrichecked
        //this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample)
    }
    Search = () => {

        let ShowSample = $('#customCheckInfo').is(":checked") ? true : false //{/*NEW*** (1/25/20201)**CHANGED***(id)** customCheck9--> customCheckInfo***/}
        let searchvalue = $('#searchTb').val()
        let FilterType = this.state.FilterValue
        let ManuFilter = []
        ManuFilter = this.state.Manuchecked
        let AttriFilter = []
        AttriFilter = this.state.Attrichecked
        let supplierfilter = []
        supplierfilter = this.state.SupplierChecked
        this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
    }
    AnykeyPress(e) {

        if (e.keyCode == 13) {
            this.Search();
        }
    };
    handlePageClick = (data) => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let pageNo = fromSearch && this.state.pageNo ? this.state.pageNo : data.selected + 1;
        let itemperpageval = this.state.itemperpage
        console.log("pageNo", pageNo)
        let PageLSearchResults = this.state.PageLoadSearchResults
        let FilterValuedataL = this.state.FilterValuedata
        let startpagecount = 0
        let PageCountList = 0
        startpagecount = (pageNo - 1) * itemperpageval
        let endcount = 0
        endcount = (pageNo * itemperpageval) - 1
        let filterSearchData = []
        let ItemTotalCOunt = 0
        let filterAppliedvalue = this.state.filterApplied
        if (filterAppliedvalue == 0) {
            filterSearchData = PageLSearchResults.filter((val, idx) => idx >= startpagecount && idx <= endcount)
            ItemTotalCOunt = PageLSearchResults.length
            PageCountList = this.getpagecount(ItemTotalCOunt, itemperpageval)
        }
        else {
            filterSearchData = FilterValuedataL.filter((val, idx) => idx >= startpagecount && idx <= endcount)
            ItemTotalCOunt = FilterValuedataL.length
            PageCountList = this.getpagecount(ItemTotalCOunt, itemperpageval)
        }
        let showpaginationL = false
        if (PageCountList > 1) {
            showpaginationL = true
        }
        this.setState({ FilteredSearchResults: filterSearchData, pageNo: pageNo, pageCount: PageCountList, TotalItemCount: ItemTotalCOunt, showpagination: showpaginationL })
        /*A1QA-206 -Pavithra-Scrolled to the top of the page when pagination is clicked   */
        window.scrollTo(0, 0)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    getpagecount = (arraycount, itemperpage) => {
        let PageCountList = 0
        let itemperpageval = itemperpage
        PageCountList = Math.floor(arraycount / itemperpageval)
        console.log(PageCountList)
        let remainder = arraycount % itemperpageval
        console.log(remainder)
        let Pagecount = 0
        Pagecount = parseInt(PageCountList.toFixed(0))
        console.log(Pagecount)
        PageCountList = remainder > 0 ? PageCountList + 1 : PageCountList
        console.log(PageCountList)
        return (PageCountList)
    }
    handlePageCOunt = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let itemperpageval = $('#itemperpagecount').val()
        let pagenum = this.state.pageNo
        let ItemTotalCOunt = 0
        let PageLSearchResults = this.state.PageLoadSearchResults
        let FilterValuedataL = this.state.FilterValuedata
        let startpagecount = 0
        let PageCountList = 0
        startpagecount = 0
        let endcount = 0
        endcount = itemperpageval
        let filterSearchData = []
        let filterAppliedvalue = this.state.filterApplied
        if (filterAppliedvalue == 0) {
            filterSearchData = PageLSearchResults.filter((val, idx) => idx < itemperpageval)
            ItemTotalCOunt = PageLSearchResults.length
            PageCountList = this.getpagecount(ItemTotalCOunt, itemperpageval)
        }
        else {
            filterSearchData = FilterValuedataL.filter((val, idx) => idx < itemperpageval)
            ItemTotalCOunt = FilterValuedataL.length
            PageCountList = this.getpagecount(ItemTotalCOunt, itemperpageval)
        }
        let showpaginationL = false
        if (PageCountList > 1) {
            showpaginationL = true
        }
        this.setState({ FilteredSearchResults: filterSearchData, pageNo: 1, itemperpage: itemperpageval, pageCount: PageCountList, TotalItemCount: ItemTotalCOunt, showpagination: showpaginationL })
        /*A1QA-206 -Pavithra-Scrolled to the top of the page when pagination is clicked   */
        window.scrollTo(0, 0)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    OnCheckTree = checked => {
        this.setState(
            { checked },
            () => console.log(`SelectTree:`, this.state.checked)
        );
    }
    OnCheckManuTree = Manuchecked => {
        let CountFilter = ""
        if (Manuchecked.length > 0) {
            CountFilter = Manuchecked.length;
        }
        let selectall = this.state.selectallMfg;
        if (this.state.Manufacture.length == CountFilter) {
            selectall = false;
        }
        else if (CountFilter == 0) {
            selectall = true;
        }
        this.setState(
            { Manuchecked, mfgcount: CountFilter, selectallMfg: selectall },
            () => console.log(`SelectTree:`, this.state.Manuchecked)
        );
        //[11/18/22], PC_WW_469_06, Dhevanesam R
        CookieService.updateLocalStorageValues("Manutree", Manuchecked)
        let ShowSample = $('#customCheckInfo').is(":checked") ? true : false //{/*NEW*** (1/25/20201)**CHANGED***(id)** customCheck9--> customCheckInfo***/}
        let searchvalue = $('#searchTb').val()
        let FilterType = this.state.FilterValue
        let ManuFilter = []
        ManuFilter = Manuchecked
        let AttriFilter = []
        AttriFilter = this.state.Attrichecked
        let supplierfilter = []
        supplierfilter = this.state.SupplierChecked
        this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
    }
    OnCheckAttriTree = Attrichecked => {
        let CountFilter = ""
        if (Attrichecked.length > 0) {
            CountFilter = Attrichecked.length;
        }
        let selectall = this.state.selectallAtt;
        if (this.state.AttributeTree.length == CountFilter) {
            selectall = false;
        }
        else if (CountFilter == 0) {
            selectall = true;
        }
        this.setState(
            { Attrichecked, attricount: CountFilter, selectallAtt: selectall },
            () => console.log(`SelectTree:`, this.state.Attrichecked)
        );
        console.log("Attrichecked", Attrichecked)
        //[11/18/22], PC_WW_469_07, Dhevanesam R
        CookieService.updateLocalStorageValues("att", Attrichecked)
        let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
        let searchvalue = $('#searchTb').val()
        let FilterType = this.state.FilterValue
        let ManuFilter = []
        ManuFilter = this.state.Manuchecked
        let AttriFilter = []
        AttriFilter = Attrichecked
        let supplierfilter = []
        supplierfilter = this.state.SupplierChecked
        this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
    }
    OnCheckSupplierTree = SupplierChecked => {
        let CountFilter = ""
        if (SupplierChecked.length > 0) {
            CountFilter = SupplierChecked.length;
        }
        let selectall = this.state.selectallSup;
        if (this.state.SupplierTree.length == CountFilter) {
            selectall = false;
        }
        else if (CountFilter == 0) {
            selectall = true;
        }
        this.setState(
            { SupplierChecked, suppliercount: CountFilter, selectallSup: selectall },
            () => console.log(`SelectTree:`, this.state.SupplierChecked)
        );
        //[11/18/22], PC_WW_469_08, Dhevanesam R
        CookieService.updateLocalStorageValues("Suppliertree", SupplierChecked)
        let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
        let searchvalue = $('#searchTb').val()
        let FilterType = this.state.FilterValue
        let ManuFilter = []
        ManuFilter = this.state.Manuchecked
        let AttriFilter = []
        AttriFilter = this.state.Attrichecked
        let supplierfilter = []
        supplierfilter = SupplierChecked
        this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
    }
    CHeckAll = (type) => {
        let checkedvalue = []
        let TradeTree = this.state.PageloadcatalogTree
        if (type == 1) {
            if (TradeTree != null) {
                TradeTree.map((val, index) => {
                    checkedvalue.push(val.FIELDNAME)
                });
            }
        }
        this.setState({ checked: checkedvalue })
    }
    //[11/15/22], PC_WW_469_02, Dhevanesam R
    //[1/30/23], PC_WW-581_APP_01 & 02, Dhevanesam R
    selectall = (SelectedCheckbox) => {
        let CountFilter = ""
        if (this.state.selectallMfg == true) {
            if (SelectedCheckbox == 'Manufacture') {
                this.setState({ Manuchecked: [] });
                let ManucheckedVal = [];
                if (this.state.Manufacture.length > 0) {
                    this.state.Manufacture.map((val, index) => {
                        ManucheckedVal.push(val.value)
                    });
                }
                if (ManucheckedVal.length > 0) {
                    CountFilter = ManucheckedVal.length;
                }
                CookieService.updateLocalStorageValues("Manutree", ManucheckedVal)
                CookieService.updateLocalStorageValues("selectallMfg", false)
                this.setState({ Manuchecked: ManucheckedVal, selectallMfg: false, mfgcount: CountFilter })
                let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
                let searchvalue = $('#searchTb').val()
                let FilterType = this.state.FilterValue
                let ManuFilter = []
                ManuFilter = ManucheckedVal
                let AttriFilter = []
                AttriFilter = this.state.Attrichecked
                let supplierfilter = []
                supplierfilter = this.state.SupplierChecked
                this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
            }
        }
        else {
            if (SelectedCheckbox == 'Manufacture') {
                CookieService.updateLocalStorageValues("Manutree", [])
                CookieService.updateLocalStorageValues("selectallMfg", true)
                this.setState({ Manuchecked: [], selectallMfg: true, mfgcount: "", expanded: [] });
                let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
                let searchvalue = $('#searchTb').val()
                let FilterType = this.state.FilterValue
                let ManuFilter = []
                let AttriFilter = []
                AttriFilter = this.state.Attrichecked
                let supplierfilter = []
                supplierfilter = this.state.SupplierChecked
                this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
            }
        }
        if (this.state.selectallAtt == true) {
            if (SelectedCheckbox == 'Attribute') {
                this.setState({ Attrichecked: [] });
                let AttricheckedVal = [];
                let expanArr = [];
                let AttrTree = this.state.AttributeTree;
                if (AttrTree.length > 0) {
                    AttrTree.map((val, index) => {
                        expanArr.push(val.value)
                        val.children.forEach((valueChild, indexChild) => {
                            AttricheckedVal.push(valueChild.value)
                        });
                    });
                }
                if (AttricheckedVal.length > 0) {
                    CountFilter = AttricheckedVal.length;
                }
                CookieService.updateLocalStorageValues("att", AttricheckedVal)
                CookieService.updateLocalStorageValues("selectallAtt", false)
                this.setState({ Attrichecked: AttricheckedVal, selectallAtt: false, attricount: CountFilter, expanded: expanArr })
                let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
                let searchvalue = $('#searchTb').val()
                let FilterType = this.state.FilterValue
                let ManuFilter = []
                ManuFilter = this.state.Manuchecked
                let AttriFilter = []
                AttriFilter = AttricheckedVal
                let supplierfilter = []
                supplierfilter = this.state.SupplierChecked
                this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
            }
        }
        else {
            if (SelectedCheckbox == 'Attribute') {
                CookieService.updateLocalStorageValues("att", [])
                CookieService.updateLocalStorageValues("selectallAtt", true)
                console.log("expandedlog", this.state.expanded)

                this.setState({ Attrichecked: [], selectallAtt: true, attricount: "", expanded: [] });
                let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
                let searchvalue = $('#searchTb').val()
                let FilterType = this.state.FilterValue
                let ManuFilter = []
                ManuFilter = this.state.Manuchecked
                let AttriFilter = []
                let supplierfilter = []
                supplierfilter = this.state.SupplierChecked
                this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
            }
        }
        if (this.state.selectallSup == true) {
            if (SelectedCheckbox == 'Supplier') {
                this.setState({ SupplierChecked: [] });
                let SupplierCheckedVal = [];
                if (this.state.SupplierTree.length > 0) {
                    this.state.SupplierTree.map((val, index) => {
                        SupplierCheckedVal.push(val.value)
                    });
                }
                if (SupplierCheckedVal.length > 0) {
                    CountFilter = SupplierCheckedVal.length;
                }
                CookieService.updateLocalStorageValues("Suppliertree", SupplierCheckedVal)
                CookieService.updateLocalStorageValues("selectallSup", false)
                this.setState({ SupplierChecked: SupplierCheckedVal, selectallSup: false, suppliercount: CountFilter })
                let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
                let searchvalue = $('#searchTb').val()
                let FilterType = this.state.FilterValue
                let ManuFilter = []
                ManuFilter = this.state.Manuchecked
                let AttriFilter = []
                AttriFilter = this.state.Attrichecked
                let supplierfilter = []
                supplierfilter = SupplierCheckedVal
                this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
            }
        }
        else {
            if (SelectedCheckbox == 'Supplier') {
                CookieService.updateLocalStorageValues("Suppliertree", [])
                CookieService.updateLocalStorageValues("selectallSup", true)
                this.setState({ SupplierChecked: [], selectallSup: true, suppliercount: "", expanded: [] });
                let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
                let searchvalue = $('#searchTb').val()
                let FilterType = this.state.FilterValue
                let ManuFilter = []
                ManuFilter = this.state.Manuchecked
                let AttriFilter = []
                AttriFilter = this.state.Attrichecked
                let supplierfilter = []
                this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
            }
        }
    }
    //[11/15/22], PC_WW_469_03, Dhevanesam R
    //[1/30/23], PC_WW-581_APP_01, Dhevanesam R
    Deselectall = (DeselectedCheckbox) => {
        if (DeselectedCheckbox == 'Manufacture') {
            CookieService.updateLocalStorageValues("Manutree", [])
            CookieService.updateLocalStorageValues("selectallMfg", true)
            this.setState({ Manuchecked: [], selectallMfg: true, mfgcount: "", expanded: [] });
            let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
            let searchvalue = $('#searchTb').val()
            let FilterType = this.state.FilterValue
            let ManuFilter = []
            let AttriFilter = []
            AttriFilter = this.state.Attrichecked
            let supplierfilter = []
            supplierfilter = this.state.SupplierChecked
            this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
        }
        else if (DeselectedCheckbox == 'Attribute') {
            CookieService.updateLocalStorageValues("att", [])
            CookieService.updateLocalStorageValues("selectallAtt", true)
            this.setState({ Attrichecked: [], selectallAtt: true, attricount: "", expanded: [] });
            let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
            let searchvalue = $('#searchTb').val()
            let FilterType = this.state.FilterValue
            let ManuFilter = []
            ManuFilter = this.state.Manuchecked
            let AttriFilter = []
            let supplierfilter = []
            supplierfilter = this.state.SupplierChecked
            this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
        }
        else if (DeselectedCheckbox == 'Supplier') {
            CookieService.updateLocalStorageValues("Suppliertree", [])
            CookieService.updateLocalStorageValues("selectallSup", true)
            this.setState({ SupplierChecked: [], selectallSup: true, suppliercount: "", expanded: [] });
            let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
            let searchvalue = $('#searchTb').val()
            let FilterType = this.state.FilterValue
            let ManuFilter = []
            ManuFilter = this.state.Manuchecked
            let AttriFilter = []
            AttriFilter = this.state.Attrichecked
            let supplierfilter = []
            this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
        }
        else if (DeselectedCheckbox == 'All') {
            CookieService.updateLocalStorageValues("Manutree", [])
            CookieService.updateLocalStorageValues("selectallMfg", true)
            CookieService.updateLocalStorageValues("att", [])
            CookieService.updateLocalStorageValues("selectallAtt", true)
            CookieService.updateLocalStorageValues("Suppliertree", [])
            CookieService.updateLocalStorageValues("selectallSup", true)

            let ShowSample = $('#customCheckInfo').is(":checked") ? true : false
            let searchvalue = $('#searchTb').val()

            let FilterType = this.state.FilterValue
            let ManuFilter = []
            let AttriFilter = []
            let supplierfilter = []

            AttriFilter = this.state.Attrichecked
            supplierfilter = this.state.SupplierChecked
            ManuFilter = this.state.Manuchecked

            this.setState({ Manuchecked: [], selectallMfg: true, mfgcount: "", expanded: [], SupplierChecked: [], selectallSup: true, suppliercount: "", Attrichecked: [], selectallAtt: true, attricount: "" });

        }
    }
    ApplyCatagoryFilter = () => {
        catagoryfilterApplied = 1
        this.LoadSearchResults()
        $('#searchTb').val("")
    }
    Mfg_parts = () => {

        let Mfg_Parts = this.state.ManufacturerPartsList; //CookieService.getLocalStorageValues("WO_Parts")
        if (Mfg_Parts != null && Mfg_Parts != undefined) {
            if (Mfg_Parts.length > 0) {
                return Mfg_Parts.map((val, ind) => {

                    return (
                        <div className="order-card px-3 py-3 mb-3">
                            <div className="d-flex">
                                <div className="d-block ml-3">
                                    <span className="font-14 font-medium custom-parts-spec-color">Manufacturer name:</span> <span className="font-14 font-regular custom-parts-spec-value-color">{val.Manufacturer_name}</span>

                                    <span className="d-block">
                                        <span className="font-14 font-medium custom-parts-spec-color">Manufacturer Part #:</span> <span className="font-14 font-regular custom-parts-spec-value-color">{val.Manufacturer_part}</span>
                                    </span>

                                </div>
                            </div>
                        </div>
                    )
                })
            }
        }

    }

    ManufactureDetails_click = () => {
        $('#Manufacturer_details').modal('show');
    }
    //AddtoCartLater = (e, index1, catalogId, ManuPartNum) => {
    //    let FilterdValue = this.state.FilteredSearchResults
    //    FilterdValue[index1].QuantityOrdered = IncDecVal

    //    this.setState({ cheaperItem: IncDecVal, cheaperIndex: index1, cheaperClientId: catalogId, cheaperManf: ManuPartNum, FilteredSearchResults: FilterdValue });
    //}
    //[12/30/21], PC_SR_14, WW-286, Dhevanesam R
    AddOrder = (e, index1, catalogId, ManuPartNum, manufacturer, ItemPrice, suppliername, cheaper, QtyNtChanged, Proceed) => {

        const re = SDIConstants.quantityRegEX;
        let PageLSearchResults = this.state.PageLoadSearchResults
        let FilterdValue = this.state.FilteredSearchResults
        let OrderCatalogItemL = this.state.OrderCatalogItem
        let OrderNonCatalogItemL = this.state.OrderNonCatalogItem
        let Index = PageLSearchResults.findIndex(x => x.clientPartNumber == catalogId && x.manfPartNumber == ManuPartNum && x.mfg_std == manufacturer && x.ItemPrice == ItemPrice && x.supplierName.trim().toUpperCase() == suppliername.trim().toUpperCase());
        let Index2 = FilterdValue.findIndex(x => x.clientPartNumber == catalogId && x.manfPartNumber == ManuPartNum && x.mfg_std == manufacturer && x.ItemPrice == ItemPrice && x.supplierName.trim().toUpperCase() == suppliername.trim().toUpperCase());
        let obj = PageLSearchResults.find(x => x.clientPartNumber == catalogId && x.manfPartNumber == ManuPartNum);
        let loccheaperitemQTY = this.state.cheaperItem;
        let imagePath = "";
        let ItemIndex;
        let cheaperitem = [];
        let QuantityOnhand = ""
        let QuantityOnhandL = []
        let message;
        let cheaperobj = this.state.cheaperItem;
        this.setState({ pageresqty: index1 });

        if (Proceed == "Proceed") {

            this.state.showCoreCharge = false
            this.state.addtocartCoreCharge = true
            this.setState({ showCoreCharge: false, addtocartCoreCharge: false });
        }
        //[07/11/2022,bug 2205 quantity cannot be increment and decrement]Pavithra R
        if (parseInt(PageLSearchResults[Index].QuantityOrdered) < parseInt(PageLSearchResults[Index].min_order_qty)) {
            alert('Quantity Entered Is Below The Minimum Order Quantity');
            return;
        }
        else if ((parseInt(PageLSearchResults[Index].QuantityOrdered) % parseInt(PageLSearchResults[Index].min_order_qty)) != 0) {
            alert('Entered Quantity Does Not Match the Minimum Order Quantity Sequence');
            return;
        }

        if (cheaper == "yes") {
            if (parseInt(cheaperobj.QuantityOrdered) < parseInt(cheaperobj.min_order_qty)) {
                alert('Entered Quantity is less than Minimum Order Quantity');
                if (cheaperobj.core_charges == "\\N" || cheaperobj.core_charges == "" || cheaperobj.core_charges == undefined) {
                }
                else {
                    if (this.state.showCoreCharge == false && this.state.addtocartCoreCharge == false) {
                        $('#CoreChargePopUp').modal('show')
                        this.state.showCoreCharge = true;
                        this.setState({ index1CC: index1, catalogIdCC: catalogId, ManuPartNumCC: ManuPartNum, manufacturerCC: manufacturer, ItemPriceCC: ItemPrice, suppliernameCC: suppliername });
                        return;
                    }
                }
                return;
            }
            else if ((parseInt(cheaperobj.QuantityOrdered) % parseInt(cheaperobj.min_order_qty)) != 0) {
                alert('Entered Quantity Does Not Match the Minimum Order Quantity Sequence');
                if (cheaperobj.core_charges == "\\N" || cheaperobj.core_charges == "" || cheaperobj.core_charges == undefined) {
                }
                else {
                    if (this.state.showCoreCharge == false && this.state.addtocartCoreCharge == false) {
                        $('#CoreChargePopUp').modal('show')
                        this.state.showCoreCharge = true;
                        this.setState({ index1CC: index1, catalogIdCC: catalogId, ManuPartNumCC: ManuPartNum, manufacturerCC: manufacturer, ItemPriceCC: ItemPrice, suppliernameCC: suppliername });
                        return;
                    }
                }
                return;
            }
        }

        if (Index != -1) {
            if (PageLSearchResults[Index].hasCoreCharge == true && this.state.showCoreCharge == false && this.state.addtocartCoreCharge == false && Proceed != "QuantityChange") {
                $('#CoreChargePopUp').modal('show')
                this.state.showCoreCharge = true;
                this.setState({ index1CC: index1, catalogIdCC: catalogId, ManuPartNumCC: ManuPartNum, manufacturerCC: manufacturer, ItemPriceCC: ItemPrice, suppliernameCC: suppliername });
                return;
            }
        }
        else {
            if (cheaperobj.core_charges == "\\N" || cheaperobj.core_charges == "" || cheaperobj.core_charges == undefined) {
            }
            else {
                if (this.state.showCoreCharge == false && this.state.addtocartCoreCharge == false) {
                    $('#CoreChargePopUp').modal('show')
                    this.state.showCoreCharge = true;
                    this.setState({ index1CC: index1, catalogIdCC: catalogId, ManuPartNumCC: ManuPartNum, manufacturerCC: manufacturer, ItemPriceCC: ItemPrice, suppliernameCC: suppliername });
                    return;
                }
            }
        }
        //*[12/13/21, PC_SRC_03, WW-275-Added Inc & Decr option for qty in cheaper popup , Poornima S]
        let qtyIndexVal = document.getElementById("quantityidCheap");
        let MinOrdQty = 1
        let MaxOrdQty = 1
        if (Index != -1) {
            MinOrdQty = PageLSearchResults[Index].min_order_qty;
            MaxOrdQty = parseInt(MinOrdQty) + parseInt(MinOrdQty);
        }
        else {
            MinOrdQty = cheaperobj.min_order_qty
            MaxOrdQty = parseInt(cheaperobj.min_order_qty) + parseInt(cheaperobj.min_order_qty);
        }

        let IncDecVal;
        if (Index != -1) {
            PageLSearchResults[Index].IsQtyChanged = false;
        }
        //Minimum Order Quantity Issue - WW-243, A1QA-136 - Deepthi N H
        if (PageLSearchResults[Index].EditedQuantity == true || cheaperobj.EditedQuantity == true) {

            if (cheaper == "yes") {
                IncDecVal = cheaperobj.QuantityOrdered;
            }
            else {
                //2204 Search results_ Not able to increase/ decrease quantity once the Quantity is updated manually - Deepthi
                if (e.target.value == undefined || e.target.value == "") {
                    if (Index != -1) {
                        IncDecVal = PageLSearchResults[Index].QuantityOrdered;
                    }
                }
                else if ((parseInt(PageLSearchResults[Index].QuantityOrdered) < parseInt(PageLSearchResults[Index].min_order_qty)) ||
                    (parseInt(PageLSearchResults[Index].QuantityOrdered) % parseInt(PageLSearchResults[Index].min_order_qty) != 0)) {
                    e.preventDefault()
                }
                else if (e.target.value == "-") {
                    IncDecVal = parseInt(PageLSearchResults[Index].QuantityOrdered) - parseInt(PageLSearchResults[Index].min_order_qty);
                }
                else if (e.target.value == "+") {
                    IncDecVal = parseInt(PageLSearchResults[Index].QuantityOrdered) + parseInt(PageLSearchResults[Index].min_order_qty);
                }
            }


        }
        else {

            if (e.target.value == undefined || e.target.value == "") {

                if (Index != -1) {
                    if (this.state.QtyChCoreCharge) {

                        IncDecVal = PageLSearchResults[Index].QuantityOrdered;
                        this.setState({ QtyChCoreCharge: false })
                    }
                    else {
                        IncDecVal = PageLSearchResults[Index].min_order_qty
                    }
                }
            }
            else {

                if (e.target.value == "-") {

                    if (cheaper != "yes" && QtyNtChanged != "yes") {
                        if (Index != -1) {
                            PageLSearchResults[Index].IsQtyChanged = true;
                        }
                        IncDecVal = parseInt($(`#quantityid${index1}`).val()) - parseInt(MinOrdQty);
                        if (IncDecVal < MinOrdQty) {
                            IncDecVal = $(`#quantityid${index1}`).val();
                        }
                    }
                    else if (QtyNtChanged != "yes") {
                        IncDecVal = parseInt($(qtyIndexVal).val()) - parseInt(MinOrdQty);
                        if (IncDecVal < MinOrdQty) {
                            IncDecVal = $(qtyIndexVal).val()
                        }
                    }

                }
                else {
                    if (Index != -1) {
                        PageLSearchResults[Index].IsQtyChanged = true;
                    }
                    if (cheaper != "yes" && QtyNtChanged != "yes") {
                        IncDecVal = parseInt($(`#quantityid${index1}`).val()) + parseInt(MinOrdQty);
                        if (IncDecVal < MaxOrdQty && IncDecVal > MaxOrdQty) {
                            IncDecVal = $(`#quantityid${index1}`).val();
                        }
                    }
                    else if (QtyNtChanged != "yes") {
                        IncDecVal = parseInt($(qtyIndexVal).val()) + parseInt(MinOrdQty);
                        if (IncDecVal < MaxOrdQty && IncDecVal > MaxOrdQty) {
                            IncDecVal = $(qtyIndexVal).val()
                        }
                    }
                }
            }
        }
        if (cheaper == "yes" && QtyNtChanged == "yes") {
            IncDecVal = $(qtyIndexVal).val()
        }
        if (IncDecVal != "" && re.test(IncDecVal)) {
            if (parseInt(IncDecVal) < parseInt(PageLSearchResults[Index].min_order_qty)) {
                alert('You Cannot Decrement Below the Minimum Order Quantity');
                return;
            }
            console.log(IncDecVal)
            if (IncDecVal != 0) {
                if (cheaper != "yes") {
                    if (Index != -1) {
                        PageLSearchResults[Index].QuantityOrdered = IncDecVal
                    }
                    else {
                        cheaperobj.QuantityOrdered = IncDecVal
                    }
                    if (Index2 != -1) {
                        FilterdValue[Index2].QuantityOrdered = IncDecVal
                    }
                }
                else {
                    // Index = PageLSearchResults.findIndex(x => x.clientPartNumber == catalogId && x.manfPartNumber == ManuPartNum && x.mfg_std.trim().toUpperCase() == manufacturer.trim().toUpperCase());
                    //Index2 = FilterdValue.findIndex(x => x.clientPartNumber == catalogId && x.manfPartNumber == ManuPartNum && x.mfg_std.trim().toUpperCase() == manufacturer.trim().toUpperCase());
                    if (Index != -1) {
                        PageLSearchResults[Index].QuantityOrdered = IncDecVal

                    }
                    if (Index2 != -1) {
                        FilterdValue[Index2].QuantityOrdered = IncDecVal
                    }

                }
                let type
                let Selecteditem
                if (Index != -1) {
                    type = PageLSearchResults[Index].CatlgOrNotCatlg == "NA" ? "SM" : "SR"
                    Selecteditem = PageLSearchResults[Index]
                }
                else {
                    type = cheaperobj.CatlgOrNotCatlg == "NA" ? "SM" : "SR"
                    Selecteditem = cheaperobj
                }

                console.log("PageLSearchResults1", PageLSearchResults)

                //if (type == "SM") {
                //    let removeIndex4 = OrderCatalogItemL.findIndex(x => x.txtItemID == Selecteditem.clientPartNumber && x.ManuPartNumber == Selecteditem.manfPartNumber);
                //    if (removeIndex4 != -1) {

                //        OrderCatalogItemL.splice(removeIndex4, 1);
                //    }
                //    let ItemDetails = {
                //        txtItemID: PageLSearchResults[Index].clientPartNumber,
                //        ManuPartNumber: PageLSearchResults[Index].manfPartNumber,
                //        Quantity: IncDecVal,
                //        EMPCC: "",
                //        DUeDate: null, 
                //        Type: "",
                //        MachineNo: "",
                //        Notes: "",
                //        Priority: "",
                //    }
                //    OrderCatalogItemL.push(ItemDetails)
                //}
                //else {
                let removeIndex3 = OrderNonCatalogItemL.findIndex(x => x.ItemId == Selecteditem.clientPartNumber
                    && x.txtMfgPartNum == Selecteditem.manfPartNumber && x.txtSupplierID == Selecteditem.vendor_id);
                if (removeIndex3 != -1) {

                    OrderNonCatalogItemL.splice(removeIndex3, 1);
                }

                let ItemDetails;
                if (Index != -1) {
                    let SW = PageLSearchResults[Index].ships_within;
                    let ShipByDate = this.calcWorkingDaysNew(SW);
                    let suppllier_part_num = PageLSearchResults[Index].supplier_part_number;
                    if (suppllier_part_num == "" || suppllier_part_num == undefined || suppllier_part_num == null) {
                        suppllier_part_num = PageLSearchResults[Index].clientPartNumber;
                    };
                    //[25/07/2022 WAL-826]
                    ItemDetails = {
                        ItemId: PageLSearchResults[Index].clientPartNumber,
                        txtSupplier: PageLSearchResults[Index].supplierName,
                        txtSupplierID: PageLSearchResults[Index].vendor_id,
                        txtSuppPartNum: suppllier_part_num,
                        txtEstPrice: PageLSearchResults[Index].ItemPrice,
                        txtDesc: PageLSearchResults[Index].Description + " " + "-InvItemIcon-" + PageLSearchResults[Index].hasBenItemVal,
                        txtMfgPartNum: PageLSearchResults[Index].manfPartNumber,
                        txtMfgName: PageLSearchResults[Index].manufacturer,
                        txtQty: IncDecVal,
                        image_url: PageLSearchResults[Index].ThumbnailImagefile,
                        DropUOM: PageLSearchResults[Index].UOM,
                        rblcatalogVisible: false,
                        Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                        filePath: null,
                        EMPCC: "",
                        DUeDate: ShipByDate,
                        Type: "",
                        MachineNo: "",
                        Notes: "",
                        Priority: "",
                        SAP_ARTCILE_NUMBER: PageLSearchResults[Index].customer_part_number_woprefix,
                        ItemCat: PageLSearchResults[Index].UNSPSC,
                        MIN_ORD_QTY: PageLSearchResults[Index].min_order_qty,
                        //[12/22/21], PC_SR_02, WW-286, Dhevanesam R
                        CORE_CHARGE: PageLSearchResults[Index].core_charges
                    }
                }

                else {
                    let SW = Selecteditem.ships_within;
                    let ShipByDate = this.calcWorkingDaysNew(SW);
                    let selected_supplier_part_number = Selecteditem.supplier_part_number;
                    if (selected_supplier_part_number == "" || selected_supplier_part_number == undefined || selected_supplier_part_number == null) {
                        selected_supplier_part_number = Selecteditem.clientPartNumber;
                    };
                    ItemDetails = {
                        ItemId: Selecteditem.clientPartNumber,
                        txtSupplier: Selecteditem.supplierName,
                        txtSupplierID: Selecteditem.vendor_id,
                        txtSuppPartNum: selected_supplier_part_number,
                        txtEstPrice: Selecteditem.ItemPrice,
                        txtDesc: Selecteditem.Description + " " + "-InvItemIcon-" + Selecteditem[Index].hasBenItemVal,
                        txtMfgPartNum: Selecteditem.manfPartNumber,
                        txtMfgName: Selecteditem.manufacturer,
                        txtQty: IncDecVal,
                        image_url: Selecteditem.ThumbnailImagefile,
                        DropUOM: Selecteditem.UOM,
                        rblcatalogVisible: false,
                        Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                        filePath: null,
                        EMPCC: "",
                        DUeDate: ShipByDate,
                        Type: "",
                        MachineNo: "",
                        Notes: "",
                        Priority: "",
                        SAP_ARTCILE_NUMBER: Selecteditem.customer_part_number_woprefix,
                        ItemCat: Selecteditem.UNSPSC,
                        MIN_ORD_QTY: Selecteditem.min_order_qty,
                        //[12/22/21], PC_SR_02, WW-286, Dhevanesam R
                        CORE_CHARGE: PageLSearchResults[Index].core_charges
                    }
                }

                OrderNonCatalogItemL.push(ItemDetails)
            }
        }
        //} ***********NEW****ADDED(3/16/2021)*********SAP_ARTCILE_NUMBER:PageLSearchResults[Index].customer_part_number_woprefix**************
        else if (IncDecVal == "" || IncDecVal == null || IncDecVal == "0" || IncDecVal == undefined) {
            if (parseInt(IncDecVal) < parseInt(PageLSearchResults[Index].min_order_qty)) {
                alert('You Cannot Decrement Below the Minimum Order Quantity');
                return;
            }
            if (cheaper == "yes") {
                let Selecteditem;
                if (Index != -1) {
                    Selecteditem = PageLSearchResults[Index]
                }
                else {
                    Selecteditem = cheaperobj
                }

                let removeIndex3 = OrderNonCatalogItemL.findIndex(x => x.ItemId == Selecteditem.clientPartNumber
                    && x.txtMfgPartNum == Selecteditem.manfPartNumber && x.txtSupplierID == Selecteditem.vendor_id);
                if (removeIndex3 != -1) {

                    OrderNonCatalogItemL.splice(removeIndex3, 1);
                }
                let ItemDetails;
                if (Index != -1) {
                    let SW = PageLSearchResults[Index].ships_within;
                    let ShipByDate = this.calcWorkingDaysNew(SW);
                    let suppllier_part_num = PageLSearchResults[Index].supplier_part_number;
                    if (suppllier_part_num == "" || suppllier_part_num == undefined || suppllier_part_num == null) {
                        suppllier_part_num = PageLSearchResults[Index].clientPartNumber;
                    };
                    ItemDetails = {
                        ItemId: PageLSearchResults[Index].clientPartNumber,
                        txtSupplier: PageLSearchResults[Index].supplierName,
                        txtSupplierID: PageLSearchResults[Index].vendor_id,
                        txtSuppPartNum: suppllier_part_num,
                        txtEstPrice: PageLSearchResults[Index].ItemPrice,
                        txtDesc: PageLSearchResults[Index].Description + " " + "-InvItemIcon-" + PageLSearchResults[Index].hasBenItemVal,
                        txtMfgPartNum: PageLSearchResults[Index].manfPartNumber,
                        txtMfgName: PageLSearchResults[Index].manufacturer,
                        txtQty: IncDecVal,
                        image_url: PageLSearchResults[Index].ThumbnailImagefile,
                        DropUOM: PageLSearchResults[Index].UOM,
                        rblcatalogVisible: false,
                        Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                        filePath: null,
                        EMPCC: "",
                        DUeDate: ShipByDate,
                        Type: "",
                        MachineNo: "",
                        Notes: "",
                        Priority: "",
                        SAP_ARTCILE_NUMBER: PageLSearchResults[Index].customer_part_number_woprefix,
                        ItemCat: PageLSearchResults[Index].UNSPSC,
                        MIN_ORD_QTY: PageLSearchResults[Index].min_order_qty,
                        //[12/22/21], PC_SR_02, WW-286, Dhevanesam R
                        CORE_CHARGE: PageLSearchResults[Index].core_charges
                    }
                }
                else {
                    let SW = Selecteditem.ships_within;
                    let ShipByDate = this.calcWorkingDaysNew(SW);
                    let selected_supplier_part_number = Selecteditem.supplier_part_number;
                    if (selected_supplier_part_number == "" || selected_supplier_part_number == undefined || selected_supplier_part_number == null) {
                        selected_supplier_part_number = Selecteditem.clientPartNumber;
                    };
                    let ItemDetails = {
                        ItemId: Selecteditem.clientPartNumber,
                        txtSupplier: Selecteditem.supplierName,
                        txtSupplierID: Selecteditem.vendor_id,
                        txtSuppPartNum: selected_supplier_part_number,
                        txtEstPrice: Selecteditem.ItemPrice,
                        txtDesc: Selecteditem.Description + " " + "-InvItemIcon-" + Selecteditem[Index].hasBenItemVal,
                        txtMfgPartNum: Selecteditem.manfPartNumber,
                        txtMfgName: Selecteditem.manufacturer,
                        txtQty: IncDecVal,
                        image_url: Selecteditem.ThumbnailImagefile,
                        DropUOM: Selecteditem.UOM,
                        rblcatalogVisible: false,
                        Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                        filePath: null,
                        EMPCC: "",
                        DUeDate: ShipByDate,
                        Type: "",
                        MachineNo: "",
                        Notes: "",
                        Priority: "",
                        SAP_ARTCILE_NUMBER: Selecteditem.customer_part_number_woprefix,
                        ItemCat: Selecteditem.UNSPSC,
                        MIN_ORD_QTY: Selecteditem.min_order_qty,
                        //[12/22/21], PC_SR_02, WW-286, Dhevanesam R
                        CORE_CHARGE: PageLSearchResults[Index].core_charges
                    }
                }

                OrderNonCatalogItemL.push(ItemDetails)


            }
            else if (cheaper == 'no') {
                let Selecteditem;
                if (Index != -1) {
                    Selecteditem = PageLSearchResults[Index]
                }
                else {
                    Selecteditem = cheaperobj
                }
                let removeIndex3 = OrderNonCatalogItemL.findIndex(x => x.ItemId == Selecteditem.clientPartNumber
                    && x.txtMfgPartNum == Selecteditem.manfPartNumber && x.txtSupplierID == Selecteditem.vendor_id);
                if (removeIndex3 != -1) {

                    OrderNonCatalogItemL.splice(removeIndex3, 1);
                }

            }
            else {
                let Selecteditem;
                if (Index != -1) {
                    PageLSearchResults[Index].QuantityOrdered = IncDecVal
                    FilterdValue[index1].QuantityOrdered = IncDecVal
                    Selecteditem = PageLSearchResults[Index]
                }
                else {
                    Selecteditem = cheaperobj
                }

                //let type = Selecteditem.CatlgOrNotCatlg == "NA" ? "SM" : "SR"
                //if (type == "SM") {
                //    let removeIndex1 = OrderCatalogItemL.findIndex(x => x.txtItemID == Selecteditem.clientPartNumber);
                //    if (removeIndex1 != -1) {

                //        OrderCatalogItemL.splice(removeIndex1, 1);
                //    }
                //}
                //else {
                if (OrderNonCatalogItemL.length > 0) {
                    let removeIndex2 = OrderNonCatalogItemL.findIndex(x => x.ItemId == Selecteditem.clientPartNumber && x.txtMfgPartNum == Selecteditem.manfPartNumber && x.txtSupplierID == Selecteditem.vendor_id);
                    if (removeIndex2 != -1) {

                        OrderNonCatalogItemL.splice(removeIndex2, 1);
                    }
                }
            }


            // }

        }
        else {
            console.log("Enter valid quantity");
            return;
        }
        console.log(OrderCatalogItemL);
        console.log(OrderNonCatalogItemL);
        console.log(this.state.cheaperItem);
        if (cheaper == 'yes') {
            this.setState({
                OrderCatalogItem: OrderCatalogItemL, OrderNonCatalogItem: OrderNonCatalogItemL, PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue,
                QuantityOrdered: IncDecVal, cheaperitem: cheaperobj
            });
        }
        else {
            this.setState({ OrderCatalogItem: OrderCatalogItemL, OrderNonCatalogItem: OrderNonCatalogItemL, PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue })

        }
    }

    cheaperpopupclose = () => {
        $('#cheaperitem-popup').modal('hide');

    }
    //[12/30/21], PC_SR_14, WW-286, Dhevanesam R
    CoreChargePopUpclose = (e) => {

        $('#CoreChargePopUp').modal('hide');
        this.setState({ showCoreCharge: false });

    }

    CheaperPopup = (manupartnum, Itemprice, indexval, val, MinOrdQty, MaxOrdQty, cheapindexval) => {
        //if (val.QuantityOrdered == "" || val.QuantityOrdered == null) {
        //    alert("Enter Quantity for at least one item")
        //    return;
        //}

        let cheaperitem = val;
        //if (Itemprice == ' ' || Itemprice == '' || Itemprice == null) { Itemprice = 0; }
        //this.state.FilteredSearchResults.filter((item) => item.manfPartNumber == manupartnum && item.ItemPrice < Itemprice)
        //    .sort((a, b) => a.ItemPrice > b.ItemPrice ? 1 : -1)
        //    .map((item, index) =>
        //        cheaperitem.push(item)
        //);
        let ItemIndex = indexval
        let imagePath = "";
        if (cheaperitem.length > 0) {
            if (cheaperitem[0].ThumbnailImagefile) {
                cheaperitem[0].Image = cheaperitem[0].ThumbnailImagefile.replace('\\', '/');
                if (cheaperitem[0].Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = cheaperitem[0].ThumbnailImagefile;
                } else {
                    imagePath = cheaperitem[0].ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? cheaperitem[0].ThumbnailImagefile.substring(cheaperitem[0].ThumbnailImagefile.lastIndexOf("/") + 1, cheaperitem[0].ThumbnailImagefile.length) : "noimage_new.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `/Images/noimage_new.png`;
            }
        }
        let QuantityOnhand = ""
        let QuantityOnhandL = []
        if (cheaperitem[0].length > 0) {
            if (cheaperitem[0].CustomColQOH != null) {
                let valqtg = cheaperitem[0].CustomColQOH
                QuantityOnhandL = valqtg.match(/[a-zA-Z0-9]/);
                //console.log("QuantityOnhand", QuantityOnhandL)
                if (QuantityOnhandL != null && QuantityOnhandL != undefined) {
                    if (QuantityOnhandL.length > 0) {
                        if (QuantityOnhandL[0] != "Y" && QuantityOnhandL[0] != "y" && QuantityOnhandL[0] == 0) {
                            QuantityOnhand = ""
                            //console.log("QuantityOnhand588758", QuantityOnhand)
                        }
                        else {
                            QuantityOnhand = QuantityOnhandL[0]
                        }
                    }
                }
            }
        }
        let message = this.calcWorkingDays(cheaperitem[0].ships_within)//*****NEW****wal-158(GetShipwithin()-->calcWorkingDays)
        let FavItem = false
        let selectedfav = false
        let favsubitem = []
        favsubitem = this.state.FavoritesSubMenu
        if (favsubitem.length > 0) {
            selectedfav = favsubitem.filter((item, index) => item.CUSTOMERITEMID == this.state.SelectedItemForCheaper.clientPartNumber || (item.CLIENT_MFG_PART == this.state.SelectedItemForCheaper.manfPartNumber && item.MANUFACTURER == this.state.SelectedItemForCheaper.manfPartNumber)).length > 0 ? true : false;

            FavItem = favsubitem.filter((item, index) => item.CUSTOMERITEMID == cheaperitem[0].clientPartNumber || (item.CLIENT_MFG_PART == cheaperitem[0].manfPartNumber && item.MANUFACTURER == cheaperitem[0].manfPartNumber)).length > 0 ? true : false;
        }

        this.setState({ cheaperItem: cheaperitem[0], cheaperItemImage: imagePath, cheaperQty: QuantityOnhand, cheapershipby: message, cheaperIndex: ItemIndex, Itemdetailfav: FavItem, selectedItemdetailfav: selectedfav, CheapItemMinQty: MinOrdQty, CheapItemMaxQty: MaxOrdQty, QuantityOrdered: MinOrdQty, cheaperItemIndex: cheapindexval });


        if (cheaperitem.length > 0) {

            //$('#cheaper-img').attr("src", imagePath)
            $('#cheaperitem-popup').modal('show');
        }

    }
    //WW-243_AddToCart_PC_03 adding parameter "value" (3/7/2022) -Aparna
    Addtocart = (item, mfgpartid, cartno, cheapflag, value) => {
        const { t } = this.props
        /*[01/30/22, PC_EF_04, Priyanka.D]*/
        let EnersysFormVaue = ""
        let OrderCatalogItemL = this.state.OrderCatalogItem;
        let OrderNonCatalogItemL = this.state.OrderNonCatalogItem;
        console.log("OrderNonCatalogItemL", OrderNonCatalogItemL);
        /*[05/02/22, A1QA-172], Priyanka D */
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        let KenstanItem = "";
        let ItemID = ""
        let KenstanKey = false;
        /*[05/03/22,PC_A1QA-172 and A1QA-169], Priyanka D */
        CartStorage.forEach((val) => {
            if (val.FilePath != null && val.FilePath.includes('kenstan')) {
                KenstanItem = KenstanItem.concat(val.Itemid);
            }
        });

        if (cartno == "1") {
            if (cheapflag == "cheap-yes") {
                if (this.state.QuantityOrdered != "" && this.state.QuantityOrdered != null) {
                    if (OrderNonCatalogItemL.length > 1) {
                        OrderNonCatalogItemL = OrderNonCatalogItemL.filter((x) => x.ItemId == item && x.txtMfgPartNum == mfgpartid && x.txtSupplier.trim().toUpperCase() == this.state.cheaperItem.supplierName.trim().toUpperCase())

                    }

                }

                else {
                    alert("Enter Quantity for the item ")
                    return;
                }
            }
            else if (cheapflag == "cheap-no") {


                if (OrderNonCatalogItemL.length > 1) {
                    OrderNonCatalogItemL = OrderNonCatalogItemL.filter((x) => x.ItemId == this.state.SelectedItemForCheaper.clientPartNumber && x.txtMfgPartNum == this.state.SelectedItemForCheaper.manfPartNumber && x.txtSupplier.trim().toUpperCase() == this.state.SelectedItemForCheaper.supplierName.trim().toUpperCase())

                }


            }
            else {


                if (OrderNonCatalogItemL.length > 1) {
                    //WW-243_AddToCart_PC_01 (3/7/2022) -Aparna
                    // OrderNonCatalogItemL = OrderNonCatalogItemL.filter((x) => x.ItemId == this.state.SelectedItemForCheaper.clientPartNumber && x.txtMfgPartNum == this.state.SelectedItemForCheaper.manfPartNumber && x.txtSupplier.trim().toUpperCase() == this.state.SelectedItemForCheaper.supplierName.trim().toUpperCase())
                    OrderNonCatalogItemL = OrderNonCatalogItemL.filter((x) => x.ItemId == value.clientPartNumber && x.txtMfgPartNum == value.manfPartNumber && x.txtSupplier.trim().toUpperCase() == value.supplierName.trim().toUpperCase())

                }


            }

        }

        console.log('OrderCatalogItemL', OrderCatalogItemL);
        console.log('OrderNonCatalogItemL', OrderNonCatalogItemL);
        let kenstan = false;
        OrderCatalogItemL.map((item, index) => {
            if (item.txtMfgName.indexOf('KENSTAN') > -1) {
                kenstan = true;
            }
        }
        );
        OrderNonCatalogItemL.map((item, index) => {
            if (item.txtMfgName.indexOf('KENSTAN') > -1) {
                kenstan = true;
            }
        }
        )
        let AddToCartBO = {
            ItemDetails: OrderCatalogItemL,
            NonItemDetails: OrderNonCatalogItemL,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_USERID: this.state.Login_UserId,
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: "",
            Session_PUNCHIN: "False",
            MobileAPICall: false,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
            SOURCE: "WEB"
        }
        this.setState({ OrderNonCatalogItem: OrderNonCatalogItemL })
        //debugger
        let AttributeNameLocal = [];
        let AttributeValueLocal = [];
        AttributeNameLocal = CookieService.getLocalStorageValues("Search_AttributeName") ? CookieService.getLocalStorageValues("Search_AttributeName").split("|") : null;
        AttributeValueLocal = CookieService.getLocalStorageValues("Search_AttributeValue") ? CookieService.getLocalStorageValues("Search_AttributeValue").split("|") : null;
        console.log('attribute', CookieService.getLocalStorageValues("Search_AttributeName") + CookieService.getLocalStorageValues("Search_AttributeValue"));
        let form = "";
        let DoorFormValue = "";
        if (AttributeNameLocal != null && AttributeNameLocal != undefined) {
            if (AttributeNameLocal.length > 0) {
                AttributeNameLocal.map((val, index) => {
                    let AttributeName = val.trim()
                    let AttributeValue = AttributeValueLocal[index].replace(/\s/g, "");
                    if (AttributeName == 'FORM') {
                        if (AttributeValue.trim().indexOf('KENSTAN') > -1) {
                            form = AttributeValueLocal[index];
                            this.setState({ EnersysFormVaue: "", EnersysForm: false })
                            CookieService.updateLocalStorageValues("EnersysFormVaue", "")
                            CookieService.updateLocalStorageValues("EnersysForm", false)
                        }
                        /*[04/01/22,PC_DF_04,WW-371] Priyanka D */
                        else if (AttributeValue.indexOf("DOORS-INTERIOR NON-FIRE RATED ") > -1) {
                            DoorFormValue = AttributeValueLocal[index];
                            this.setState({ DoorFormValue: DoorFormValue, DoorForm: true })
                            CookieService.updateLocalStorageValues("DoorFormValue", DoorFormValue)
                            CookieService.updateLocalStorageValues("DoorForm", true)
                        }
                        else if (AttributeValue.indexOf("BATTERY") > -1 || AttributeValue.indexOf("CHARGER") > -1) {
                            /*[01/30/22, PC_EF_04, Priyanka.D]*/
                            EnersysFormVaue = AttributeValueLocal[index];
                            this.setState({ EnersysFormVaue: EnersysFormVaue, EnersysForm: true, EnersysEmp: "Are you working on an enersys(nextsys) " + AttributeValueLocal[index].toLowerCase() })
                            /*[04/26/22,PC_A1QA-168_03], Priyanka D */
                            CookieService.updateLocalStorageValues("EnersysFormVaue", EnersysFormVaue)
                            CookieService.updateLocalStorageValues("EnersysForm", true)
                        }
                    } else {
                        /*[04/01/22,PC_DF_04,WW-371] Priyanka D */
                        this.setState({ EnersysFormVaue: "", EnersysForm: false, DoorFormValue: "", DoorForm: false })
                        CookieService.updateLocalStorageValues("EnersysFormVaue", "")
                        CookieService.updateLocalStorageValues("EnersysForm", false)
                        CookieService.updateLocalStorageValues("DoorFormValue", "")
                        CookieService.updateLocalStorageValues("DoorForm", false)
                    }
                });
            } else {
                /*[04/01/22,PC_DF_04,WW-371] Priyanka D */
                this.setState({ EnersysFormVaue: "", EnersysForm: false, DoorFormValue: "", DoorForm: false })
                CookieService.updateLocalStorageValues("EnersysFormVaue", "")
                CookieService.updateLocalStorageValues("EnersysForm", false)
                CookieService.updateLocalStorageValues("DoorFormValue", "")
                CookieService.updateLocalStorageValues("DoorForm", false)
            }

        } else {
            /*[04/01/22,PC_DF_04,WW-371], Priyanka D */
            this.setState({ EnersysFormVaue: "", EnersysForm: false, DoorFormValue: "", DoorForm: false })
            CookieService.updateLocalStorageValues("EnersysFormVaue", "")
            CookieService.updateLocalStorageValues("EnersysForm", false)
            CookieService.updateLocalStorageValues("DoorFormValue", "")
            CookieService.updateLocalStorageValues("DoorForm", false)
        }
        /*[04/27/22, A1QA-172], Priyanka D */
        let KenstanList = CookieService.getLocalStorageValues("KenstanList")
        if (KenstanList.length > 0) {
            KenstanList.forEach((val) => {
                if (val.includes('KEY')) {
                    KenstanKey = true
                }
            });
        }
        if (KenstanKey && form.includes('KEY')) {
            alert("Kensktan key is already added to cart, only one key allow for one cart. Please go to cart to increase quantity");
            return; {/*NEW**CHANGED(11/1/2021)******/ }
        }
        if ((CookieService.getLocalStorageValues("KenstanList") != null && CookieService.getLocalStorageValues("KenstanList") != undefined) ? CookieService.getLocalStorageValues("KenstanList").indexOf(OrderNonCatalogItemL[0].ItemId) > -1 : false) {
            console.log("KenstanListinsearch", CookieService.getLocalStorageValues("KenstanList"));
            alert(t("This Kensktan lock is already in the cart. Please go to cart to increase quantity"));
            return; {/*NEW**CHANGED(11/8/2021)******/ }

        }
        /*[05/03/22,PC_A1QA-172 and A1QA-169], Priyanka D */
        else if (CookieService.getLocalStorageValues("KenstanList").indexOf(OrderNonCatalogItemL[0].ItemID) > -1) {
            alert("This Kensktan Item is already in the cart.Please go to cart to increase quantity")
        } else if (KenstanItem != "") {
            if (KenstanItem.indexOf(OrderNonCatalogItemL[0].ItemID) > -1) {
                alert("This Kensktan Item is already in the cart.Please go to cart to increase quantity")
            }
        }
        else if (kenstan == true) {
            if (form.indexOf('KEY') > -1) {
                CookieService.updateLocalStorageValues("IsKenstanKey", true);
            }

            this.props.history.push({
                pathname: "/kenstanform",
                state: { item: AddToCartBO, qty: CookieService.getLocalStorageValues("QTY_KENSTAN"), WO: this.state.WorkOrderNo, pagename: 'SearchResult', searchKey: this.state.SearchKeyWord, form: form }
            });
            /*[01/30/22, PC_EF_04, Priyanka.D]*/
        }
        else if (CookieService.getLocalStorageValues("EnersysForm") == true) {
            if (CookieService.getLocalStorageValues("EnersysList") != undefined) {
                if ((CookieService.getLocalStorageValues("EnersysList").indexOf(OrderNonCatalogItemL[0].ItemId) == -1)) {
                    $('#EnersysEmployee').modal('show');
                    return

                }
            } else {
                $('#EnersysEmployee').modal('show');
                return
            }
            /*[04/01/22,PC_DF_04,WW-371] Priyanka D */
        } else if (CookieService.getLocalStorageValues("DoorForm") == true) {

            if (CookieService.getLocalStorageValues("Doorlist") != undefined) {
                if ((CookieService.getLocalStorageValues("Doorlist").indexOf(OrderNonCatalogItemL[0].ItemId) == -1)) {
                    this.props.history.push({
                        pathname: "/DoorForm",
                        state: { item: AddToCartBO, qty: CookieService.getLocalStorageValues("QTY"), pagename: 'SearchResult', searchKey: this.state.SearchKeyWord, form: "DoorForm" }
                    });
                } else {
                    alert("This Door Item is already added in the cart. Please go to cart to increase quantity !")
                    return
                }
            } else {
                this.props.history.push({
                    pathname: "/DoorForm",
                    state: { item: AddToCartBO, qty: CookieService.getLocalStorageValues("QTY"), pagename: 'SearchResult', searchKey: this.state.SearchKeyWord, form: "DoorForm" }
                });
            }

        }
        else if (OrderCatalogItemL.length > 0 || OrderNonCatalogItemL.length > 0) {

            SearchResultsAction.AddCart(AddToCartBO)
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        else {
            //e.preventDefault();
            alert("Enter Quantity for at least one item"); {/*NEW**CHANGED(1/25/2021)******/ }
        }

    }
    AddtocartSuccess = () => {

        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#add-fav-popup').modal('hide');
        $('#cheaperitem-popup').modal('hide');
        let Status = JSON.parse(SearchResultsStore.SuccessStatus);
        console.log("Status_Add", Status)
        let itemstatus = Status._FlagDt
        let iteminsertstatus = Status.SuccessFLag
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {
                CookieService.updateLocalStorageValues("Session_SearchValue", this.state.SearchKeyWord);
                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }

                //window.location.reload();
                //[12/22/21], PC_SR_04, WW-286, Dhevanesam R
                if (iteminsertstatus[0].CORE_CHARGE != "" && iteminsertstatus[0].CORE_CHARGE != " " && iteminsertstatus[0].CORE_CHARGE != null) {
                    // alert("Item successfully added to cart and added item applies core charges")
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'Item successfully added to cart and added item applies core charges'
                    });
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'Item successfully added to cart'
                    });
                    //alert("Item successfully added to cart")
                }
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                //MenuAction.refreshMasterData();
                //PageLSearchResults[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                ////Add_To_Cart_ISSUE_PC_01 (5/19/2022)-Aparna
                //let ind = FilterdValue.findIndex((x) => x == PageLSearchResults[this.state.pageresqty])
                //FilterdValue[ind].QuantityOrdered = PageLSearchResults[ind].min_order_qty;
                //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                ////*[12/13/21, PC_SRC_02, WW-275-clearing min ord qty for cheaper item after adding to cart, Poornima S]
                //if (this.state.cheaperItemIndex != "" && this.state.cheaperItemIndex != null) {
                //    PageLSearchResults[this.state.cheaperItemIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperItemIndex].min_order_qty;
                //    FilterdValue[this.state.cheaperItemIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperItemIndex].min_order_qty;
                //}

                //this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
                //this.props.history.push({
                //    //pathname: "/shoppingcart",
                //    pathname: `\shoppingcart`,
                //    search: `?SearchKey=${this.state.SearchKeyWord}`
                //});
            }
            else {
                CookieService.updateLocalStorageValues("Session_SearchValue", this.state.SearchKeyWord);
                let itemidnotinserted = ""
                let validate = false
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                        else if (validate != true && val.Status == "true") {
                            validate = true
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }
                if (validate == true) {

                    //window.location.reload();
                    //[12/22/21], PC_SR_04, WW-286, Dhevanesam R
                    if (iteminsertstatus[0].CORE_CHARGE != "" && iteminsertstatus[0].CORE_CHARGE != " " && iteminsertstatus[0].CORE_CHARGE != null) {
                        // alert("Item successfully added to cart and added item applies core charges")
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: 'Item successfully added to cart and added item applies core charges'
                        });

                    }
                    else {
                        alert("Item successfully added to cart")
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: 'Item successfully added to cart'
                        });
                    }

                    /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                    //MenuAction.refreshMasterData();                 
                    PageLSearchResults[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                    FilterdValue[this.state.pageresqty].QuantityOrdered = PageLSearchResults[this.state.pageresqty].min_order_qty;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    PageLSearchResults[this.state.cheaperIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperIndex].min_order_qty;
                    FilterdValue[this.state.cheaperIndex].QuantityOrdered = PageLSearchResults[this.state.cheaperIndex].min_order_qty;
                    console.log(PageLSearchResults, FilterdValue)
                    this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
                    //this.props.history.push({
                    //    //pathname: "/shoppingcart",
                    //    pathname: `\shoppingcart`,
                    //    search: `?SearchKey=${this.state.SearchKeyWord}`
                    //});
                }
                else if (itemidnotinserted == null || itemidnotinserted == undefined || itemidnotinserted == "") {
                    alert("Techincal Issue Contact SDI Customer Care")
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }

    }
    BindFavForm = (e, favexist, Itemtype, popup) => {

        let targetID = ""

        document.getElementById("lblerror").innerText = "";
        let FilteredSearch = this.state.FilteredSearchResults
        let SelectedValue = []
        if (e.target == null) {
            targetID = e
        } else {
            targetID = e.target.id
        }
        SelectedValue = FilteredSearch[targetID]
        console.log("SelectedValue", SelectedValue)
        let Itemtypevalue = Itemtype == "" || Itemtype == null ? "CAT" : "NONCAT"
        if (!favexist) {
            if (SelectedValue != [] && SelectedValue != null) {
                {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/ }
                let FavSDICatg = SelectedValue.UNSPSCCategory == null || SelectedValue.UNSPSCCategory == "" || SelectedValue.UNSPSCCategory == " " ? "UnClassified" : SelectedValue.UNSPSCCategory;
                let kitcomponents = SelectedValue.kit_components.replaceAll(",", "~").replaceAll(";", "|")
                let core = false
                let iscore = SelectedValue.core_charges;
                if (iscore != "\\N" && iscore != "\N" && iscore != "" && iscore != undefined && iscore.length > 0) {
                    core = true;
                }

                this.setState({
                    FavItemIdPopUp: SelectedValue.clientPartNumber, FavSDICatgPopUp: FavSDICatg,
                    FavItemDescripPopUp: SelectedValue.longdescriptionone, FavMFGPopUp: SelectedValue.manufacturer,
                    FavSupplierPopUp: SelectedValue.supplierName,
                    FavMFGPartNUMPopUp: SelectedValue.manfPartNumber, txtUOMHidePopUp: SelectedValue.UOM,
                    txtMfgItemidHidePopUp: SelectedValue.manfPartNumber,
                    txtItemidHidePopUp: SelectedValue.clientPartNumber, txtMFGHidePopUp: SelectedValue.vendor_id, ItemType: Itemtypevalue, FavitemImage: SelectedValue.ThumbnailImagefile, FavSAP: SelectedValue.customer_part_number_woprefix,
                    FavYourCatg: popup == "Yes" ? this.state.FavYourCatg : "", FavSubCategory: popup == "Yes" ? this.state.FavSubCategory : "",
                    FavKit_Components: kitcomponents,
                    ISCoreCharge: core //BUG-2688  (9/21/2022)-Aparna
                })
                document.getElementById("txtUOMHide").hidden = true
                document.getElementById("txtMfgItemidHide").hidden = true
                document.getElementById("txtItemidHide").hidden = true
                document.getElementById("txtMFGHide").hidden = true
                document.getElementById("ItemType").hidden = true
                $('#add-fav-popup').modal('show');
                $('#FavYourCatg').val('');
                //WW-516 -Aparna
                if (popup != "Yes") {
                    $('#FavYourDescrip').val('');
                }

                //WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna 
                let autoCompleteDataRes = []
                let locsugg = []
                let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
                console.log("Fav_Item_Cat", suggestionsStr)
                if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
                    suggestionsStr.forEach((sugg, index) => {
                        autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
                    });
                    autoCompleteDataRes = autoCompleteDataRes.sort((a, b) =>
                        a.value > b.value ? 1 : -1,
                    );
                }
                let locSubCat = []
                let locSubCatSGG = []
                let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
                console.log("Fav_Item_SubCat", subcatsuggestion)
                if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
                    subcatsuggestion.forEach((sugg, index) => {
                        //WW-516_PC_04  (9/30/2022)-Aparna
                        if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                            locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), category: sugg.ISA_FAVS_CATEGORY.toUpperCase() });
                        }

                    });
                }
                if (locSubCat.length > 0) {
                    locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.category === v.category && t.label != null && t.label != " ")) === i)
                    locSubCatSGG = locSubCatSGG.sort((a, b) =>
                        a.value > b.value ? 1 : -1,
                    );
                }
                this.setState({ autocompleteData: autoCompleteDataRes, CategoryErr: false, SubCategoryErr: false, subCategory: locSubCatSGG, autocompleteDataRstl: autoCompleteDataRes, subCategoryResults: [] });
            }
        }
        else {
            let deleteFavBO = {
                ItemId: SelectedValue.clientPartNumber,
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                MFG: SelectedValue.manufacturer,
                MFGpartnum: SelectedValue.manfPartNumber,
                SupplierId: SelectedValue.vendor_id,
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            FavItemMainAction.DeletFavItem(deleteFavBO);
            favexist = false
        }

        this.setState({ attachmentPathArr: [], SelectedValueImg: SelectedValue.Image, eventFav: targetID, favexist: favexist, Itemtype: Itemtype });
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    AddfavItem = (ImgNo) => {

        let itemtypevalue = this.state.ItemType
        let ItemDescrip = $('#FavYourDescrip').val()
        let ItemCatagory = $('#FavYourCatg').val();
        ItemCatagory = this.state.FavYourCatg;
        //WW-516_PC_05 (9/30/2022) -Aparna
        let ItemSubCategory = this.state.FavSubCategory
        if (itemtypevalue == "CAT") {
            if (ItemCatagory != null && ItemCatagory != undefined && ItemSubCategory != null && ItemSubCategory != undefined) {
                if (ItemCatagory.trim() != "" && ItemSubCategory.trim() != "") {
                    //  if (this.state.attachmentPathArr.length == 0 && !((this.state.SelectedValueImg.includes(".jpg")) || this.state.SelectedValueImg.includes(".JPG")) && ImgNo != true) {
                    if ((!(this.state.SelectedValueImg.includes(".png") || (this.state.SelectedValueImg.includes(".PNG"))) && !(this.state.SelectedValueImg.includes(".JPEG") || (this.state.SelectedValueImg.includes(".jpeg"))) && !(this.state.SelectedValueImg.includes(".jpg") || (this.state.SelectedValueImg.includes(".JPG")))) && this.state.attachmentPathArr.length == 0 && ImgNo != true) {
                        $('#add-fav-Img').modal('show');
                        $('#add-fav-popup').modal('hide');
                        return;
                    }
                    else {
                        let FavItemBo = {
                            Session_BUSUNIT: this.state.Login_UserBU,
                            Session_USERID: this.state.Login_UserId,
                            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                            ItemId: this.state.FavItemIdPopUp,
                            YourDesc: ItemDescrip != " " && ItemDescrip != "" ? ItemDescrip.toUpperCase() : "",
                            YourCat: ItemCatagory != " " && ItemCatagory != "" ? ItemCatagory.toUpperCase() : "",
                            YourSubCat: ItemSubCategory != " " && ItemSubCategory != "" ? ItemSubCategory.toUpperCase() : "",
                            SDI_Catagory: this.state.FavSDICatgPopUp,
                            txtItemidHide: this.state.txtItemidHidePopUp,
                            txtMFGHide: this.state.txtMFGHidePopUp,
                            txtUOMHide: this.state.txtUOMHidePopUp,
                            txtMfgItemidHide: this.state.txtMfgItemidHidePopUp,
                            SAP: this.state.FavSAP,
                            Manufacturer: this.state.FavMFGPopUp,
                            WorkOrder: $('#WONUM').val(),
                            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",// localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "", sending home store as dafult value for the shipto id(for warhouse item qty check sp)WAL-767-Aparna
                            ImgByteCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                            IsWeb: true,
                            FileNameCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                            SupplierID: this.state.txtMFGHidePopUp,
                            ISCoreCharge: this.state.ISCoreCharge,
                            Kit_Components: this.state.FavKit_Components
                        }
                        console.log("HOME_STORE", CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ")
                        SearchResultsAction.srchcatfavItem(FavItemBo)
                        $('#add-fav-popup').modal('hide');
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        this.setState({ CategoryErr: false, SubCategoryErr: false });
                    }
                }
                else {
                    this.setState({ CategoryErr: ItemCatagory.trim() == "" ? true : false, SubCategoryErr: ItemSubCategory.trim() == "" ? true : false });
                }
            }
            else {
                this.setState({ CategoryErr: ItemCatagory == null || ItemCatagory == undefined ? true : false, SubCategoryErr: ItemSubCategory == null || ItemSubCategory == undefined ? true : false });
            }
        }
        else {
            if (ItemCatagory.trim() != "" && ItemCatagory != null && ItemCatagory != undefined) {
                let FavItemBo = {
                    ItemIdType: "NONCAT",
                    YourDesc: ItemDescrip,
                    YourCat: ItemCatagory,
                    Item_Description: this.state.FavItemDescripPopUp,
                    Item_MFG: this.state.FavMFGPopUp,
                    Session_BUSUNIT: this.state.Login_UserBU,
                    Session_USERID: this.state.Login_UserId,
                    MFG_PartNumber: this.state.FavMFGPartNUMPopUp,
                    img_name: this.state.FavitemImage,
                    UOM: this.state.txtUOMHidePopUp,
                    supplierId: this.state.txtMFGHidePopUp,
                    supplierPartNo: this.state.txtMfgItemidHidePopUp,
                    SAP: this.state.FavSAP,
                    WorkOrder: $('#WONUM').val(),
                    ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                }
                SearchResultsAction.NoncatfavItem(FavItemBo)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.setState({ CategoryErr: false, SubCategoryErr: false });
            }
            else {
                this.setState({ CategoryErr: true });
            }
        }
    }
    FavSuccess = () => {

        const {t}=this.props
        let Status = JSON.parse(SearchResultsStore.FavitemAddList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("Status", Status)
        let Favstatus = Status.ErrorMsg
        if (Favstatus.length > 0) {
            if (Favstatus[0].Error_Msg == "Favorite item inserted sucessfully") {
                //e.preventDefault();
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t('Favorite item inserted sucessfully')
                });
                //alert("Favorite item inserted sucessfully")
                let favsub = Status.FavSubMenu
                //WW-757-Invoke the refresh method in action as there is a delay-Priyanka
                //MenuAction.refreshMasterData();
                //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
                //this.props.history.push({
                //    pathname: `\searchresults`,
                //    search: `?key=${this.state.SearchKeyWord}`
                //});
                //WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna 
                let autoCompleteDataRes = []
                let locsugg = []
                let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
                console.log("Fav_Item_Cat", suggestionsStr)
                if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
                    suggestionsStr.forEach((sugg, index) => {
                        autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
                    });
                }
                let locSubCat = []
                let locSubCatSGG = []
                let subcatsuggestion = CookieService.getLocalStorageValues("FavItem_Cat_SubCat")
                console.log("Fav_Item_SubCat", subcatsuggestion)
                if (subcatsuggestion != null && subcatsuggestion != "" && subcatsuggestion != undefined) {
                    subcatsuggestion.forEach((sugg, index) => {
                        //WW-516_PC_04  (9/30/2022)-Aparna
                        if (sugg.ISA_FAVS_SUBCATEGORY != null) {
                            locSubCat.push({ label: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase(), value: sugg.ISA_FAVS_SUBCATEGORY.toUpperCase() });
                        }

                    });
                }
                if (locSubCat.length > 0) {


                    locSubCatSGG = locSubCat.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.label != null && t.label != " ")) === i)

                }
                this.setState({ autocompleteData: autoCompleteDataRes, subCategory: locSubCatSGG });
                this.setState({ FavoritesSubMenu: favsub })
            }
            else {
                //e.stopImmediatePropagation();
                //e.preventDefault();
                alert(t("Technical Issue Try again"));
            }
        }
    }
    showitemdetails = (qt, index, ItemId, Itemtype, mfg_std, vendor_id, FavItem, event) => {
        /*[06/24/22, PC_WW-390_21]Priyanka D*/
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $('#cheaperitem-popup').modal('hide');
        if (event) {
            event.preventDefault();
        }
        let qtt = ""
        if (qt != null) {
            if (qt.includes('^')) {
                qtt = qt.split('^')[0];
            }
            else {
                qtt = qt;
            }
        }
        let FilteredSearch = this.state.FilteredSearchResults
        let SelectedValue = []
        SelectedValue = FilteredSearch[index]
        /*[05/31/22, PC_WW-401_05]Priyanka D*/
        FilteredSearch[index].txtDesc = FilteredSearch[index].Description + " " + "-InvItemIcon-" + FilteredSearch[index].hasBenItemVal;
        let Itemtypevalue = Itemtype == "" || Itemtype == null ? "CAT" : "NONCAT"
        let Manufactpartnum = SelectedValue.manfPartNumber
        CookieService.updateLocalStorageValues("Session_Noncat", Itemtypevalue);
        let SuggSupplier = this.state.PageLoadSearchResults.filter((item, index) => item.mfg_part_number == Manufactpartnum && item.manufacturer_name == mfg_std);
        //WW-522_PC_01 (12/14/2022)-Aparna
        let locAlternateParts = ""
        if (SelectedValue.alt_part_number != null && SelectedValue.alt_part_number != undefined && SelectedValue.alt_part_number != "NA" && SelectedValue.alt_part_number != "" && SelectedValue.alt_part_number != "\N") {
            locAlternateParts = SelectedValue.alt_part_number
        }
        let TsFavlist = this.state.FavoritesSubMenu;
        CookieService.updateLocalStorageValues("SuggFavItem", TsFavlist);
        CookieService.updateLocalStorageValues("SuggestedSupplierList", SuggSupplier);
        if (Itemtypevalue != "NONCAT") {

            //WW-1378_WW-1382- Update search properties to local storage - Nandhini L
            let SearchUrl = window.location.href
            CookieService.updateLocalStorageValues("SearchUrl", SearchUrl);
            CookieService.updateLocalStorageValues('fromSearch', true);
            CookieService.updateLocalStorageValues('pageNo', this.state.pageNo);
            CookieService.updateLocalStorageValues('GridType', this.state.GridType);
            CookieService.updateLocalStorageValues('itemperpage', this.state.itemperpage);
            CookieService.updateLocalStorageValues('DescriptionType', this.state.DescriptionType);
            CookieService.updateLocalStorageValues('SearchKeyWord', this.state.SearchKeyWord);
            CookieService.updateLocalStorageValues("Search_ItemFav", FavItem);
            CookieService.updateLocalStorageValues("ItemDetail_ItemId", ItemId);
            CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", Manufactpartnum);
            CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", mfg_std);
            CookieService.updateLocalStorageValues("ItemDetail_SupplierID", vendor_id);
            CookieService.updateLocalStorageValues("ItemDetail_QTY", qtt);
            CookieService.updateLocalStorageValues("Search_lblpricetext", SelectedValue.ItemPrice);
            CookieService.updateLocalStorageValues("Search_Descriptiontype", this.state.DescriptionType);
            console.log("ItemDetail_ItemId", CookieService.getLocalStorageValues("ItemDetail_ItemId"))
            CookieService.updateLocalStorageValues("Suppliertree", this.state.SupplierChecked);
            CookieService.updateLocalStorageValues("Manutree", this.state.Manuchecked);
            CookieService.updateLocalStorageValues("AtttreeEx", this.state.expanded);
            CookieService.updateLocalStorageValues("AtttreeCh", this.state.checked);
            CookieService.updateLocalStorageValues("att", this.state.Attrichecked);
            const queryParams = new URLSearchParams(window.location.search)
            const QS_src = queryParams.get('key');
            CookieService.updateLocalStorageValues("QS_src", QS_src);
            CookieService.updateLocalStorageValues("searchTb", $('#searchTb').val());
            //CookieService.updateLocalStorageValues("", FavItem);

            //[2/28/22], PC_IC_10, WW-316, Dhevanesam R
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${ItemId}&ManufacturePartNumber=${Manufactpartnum}&ManufactureName=${mfg_std}&SupplierID=${vendor_id}&QTY=${qtt}`,
                state: { WO: this.state.WorkOrderNo, ItemData: SelectedValue, Suggesstions: false, AlternateParts: locAlternateParts, Orgin: 'Search', equhighlight: this.state.SearchKeyWord }

            });
        }
        else {
            CookieService.updateLocalStorageValues("Search_ItemFav", FavItem);
            CookieService.updateLocalStorageValues("Search_supplierName", SelectedValue.supplierName);
            CookieService.updateLocalStorageValues("Search_lblproductidtext", SelectedValue.clientPartNumber);
            CookieService.updateLocalStorageValues("Search_lblManufacturerName", SelectedValue.manufacturer);
            CookieService.updateLocalStorageValues("Search_lblFeaturestext", SelectedValue.Description);
            CookieService.updateLocalStorageValues("Search_txtClientPartNumber", SelectedValue.clientPartNumber);
            CookieService.updateLocalStorageValues("Search_lblDescriptionText", SelectedValue.longdescriptionone);
            CookieService.updateLocalStorageValues("Search_AttributeName", SelectedValue.AttributeName);
            CookieService.updateLocalStorageValues("Search_AttributeValue", SelectedValue.AttributeValue);
            CookieService.updateLocalStorageValues("Search_lblClientDesc", SelectedValue.clientDesc);
            CookieService.updateLocalStorageValues("Search_lblUOM", SelectedValue.UOM);
            CookieService.updateLocalStorageValues("Search_lblCategory", SelectedValue.UNSPSCCategory);
            CookieService.updateLocalStorageValues("Search_lblManufacturerPartNumber", SelectedValue.manfPartNumber);
            CookieService.updateLocalStorageValues("Search_UNSPSC", SelectedValue.UNSPSC);
            CookieService.updateLocalStorageValues("Search_ThumbnailImage", SelectedValue.ThumbnailImagefile);
            CookieService.updateLocalStorageValues("Search_lblCurrencyCode", SelectedValue.CurrencyCd);
            CookieService.updateLocalStorageValues("Search_btnShowExtndOraDesc", SelectedValue.ExtndDesc);
            CookieService.updateLocalStorageValues("Search_lblpricetext", SelectedValue.ItemPrice);
            CookieService.updateLocalStorageValues("Search_VendorId", SelectedValue.vendor_id);
            CookieService.updateLocalStorageValues("Search_Supplieritemid", SelectedValue.supplier_part_number);
            CookieService.updateLocalStorageValues("ItemDetail_ItemId", ItemId);
            CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", Manufactpartnum);
            CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", mfg_std);
            CookieService.updateLocalStorageValues("ItemDetail_SupplierID", vendor_id);
            CookieService.updateLocalStorageValues("ItemDetail_QTY", qtt);
            CookieService.updateLocalStorageValues("Suppliertree", this.state.SupplierChecked);
            CookieService.updateLocalStorageValues("Manutree", this.state.Manuchecked);
            CookieService.updateLocalStorageValues("AtttreeEx", this.state.expanded);
            CookieService.updateLocalStorageValues("AtttreeCh", this.state.checked);
            CookieService.updateLocalStorageValues("att", this.state.Attrichecked);
            const queryParams = new URLSearchParams(window.location.search)
            const QS_src = queryParams.get('key');
            CookieService.updateLocalStorageValues("QS_src", QS_src);
            CookieService.updateLocalStorageValues("searchTb", $('#searchTb').val());

            //[2/28/22], PC_IC_10, WW-316, Dhevanesam R
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${ItemId}&ManufacturePartNumber=${Manufactpartnum}&ManufactureName=${mfg_std}&SupplierID=${mfg_std}&SupplierID=${vendor_id}&QTY=${qtt}`,

                state: { Suggesstions: false, Orgin: 'Search', equhighlight: this.state.SearchKeyWord }
            });
        }
    }
    /*  showsample = () => {
           let ShowSample = $('#customCheckInfo').is(":checked") ? true : false 
               ShowSampleMessage: ShowSample
           })
           let searchvalue = $('#searchTb').val()
           let FilterType = this.state.FilterValue
           let ManuFilter = []
           ManuFilter = this.state.Manuchecked
           let AttriFilter = []
           AttriFilter = this.state.Attrichecked
           let supplierfilter = []
           supplierfilter = this.state.SupplierChecked
           this.ApplyFilter(searchvalue, FilterType, ManuFilter, AttriFilter, ShowSample, supplierfilter)
   
       //{/*NEW*** (1/25/20201)**CHANGED***(id)** customCheck9--> customCheckInfo***/

    descriptioncahange = (Type) => {

        if (Type != 1) {
            CatalogType = false
            ClientType = true

        }
        else {
            CatalogType = true
            ClientType = false

        }
        this.setState({
            DescriptionType: Type
        })

    }
    EditQuantity = (e, cheaper, Index) => {
        //2204-Search results_ Not able to increase/ decrease quantity once the Quantity is updated manually.-Dhamotharan P
        let filtind = (this.state.pageNo * parseInt($('#itemperpagecount').val()) - parseInt($('#itemperpagecount').val())) + Index;
        const re = SDIConstants.quantityRegEX;
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        let Index2 = FilterdValue.findIndex(x => x.clientPartNumber == PageLSearchResults[filtind].clientPartNumber && x.manfPartNumber == PageLSearchResults[filtind].manfPartNumber);
        let cheaperobj = this.state.cheaperItem;
        if (cheaper == true) {
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0") {
                    cheaperobj.QuantityOrdered = e.target.value;
                    this.setState({ QuantityOrdered: e.target.value, EditedQuantity: true, cheaperItem: cheaperobj });
                }
            }
        }
        else {
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0") {
                    PageLSearchResults[filtind].QuantityOrdered = e.target.value;
                    //Minimum Order Quantity Issue - WW-243, A1QA-136 - Deepthi N H
                    PageLSearchResults[filtind].EditedQuantity = true;
                    PageLSearchResults[filtind].IsQtyChanged = false;

                    FilterdValue[Index2].QuantityOrdered = e.target.value;
                    this.setState({ PageLoadSearchResults: PageLSearchResults, FilteredSearchResults: FilterdValue });
                }
            }
        }

    }
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true,//isFirstTimeLoaded
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_
        };
        MenuAction.getMasterData(masterBO);
    };
    DidyouMeanClick = (key, event) => {
        if (event) {
            event.preventDefault();
        }
        if (key != null && key != "" && key != undefined) {
            let searchkeyvalue = key.replace(/&/g, "%26") //WW-875_PC_01
            searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
            this.props.history.push({
                pathname: `\searchresults`,
                search: `?key=${searchkeyvalue}`,
                state: { ImageSearch: false, ImageFiles: "", image: "" }
            });
            CookieService.updateLocalStorageValues("searchKey", key.trim());
            this.LoadSearchResults()
        }
    }
    mobAdvfiltershow = (event) => {
        if (event) {
            event.preventDefault();
        }
        let ClassAvailable = document.getElementById("Advancefilterdiv").className;
        if (ClassAvailable == "col-sm-4 col-md-6 col-lg-3 my-3 mobile-filter") {
            $('#Advancefilterdiv').addClass('mobile-filter-show');

        }
        else {
            $('#Advancefilterdiv').removeClass('mobile-filter-show');
        }

    }
    ShowFIlter = (key) => {
        if (key == 1) {
            let ClassAvailable = document.getElementById("Manufilter").className;
            // $('#ManufilterIcon').toggleClass('collapsed');
            if (ClassAvailable == 'col-md-12 py-3') {
                $('#Manufilter').addClass('d-none');
                $('#ManufilterIcon').addClass('accordion-heading');
                $('#ManufilterIcon').removeClass('accordian-close');
                $('#headingtwo').removeClass('filter-card-bg');
            }
            else {
                $('#Manufilter').removeClass('d-none');



                $('#ManufilterIcon').removeClass('accordion-heading');
                $('#ManufilterIcon').addClass('accordian-close');
                $('#headingtwo').addClass('filter-card-bg');
                $('#headingthree').removeClass('filter-card-bg');
                $('#headingfour').removeClass('filter-card-bg');
                let AttrClass = document.getElementById("AttriFilter").className;
                if (AttrClass == 'col-md-12 py-3') {
                    $('#AttriFilter').addClass('d-none');



                    $('#AttriFilterIcon').addClass('accordion-heading');
                    $('#AttriFilterIcon').removeClass('accordian-close');
                }
                let Supplierclass = document.getElementById("SupplierFilter").className;
                if (Supplierclass == 'col-md-12 py-3') {
                    $('#SupplierFilter').addClass('d-none');



                    $('#SupplierFilterIcon').addClass('accordion-heading');
                    $('#SupplierFilterIcon').removeClass('accordian-close');
                }
            }
        }
        else if (key == 2) {
            let ClassAvailable = document.getElementById("AttriFilter").className;
            if (ClassAvailable == 'col-md-12 py-3') {
                $('#AttriFilter').addClass('d-none');
                $('#AttriFilterIcon').addClass('accordion-heading');
                $('#AttriFilterIcon').removeClass('accordian-close');
                $('#headingthree').removeClass('filter-card-bg');
            }
            else {
                $('#AttriFilter').removeClass('d-none');
                //$('#AttriFilterIcon').removeClass('collapsed');
                $('#AttriFilterIcon').removeClass('accordion-heading');
                $('#AttriFilterIcon').addClass('accordian-close');
                $('#headingthree').addClass('filter-card-bg');
                $('#headingtwo').removeClass('filter-card-bg');
                $('#headingfour').removeClass('filter-card-bg');
                let Manuclass = document.getElementById("Manufilter").className;
                if (Manuclass == 'col-md-12 py-3') {
                    $('#Manufilter').addClass('d-none');
                    //$('#ManufilterIcon').addClass('collapsed');
                    $('#ManufilterIcon').addClass('accordion-heading');
                    $('#ManufilterIcon').removeClass('accordian-close');
                }
                let Supplierclass = document.getElementById("SupplierFilter").className;
                if (Supplierclass == 'col-md-12 py-3') {
                    $('#SupplierFilter').addClass('d-none');
                    $('#SupplierFilterIcon').addClass('accordion-heading');
                    $('#SupplierFilterIcon').removeClass('accordian-close');



                }
            }
        }
        else if (key == 3) {
            let ClassAvailable = document.getElementById("SupplierFilter").className;
            if (ClassAvailable == 'col-md-12 py-3') {
                $('#SupplierFilter').addClass('d-none');
                $('#SupplierFilterIcon').addClass('accordion-heading');
                $('#SupplierFilterIcon').removeClass('accordian-close');
                $('#headingfour').removeClass('filter-card-bg');
            }
            else {
                $('#SupplierFilter').removeClass('d-none');
                $('#SupplierFilterIcon').removeClass('accordion-heading');
                $('#SupplierFilterIcon').addClass('accordian-close');
                $('#headingfour').addClass('filter-card-bg');
                $('#headingthree').removeClass('filter-card-bg');
                $('#headingtwo').removeClass('filter-card-bg');
                let Manuclass = document.getElementById("Manufilter").className;
                if (Manuclass == 'col-md-12 py-3') {
                    $('#Manufilter').addClass('d-none');
                    $('#ManufilterIcon').addClass('accordion-heading');
                    $('#ManufilterIcon').removeClass('accordian-close');
                }
                let AttrClass = document.getElementById("AttriFilter").className;
                if (AttrClass == 'col-md-12 py-3') {
                    $('#AttriFilter').addClass('d-none');
                    $('#AttriFilterIcon').addClass('accordion-heading');
                    $('#AttriFilterIcon').removeClass('accordian-close');
                }
            }
        }
    }
    //CPW-114_PC_03 -Aparna
    InventoryCheck = (checked, invtype) => {
        let inventory = false
        let truckstock = false
        if (invtype == "W") {
            //  this.setState({
            //     isPageloadValidWO: true
            //  })
            console.log(this.state.isPageloadValidWO)
            if (checked) {
                localStorage.setItem("inventorycheck", true);

                this.BuildSearchResults(true);
                inventory = true
            }
            else {
                localStorage.setItem("inventorycheck", false);
                this.BuildSearchResults(true);
                this.Deselectall("All")
                inventory = false
            }
            this.setState({
                inventory: inventory
            })
        } else {
            this.setState({
                isPageloadValidWO: true
            })
            if (checked) {
                localStorage.setItem("truckStockcheck", true);
                this.BuildSearchResults(true);
                truckstock = true
            }
            else {
                localStorage.setItem("truckStockcheck", false);
                this.Deselectall("All")
                this.BuildSearchResults(true);
                truckstock = false
            }
            this.setState({
                TruckStock: truckstock
            })
        }



    }
    pickupchange = (Type) => {
        let pickUp = false
        let deliveryShipTo = true
        this.setState({
            isPageloadValidWO: true
        })
        if (Type != 1) {
            pickUp = true
            deliveryShipTo = false
            localStorage.setItem("pickupcheck", true);
            this.BuildSearchResults(true);
            cartpickUp = true
        }


        else {
            pickUp = false
            deliveryShipTo = true
            localStorage.setItem("pickupcheck", false);
            this.BuildSearchResults(true);
            cartpickUp = false

        }
        this.setState({
            pickUp: pickUp, deliveryShipTo: deliveryShipTo
        })

    }
    //**************WO # *************
    WOClick = () => {
        let WorkOrderNo = $('#WONUM').val()
        if (!this.state.isValidWO) {//bug :3638 
            if (WorkOrderNo != "" && WorkOrderNo != null && WorkOrderNo != undefined) {
                if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                    let THIRDPARTY_COMP_ID = ""
                    if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                        THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                    }
                    let BO = {
                        workOrder: WorkOrderNo,
                        Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                        User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"), //WW-336-PC_06 CBRE WO# validation is not working for SDI Users (1/18/2022)  -Aparna
                        is_WO_Parts_Needed: true
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    SearchResultsAction.supplierOrderEntryPageLoad(BO)
                }
                else {
                    if (this.state.IsProblemCodeSearch == true) {
                        this.setState({ ProblemCodeSearch: true })
                    }

                    $("#WorkOrderNo").addClass("disabledbutton");
                    this.setState({ WOmsg: false, WorkOrderNo: $('#WONUM').val(), isValidWO: true, isPageloadValidWO: false });
                }
            }
        }
        //else {
        //    this.setState({ WOmsg: true });
        //    //alert("Enter valid Work Order Number");
        //    return;
        //}


    }
    /*[07/20/22,BUG:2374-Validation message should be emptied when the user closees the popop and reopen again], Priyanka D */
    WOpopup = () => {
        this.setState({
            WOmsg: ""
        })
        $('#WorkOrder').modal('show');
    }
    /*[04/22/22,PC_WW-365_02], Priyanka D */
    ClearWO = () => {
        let needPageLoad = CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' ? (CookieService.getLocalStorageValues("Session_STATE") != CookieService.getLocalStorageValues("Session_WO_STATE") ? true : false) : false; //WW-1231 WO State Restriction - for pageload on WO clear -Vishwa S
        localStorage.removeItem('WONum')
        localStorage.removeItem('WOAssetID') /*[04/10/23, PC_4247_10 - To remove the localStorage Item "WOAssetID", Vishwa S]*/
        localStorage.removeItem('StoreValue')
        localStorage.removeItem('WO_Parts')//BUG:3618 -Aparna
        //[10/18/22, WAL - 785 Getting Asset Tag and storing in a cookie value, Dhevanesam R
        CookieService.updateLocalStorageValues("AssetTag", "");
        CookieService.updateLocalStorageValues("AssetID", "");
        CookieService.updateLocalStorageValues("Trade", "");
        CookieService.updateLocalStorageValues("Category", "");
        CookieService.updateLocalStorageValues("Make", "");
        CookieService.updateLocalStorageValues("Model", "");
        // CookieService.updateLocalStorageValues("WO_Parts", "");//BUG:3618 -Aparna
        CookieService.updateLocalStorageValues("WO_Address", "");
        CookieService.updateLocalStorageValues("WO_Priority", "");
        localStorage.removeItem('WOAssetTag')
        CookieService.updateLocalStorageValues("WO_Make", "");
        CookieService.updateLocalStorageValues("WO_Model", "");
        CookieService.updateLocalStorageValues("Session_WO_STATE", ""); //WW-1231 WO State Restriction -Vishwa S
        $(`#WONUM`).val('');
        // $("#WONUM").removeClass("disabledbutton"); //WW-742_PC_11 -Aparna
        let work = this.state.isValidWO

        //WW-1374 problem code search - Nandhini L 
        CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);

        if (this.state.IsProblemCodeSearch == true) {
            this.setState({ ProblemCodeSearch: true })
        }

        this.setState({ StoreValue: null, WorkOrderNo: "", isValidWO: false, WO_Parts: [], WONum: "", IsProblemCodeSearch: false })
        //WW-383_PC_05 (5/12/2022)-Aparna
        //WW-1231 removing the BuildSearchResults call since no need of re-bind the page on clearing WO -Vishwa S
        //localStorage.setItem("inventorycheck", false);
        //this.BuildSearchResults(true)
        //WW-1231 WO State Restriction - for pageload on WO clear -Vishwa S
        if (needPageLoad) {
            this.LoadSearchResults()
        }
    }
    WOClose = () => {
        $('#WorkOrder').modal('hide');
        {/**A1QA-131_PC_03 Users Without WO Should Not Be Able To See Inventory Items -Aparna*/ }
        $('#WONUM').val(JSON.parse(localStorage.getItem("WONum")))
    }
    /*[07/20/22,BUG:2374-Validation message should be emptied when the user closees the popop and reopen again], Priyanka D */
    handleWOnum = (event) => {
        const onlyNumbers = SDIConstants.quantityRegEX;
        if (event.target.value === '' || onlyNumbers.test(event.target.value)) {
            this.setState({
                WOmsg: "", WONum: event.target.value
            })
        }
    }


    //WW-1216 Precart - Yuvarani K
    AddToCartOrFavClick = (CartOrFav, value, index, popup, Reasontype, Comments) => {
        ItemArray = value
        //[12/15/22], PC_WW-552_FE_4, Dhevanesam R
        CookieService.updateLocalStorageValues("AddIndex", index);
        CookieService.updateLocalStorageValues("AddValue", value);
        console.error("DivisTestAddValue", CookieService.getLocalStorageValues("AddValue"))
        console.error("DivisTestOnlyValue", value)
        this.setState({ AddIndex: index, AddValue: value });

        //debugger
        let formName = "";
        if (value.AttributeName != undefined && value.AttributeName != null && value.AttributeName != "" && value.AttributeName.includes('FORM')) {
            formName = value.form.trim()
        }

        if (CartOrFav == "Add To Cart") {
            if (value.AttributeName.includes('FORM')) {
                if (formName != null && formName != "" && formName != undefined) {
                    //if (formName.toLowerCase().includes("battery") || formName.toLowerCase().includes("charger")) {
                    //    FormDataProps = []
                    //    FormOptionsDataProps = []
                    //    this.AddToCart(value, index, false);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
                    //}
                    // else {
                    let dynamicFormBO = {
                        formName: formName
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    SearchResultsAction.Search_dynamicFormData(dynamicFormBO);
                    //  }
                }

                else {
                    FormDataProps = []
                    FormOptionsDataProps = []
                    this.AddToCart(ItemArray, index, popup, Reasontype, Comments)
                    //WW -694_PC_04(to make sure not from core charge popup) - Aparna
                }
            }
            else {
                FormDataProps = []
                FormOptionsDataProps = []
                this.AddToCart(ItemArray, index, popup, Reasontype, Comments);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
            }
        }

    };

    Workorderresponse = () => {

        let Workorderresponse = JSON.parse(SearchResultsStore.workorderresponse);
        let localasset = "";
        let workorder = [];
        let localstore = "";
        let storeval = "";
        let localWON = $('#WONUM').val();
        let loacalloc = "";
        let LWOmsg = false;
        /*[01/06/22, PC_SC_22,WW-283], Priyanka D*/
        let BilltoStoreLocationLat = 0;
        let BilltoStoreLocationLong = 0;
        let BilltoStore = "";
        let lat = 0;
        let long = 0;
        console.log("workorder", Workorderresponse);
        if (Workorderresponse.WOResponse) {
            if (Workorderresponse.WOResponse.length > 0) {
                /*[04/10/23, PC_4247_09 - To store AssetID in localStorage, Vishwa S]*/
                if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                    localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID);
                    localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);
                    if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                        CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);
                    } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                        CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);
                    }
                }
                workorder = Workorderresponse.WOResponse;
                // $("#WONUM").addClass("disabledbutton"); //WW-742_PC_12
                /*[12/24/21, PC_SC_07], Priyanka D//Updating the Location storage*/
                let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
                CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
                CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
                localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                //CookieService.updateLocalStorageValues("Session_STATE", Workorderresponse[0].STATE);
                //[10/18/22, WAL - 785 Getting Asset Tag and storing in a cookie value, Dhevanesam R
                CookieService.updateLocalStorageValues("AssetTag", Workorderresponse.WOResponse[0].AssetTag);
                console.log("AssetTag", CookieService.getLocalStorageValues("AssetTag"))
                CookieService.updateLocalStorageValues("AssetID", Workorderresponse.WOResponse[0].AssetID);
                CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
                //WW-591_PC_03 -Aparna
                CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
                CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
                CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
                CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
                CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
                //WW-1231 Work order state updation -Vishwa S
                CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
                CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO);//Set stating the ship to as ISBlanketWOwhen the user selects the ship to as W09301
                CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1)
                console.log("WO_Category", CookieService.getLocalStorageValues("WO_Category"));
                console.log("WO_Priority", CookieService.getLocalStorageValues("WO_Priority"));


                //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
                CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                if (this.state.IsProblemCodeSearch == true) {
                    this.setState({ ProblemCodeSearch: true })
                }

                let locWO_parts = []
                if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                    if (Workorderresponse.WOParts.length > 0) {
                        //CookieService.updateLocalStorageValues("WO_Parts", Workorderresponse.WOParts);
                        localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts)) //BUG:3618 -Aparna
                        locWO_parts = Workorderresponse.WOParts
                        //WW-1231 to display the WO parts popup when the user state is same as WO state -Vishwa S
                        if (CookieService.getLocalStorageValues("Session_STATE") == Workorderresponse.WOResponse[0].STATE) {
                            $('#WO_Parts_Popup').modal('show');
                        }
                    }
                }
                this.setState({ WO_Parts: locWO_parts, isValidWO: true, isPageloadValidWO: false })
                if (Workorderresponse.WOResponse[0].LOCATION != "" && Workorderresponse.WOResponse[0].LOCATION != null && Workorderresponse.WOResponse[0].LOCATION != undefined && Workorderresponse.WOResponse[0].LOCATION != " ") {
                    /*[01/06/22, PC_SC_22,WW-283], Priyanka D*/
                    localstore = Workorderresponse.WOResponse[0].ADDRESS1
                    loacalloc = Workorderresponse.WOResponse[0].LOCATION;
                    storeval = Workorderresponse.WOResponse[0].DESCR;
                    let BenPickLbl = localstore + " " + "-" + " " + loacalloc
                    BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                    BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                    BilltoStore = Workorderresponse.WOResponse[0].DESCR_AC;
                    if (loacalloc != null && loacalloc != undefined) {
                        localStorage.setItem("ShipToID", JSON.stringify(loacalloc));
                        let WO = JSON.stringify(localWON)
                        localStorage.setItem("WONum", (JSON.stringify(localWON)).substring(1, WO.length - 1));
                        localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                        /*[01/06/22, PC_SC_22,WW-283], Priyanka D*/
                        localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                        localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                        localStorage.setItem("BiltoStoreValue", BilltoStore);
                        localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
                        localStorage.setItem("BenPickLbl", JSON.stringify(BenPickLbl));
                    }
                    $('#WorkOrder').modal('hide');
                    console.log("ShipToID", loacalloc);
                    //WW-1231 WO State Restriction -Vishwa S
                    if (CookieService.getLocalStorageValues("Session_STATE") != Workorderresponse.WOResponse[0].STATE) {
                        //WW-1216 Precart - Yuvarani K
                        let imagesearch = this.props ?.location ?.state ?.ImageSearch
                        if (imagesearch) {
                            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                            let ImgFiles = this.props?.location?.state?.ImageFiles;
                            SearchResultsAction.ImgaddAttachment(ImgFiles);

                        }
                        else {
                            this.LoadSearchResults()
                        }
                    }
                    this.setState({
                        WOmsg: false, WorkOrderNo: localWON, StoreValue: loacalloc
                    })

                }



                else {
                    this.setState({ WOmsg: true })
                    // $("#AssetID").attr("disabled", true);
                    //alert("Enter valid Work Order No")
                }


            } else {

                alert("Enter Valid Work Order #")
            }



        }
        else {

            alert("Enter Valid Work Order #")
        }




    }
    //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
    calcWorkingDaysNew(shipwithin) {

        let count = 0;
        let today = new Date()
        console.log("today's date", today)
        console.log("no.of days", shipwithin)
        while (count < shipwithin) {
            if (today.getDay() != 0 && today.getDay() != 6) // Skip weekends
            {
                count++;
            }
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            today.setDate(today.getDate() + 1);
        }
        //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
        today.setDate(today.getDate() - 1);
        let td = this.handledate(today);
        let Sampletest = "" + td
        return Sampletest;
    }
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            document.getElementById("lblerror").innerText = "";
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArr: tempAttachments });
            rmvAttachindex = -1;
        }
    };
    bindAttachments = () => {
        return this.state.attachmentPathArr.map((attachment, index) => {
            return (
                <div className="attachment-file-name mt-2 col-md-4 p-0" key={index}>
                    <a className="noncat-Attachment-overflow" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                    <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X</span>
                </div>
            );
        });
    };
    onInputClick = (event) => {
        event.target.value = ''
    }
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    /**
     * Ref: NC_PC_13
     * On click method of removing attachments
     * @param filepath
     * @param index
     */
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }
    handleAttachment = (event) => {

        let files = event.target.files;
        console.log("event", files);
        if (this.state.attachmentPathArr != undefined) {

            if (this.state.attachmentPathArr.length < 1) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                NonCatalogAction.addAttachment(files);
            } else {

                let lblerror = "You can choose only one Image"
                document.getElementById("lblerror").innerText = lblerror;
            }

        } else {
            document.getElementById("lblerror").innerText = "";
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addAttachment(files);
        }
    };
    workorderfail = () => {
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: 'Enter Valid Work Order #'
        });
        //this.setState({ })
        $(`#WONUM`).val('');
        // $("#WONUM").removeClass("disabledbutton")//WW-742_PC_13 -Aparna
        this.setState({ WorkOrderNo: "", WOmsg: true, WONum: "", isValidWO: false });
    }
    //****************END************
    /*[01/30/22, PC_EF_06, Priyanka.D]*/
    EnersysyEmp = (EnersysEmp) => {
        if (EnersysEmp == "No") {
            $('#NotanEnersysEmp').modal('show');
        } else if (EnersysEmp == "Yes") {
            $('#EnersysEmployee').modal('hide');
            let AddToCartBO = {
                ItemDetails: this.state.OrderCatalogItem,
                NonItemDetails: this.state.OrderNonCatalogItem,
                Session_BUSUNIT: this.state.Login_UserBU,
                Session_USERID: this.state.Login_UserId,
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                Session_ImageLocPath: "",
                Session_PUNCHIN: "False",
                MobileAPICall: false,
            }

            this.props.history.push({

                pathname: "/EnersysForm",
                state: { item: AddToCartBO, qty: CookieService.getLocalStorageValues("QTY"), product: CookieService.getLocalStorageValues("EnersysFormVaue"), WO: this.state.WorkOrderNo, pagename: 'SearchResult', searchKey: this.state.SearchKeyWord, form: CookieService.getLocalStorageValues("EnersysForm") }
            });

        }
    }
    /*18/10/23, PC_WW_850_06 - To expand and collapse the Description, Vishwa S]*/
    handleDotclick = (ItemIndex, Action) => {
        if (Action === "More") {
            this.state.IsDotClickIndex.push(((this.state.pageNo - 1) * this.state.itemperpage) + ItemIndex)
            this.setState({ IsDotClick: true })
        }
        else if (Action === "Less") {
            let index = this.state.IsDotClickIndex.indexOf(((this.state.pageNo - 1) * this.state.itemperpage) + ItemIndex);

            if (index !== -1) {
                this.state.IsDotClickIndex.splice(index, 1);
                this.setState({ IsDotClick: true })
            }
        }
    }
    /*[01/30/22, PC_EF_08, Priyanka.D]*/
    NotAnEnersysyEmp = () => {
        $('#NotanEnersysEmp').modal('hide');
    }
    //WAL-1034_PC_40 -Aparna
    AnykeyWOPress(e) {
        if (e.keyCode == 13) {
            this.WOText.current.blur();
            this.WOClick();
        }
    };

    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentYes = () => {
        $('#SearchMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        // Equipment item add to cart issue fixing - Nandhini L
        if (mixcartfunction == true) {
            this.AddToCart(this.state.value, this.state.index, this.state.fromCorePopup, this.state.ReasonType, this.state.Comments);
        } else {
            this.TradeServiceAddClick("", this.state.value, this.state.IsFav, this.state.ISKitCore);
        }

    };

    //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    handleEquipmentNo = () => {
        $('#SearchMixedOrderConfirmPopup').modal('hide'); // Hide the equipment modal
        cartDelete = false;
    };

    TradeServiceAddClick = (e, value, IsFav, IsKitCore) => {
        this.setState({ AddValue: value })
        const { t } = this.props
        //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        let hasEquipmentItem = [];
        let hasQuoteItem = [];
        mixcartfunction = false;
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
        }

        //[11/22/22], CR - 2935 - To alert the user when the user tries to add the item to cart with empty qty, Dhevanesam R
        if (parseInt(value.QuantityOrdered) == "0" || parseInt(value.QuantityOrdered) == 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Cannot Be Zero')
            });
            return;
        }
        else if (value.QuantityOrdered == "") {
            debugger
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Should Not Be Empty')
            });
            return;
        }
        else if (parseInt(value.QuantityOrdered) < parseInt(value.min_order_qty)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Quantity Entered Is Below The Minimum Order Quantity'
            });
            return;
        }
        else if ((parseInt(value.QuantityOrdered) % parseInt(value.min_order_qty)) != 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Entered Quantity Does Not Match the Minimum Order Quantity Sequence'
            });
            return;
        }
        else if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
            $('#SearchMixedOrderConfirmPopup').modal('show');
            this.setState({ value: value, IsFav: IsFav, IsKitCore: IsKitCore, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
            return;
        }
        else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
            $('#SearchMixedOrderConfirmPopup').modal('show');
            this.setState({ value: value, IsFav: IsFav, IsKitCore: IsKitCore, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
            return;
        }
        else if (value.IsKit == true) {
            this.KitSearchAddClick(value, IsKitCore)

        }
        else {
            if (value.AttributeName.includes("FORM")) {
                let formItem = cartItems.filter(item => item.Itemid === value.clientPartNumber && item.SupplierPartNumber === value.supplier_part_number && item.SupplierID == value.vendor_id && item.Manufacturerpartnumber === value.manufacturer_part_number && item.Manufacturer === value.manufacturer_name);
                if (formItem.length > 0 && formItem[0].FilePath && formItem[0].FilePath.length == 10) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t('This item is already in the cart and has reached the maximum number of 10 forms')
                    });

                    return true;
                }
            }

            let ImageFiles = this.props?.location?.state?.ImageFiles;
            let IsImageSearch = this.props?.location?.state?.ImageSearch;
            let ImageUrl = this.props?.location?.state?.image
            let Mfg = value.mfg_part_number;
            let mfgName = value.manufacturer_name;
            let longDesc = value.longdescriptionone;
            let FromFavClick = "No";
            let FromPage = "SearchResult";
            let SupplierName = value.supplierName;
            let qtyadj = value.QuantityOrdered;
            let SuggSupplier = this.state.PageLoadSearchResults.filter((item, index) => item.mfg_part_number == value.mfg_part_number && item.manufacturer_name == value.manufacturer_name);
            let TsFavlist = this.state.FavoritesSubMenu;
            CookieService.updateLocalStorageValues("SuggFavItem", TsFavlist);
            CookieService.updateLocalStorageValues("SuggestedSupplierList", SuggSupplier);
            CookieService.updateLocalStorageValues("ChosenSupplier", SupplierName);
            CookieService.updateLocalStorageValues("ChosenMFGName", mfgName);
            CookieService.updateLocalStorageValues("ChosenItemId", value.clientPartNumber);
            //Pass the Values in Props as we are getting Exception when we pass spl character in query string-Priyanka-INC0013356
            let ShipmentMethod = localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false;

            //WW-1378_WW-1382- Update search properties to local storage - Nandhini L
            let SearchUrl = window.location.href
            CookieService.updateLocalStorageValues("SearchUrl", SearchUrl);
            CookieService.updateLocalStorageValues('fromSearch', true);
            CookieService.updateLocalStorageValues('pageNo', this.state.pageNo);
            CookieService.updateLocalStorageValues('GridType', this.state.GridType);
            CookieService.updateLocalStorageValues('itemperpage', this.state.itemperpage);
            CookieService.updateLocalStorageValues('DescriptionType', this.state.DescriptionType);

            this.props.history.push({
                pathname: `\suppliersuggestionpage`,
                search: `?ManufacturePartNumber=${Mfg}&ManufactureName=${mfgName}&SearchKey=${this.state.SearchKeyWord}&IsFromFav=${FromFavClick}&FavItemPage=${FromPage}&WO=${this.state.WorkOrderNo}&qtyadj=${qtyadj}&Suppliername=${SupplierName}`,
                state: { ManufacturePartNumber: Mfg, ImageFiles: ImageFiles, ImgURL: ImageUrl, IsImageSearch: IsImageSearch, ManufactureName: mfgName, SearchKey: this.state.SearchKeyWord, WO: this.state.WorkOrderNo, origin: 'search', IsPickup: ShipmentMethod, IsFromFav: 'No', FavItemPage: FromPage, Suppliername: SupplierName, qtyadj: qtyadj, cartDelete: cartDelete }
            });
            //this.setState({ SupplierSuugMFG: Mfg, SupplierSugMfgName: mfgName, SuppIsFromFav: FromFavClick, SuppFavItemPage: FromPage, SuppLongDesc: longDesc, ShowSupplierSugg:true });
            //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
            //history.push({
            //    pathname: '\suppliersuggestionpage'
            //})
            //$('#SupplierSuggestionId').modal('show');
        }
    }
    KitSearchAddClick = (value, IsKitCore) => {

        let Kit_Component = JSON.parse(value.kit_Items)
        if (Kit_Component != "" && Kit_Component != undefined && Kit_Component != null) {
            if (IsKitCore == false) {
                let IsCore = false
                let Kit_Items = Kit_Component
                Kit_Items.map((value, index) => {
                    if (value.IsCore == true) {
                        IsCore = true
                    }

                })
                if (IsCore == true) {
                    $('#CoreChargePopUp').modal('show');
                }


            }

            let KitItems = []
            const queryParams = new URLSearchParams(window.location.search)
            //const QS_src = queryParams.get('key');
            //*******getting cookie value for the saerch key**
            let QS_srcs = queryParams.get('key');
            Kit_Component.forEach((val) => {
                KitItems.push(val.SupplierPartNumber);

            });
            let KitBO = {

                Session_USERID: this.state.Login_UserId,
                Session_BUSUNIT: this.state.Login_UserBU,
                AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                CurrentPage_URL: "/SDIXZEUS/searchResults",
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_SearchQuery: " ",
                Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                SearchValue: "",
                Query_SITE: "",
                Query_USERID: this.state.Login_UserId,
                Query_Key: QS_srcs,
                Query_Opt: "",
                chbCat: true,
                chbNonCat: true,
                Catagorylist: [],//CatagoryList,	
                Make: "",
                Model: "",
                AssetId: "",
                SupplierIdList: [],
                ManufacturerList: [],
                WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
                ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                FavYourCatg: "",
                Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
                SOURCE: "WEB",
                IsSupplierSearch: true,
                KitQty: value.QuantityOrdered,
                MachineNo: "",
                KitOrderLocation2: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                KitOrderType: "",
                KitItem: value.kit_Items,
                IsKitSearch: true,
                IsAddtoCartWeb: true,
                ItemIdList: KitItems,
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                EquipmentDelete: cartDelete,
                Interactive: false





            }
            SearchResultsAction.GetCheaperItem(KitBO);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');


        }

    }



    //WAL-1034_PC_10
    WO_Parts_ButtonClick = () => {
        $('#WO_Parts_Popup').modal('show');
    }

    WOHistoryClose = () => {
        $('#WO_Parts_Popup').modal('hide');
        //Ticket No-5614 regression test bug closing the pop up and updating a state as true [4/10/2025] - Nachiappan.
        this.setState({ isPageloadValidWO: true });
    }

    //WW-1374 problem code search - Nandhini L 
    onChangePC = (e) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            const woNum = localStorage.getItem("WONum");
            CookieService.updateLocalStorageValues("IsProblemCodeSearch", true);
            if (woNum) {
                this.LoadSearchResults()
            }
            this.setState({ ProblemCodeSearch : true})
        } else {
            CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);
            this.setState({ PageLoadSearchResults: [], FilterValuedata: [], IsProblemCodeSearch: false, ProblemCodeSearch: true });
        }
    }

    render() {
        const { t } = this.props

        //WW-1374 problem code search - Nandhini L 
        let descriptionToShow;
        let desc = CookieService.getLocalStorageValues("Description") ? CookieService.getLocalStorageValues("Description") : "";
        let IsProblemCodeSearch = CookieService.getLocalStorageValues("IsProblemCodeSearch") ? CookieService.getLocalStorageValues("IsProblemCodeSearch") : false

        if (!this.state.isExpanded && desc?.length > 110) {
            descriptionToShow =desc.substring(0, 110) + '...';
        } else {
            descriptionToShow = desc;
        }

        let pickupchk = localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false
        let invenchk = localStorage.getItem("inventorycheck") != null ? JSON.parse(localStorage.getItem("inventorycheck")) : false
        let Greaterthan99 = "99+";
        let ImageSearch = CookieService.getLocalStorageValues("ImageSearch") ? CookieService.getLocalStorageValues("ImageSearch") : this.props?.location?.state?.ImageSearch


        return (<React.Fragment>
            <div className="container-fluid content-margin content-section">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title">
                            <Trans>Search Result</Trans>
                        </h5>
                    </div>

                    {this.state.PageLoadSearchResults.length < 1 && !this.state.ShowDidyoumean ? (
                        <>
                            <div className="col-sm-4 col-md-6 col-lg-3 my-3 mobile-filter" id="Advancefilterdiv">
                                <div id="accordion" className="accordion-container filters-search">
                                    <h6 className="accordion-title mb-0">
                                        <Trans>Filter</Trans>
                                    </h6>
                                    <div className="card border-0">
                                        <div className="row col-md-12 ">
                                            <h5 className="col-md-12 p-0 search-category d-block mt-4 title-font ml-1" style={{ fontSize: "15px" }}>
                                                <Trans>Shipment Method</Trans>
                                            </h5>

                                            <label className="custom-radiobtn ">
                                                <Trans>Pickup</Trans>
                                                <input
                                                    type="radio"
                                                    id="pick"
                                                    checked={this.state.pickUp}
                                                    name="dev1"
                                                    onChange={() => this.pickupchange(0)}
                                                />
                                                <span className="checkmark checkmark-org" style={{ top: "1px", left: "3px" }} />
                                            </label>
                                            <label className="custom-radiobtn pb-3 mb-0 ">
                                                <Trans>Ship To</Trans>
                                                <input
                                                    type="radio"
                                                    id="ship"
                                                    checked={!this.state.pickUp}
                                                    name="dev"
                                                    onChange={() => this.pickupchange(1)}
                                                />
                                                <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                            </label>
                                        </div>

                                        <div className="row pl-1">
                                            <div className="col-12">
                                                <div className="row">
                                                    <label className="title-font col-lg-6 col-3 p-1 ml-2" style={{ fontSize: "15px" }}>
                                                        <Trans>Warehouse</Trans>
                                                    </label>
                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            className="cust-toggle"
                                                            onChange={() => this.InventoryCheck(!this.state.inventory, "W")}
                                                            checked={this.state.inventory}
                                                        />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row pl-1">
                                            <div className="col-12">
                                                <div className="row">
                                                    <label className="title-font col-lg-6 col-3 p-1 ml-2" style={{ fontSize: "15px" }}>
                                                        <Trans>Truck Stock</Trans>
                                                    </label>
                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            className="cust-toggle"
                                                            onChange={() => this.InventoryCheck(!this.state.TruckStock, "T")}
                                                            checked={this.state.TruckStock}
                                                        />
                                                        <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-8 col-md-12 col-lg-9 mt-3">
                                {(IsProblemCodeSearch == false && this.state.ProblemCodeSearch == false) && (
                                    <div className="d-block">
                                        <h5 className="search-category title-font mb-2 mr-2 float-left">
                                            <Trans>You searched for </Trans>:
                                        </h5>

                                        <h5 className="mx-2 ml-2 search-category title-font light-gray-text">
                                            {this.state.SearchKeyWord}
                                        </h5>
                                    </div>

                                )}

                                <div className="col-12 col-lg-12 py-2  search-histroy-parent">
                                    <div className="row">
                                        <div className="search-histroy-page">
                                            <div className="custom-search-histroy-container d-flex">
                                                <div className="input-group search-histroy-field">
                                                    <div className="search-filed-section position-relative">
                                                        <input
                                                            type="text"
                                                            className={`form-control ${this.state.isValidWO ? "disabledbutton" : ""}`}
                                                            placeholder={t("Enter WO#")}
                                                            id="WONUM"
                                                            maxLength="9"
                                                            onKeyDown={this.AnykeyWOPress}
                                                            ref={this.WOText}
                                                            pattern="[0-9]*"
                                                            value={this.state.WONum}
                                                            onChange={this.handleWOnum}
                                                        />

                                                        {this.state.WONum && (
                                                            <span
                                                                src="images/cancel-icon-black.svg" alt="cancel-icon-black"
                                                                className="search-histroy-field-cancel-btn search-cancel-header cursor-pointer"
                                                                style={{ right: "6px" }}
                                                                onClick={() => this.ClearWO()}
                                                            >
                                                            </span>
                                                        )}
                                                    </div>
                                                    <button className="btn search-histroy-field-btn" onClick={() => this.WOClick()} type="button">
                                                        <img className src="Images/black-search-icon.svg" alt="search" /></button>
                                                </div>


                                                {this.state.isValidWO && this.state.WO_Parts.length > 0 && (
                                                    <button
                                                        className="btn custom-btn-primary primary-btn w-sm-100 history-btn"
                                                        onClick={(e) => this.WO_Parts_ButtonClick(e)}
                                                        id="EditFavLink"
                                                    >
                                                        <img src="Images/history_icon.svg" alt="bin-icon" className="history-btn-icon" /><Trans> WO# History</Trans>
                                                    </button>
                                                )}
                                            </div>

                                            <div className={`work-order-switcher d-flex ${this.state.isValidWO == false ? "disabled" : ""}`}>
                                                <span>Suggested item(s) for the work order</span>
                                                <div className="form-check form-switch d-flex align-items-center me-4 pl-1">
                                                    <label className="switch">
                                                        <input
                                                            id= "PcToggleInput"
                                                            type="checkbox"
                                                            className="cust-toggle"
                                                            onChange={(e) => this.onChangePC(e)}
                                                            checked={this.state.IsProblemCodeSearch}
                                                            disabled={this.state.isValidWO == false}
                                                        />
                                                        <span id="PcToggleSpan" className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <span
                                            className="errorspan12 text-left mt-2"
                                            id="StatusMsgbilltostore"
                                        ></span>

                                        {this.state.isValidWO && (
                                            <>
                                                <div className="custom-work-order-store-trade">
                                                    <div className="search-result-logo-container justify-content-center d-flex">
                                                        <img src="Images/walmart-image.png" alt="" className="w-100" />
                                                    </div>
                                                    <div className="search-result-details">
                                                        <div>
                                                            <label htmlFor="" className="font-14 mb-1 ">Work order trade :</label>
                                                            <p className="font-14 m-0 sub-content">{CookieService.getLocalStorageValues("Trade") || "-"}</p>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="" className="font-14 mb-1">Work order store :</label>
                                                            <p className="font-14 m-0 sub-content">{localStorage.getItem("StoreValue") ? JSON.parse(localStorage.getItem("StoreValue")) : "-"}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="custom-problem-code-section">
                                                    <p><span className="title">Problem code:</span> {descriptionToShow || "-"}
                                                        {desc?.length > 110 && (
                                                            <span
                                                                className="toggle-description view-details-item cursor-pointer ml-2"
                                                            >
                                                                <a
                                                                    className="view-details-items"
                                                                    onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
                                                                >
                                                                    {this.state.isExpanded ? "Show less" : "Show more"}
                                                                </a>
                                                            </span>
                                                        )}
                                                    </p>

                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="border-top pt-2" > </div>
                            </div>
                        </>
                    ) : null}                    


                    {this.state.PageLoadSearchResults.length < 1 &&
                        this.state.ShowDidyoumean != false ? (
                        <>
                            <div
                                    className="col-sm-4 col-md-6 col-lg-3 my-3 mobile-filter"
                                id="Advancefilterdiv"
                            >
                                <div id="accordion" className="accordion-container filters-search">
                                    <h6 className="accordion-title mb-0">
                                        <Trans>Filter</Trans>
                                    </h6>
                                    <div className="card border-0">
                                        <div className="row col-md-12 ">
                                            <h5
                                                className="col-md-12 p-0 search-category d-block  mt-4 title-font float-right ml-1"
                                                style={{ fontSize: "15px" }}
                                            >
                                                <Trans>Shipment Method</Trans>
                                            </h5>

                                            <label className="custom-radiobtn ">
                                                <Trans>Pickup</Trans>
                                                <input
                                                    type="radio"
                                                    id="pick"
                                                    checked={this.state.pickUp == true ? true : false}
                                                    name="dev1"
                                                    onChange={() => this.pickupchange(0)}
                                                />
                                                <span
                                                    className="checkmark checkmark-org"
                                                    style={{ top: "1px", left: "3px" }}
                                                />
                                            </label>
                                            <label className="custom-radiobtn pb-3 mb-0 ">
                                                <Trans>Ship To</Trans>
                                                <input
                                                    type="radio"
                                                    id="ship"
                                                    checked={this.state.pickUp == false ? true : false}
                                                    name="dev"
                                                    onChange={() => this.pickupchange(1)}
                                                />
                                                <span
                                                    className="checkmark checkmark-org"
                                                    style={{ top: "2px", left: "2px" }}
                                                />
                                            </label>
                                        </div>

                                        <div className="row pl-1">
                                            <div className="col-12">
                                                <div className="row">
                                                    <label
                                                        className="title-font col-lg-6 col-3 p-1 ml-2"
                                                        style={{ fontSize: "15px" }}
                                                    >
                                                        <Trans>Warehouse</Trans>
                                                    </label>

                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            className="cust-toggle"
                                                            onChange={() => this.InventoryCheck(!this.state.inventory, "W")}
                                                            checked={this.state.inventory}
                                                        />
                                                            <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row pl-1">
                                            <div className="col-12">
                                                <div className="row">
                                                    <label
                                                        className="title-font col-lg-6 col-3 p-1 ml-2"
                                                        style={{ fontSize: "15px" }}
                                                    >
                                                        <Trans>Truck Stock</Trans>
                                                    </label>

                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            className="cust-toggle"
                                                            onChange={() =>this.InventoryCheck(!this.state.TruckStock, "T")}
                                                            checked={this.state.TruckStock}
                                                        />
                                                            <span className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                <div className="col-sm-8 col-md-12 col-lg-9 mt-3 float-left">
                                {(IsProblemCodeSearch == false && this.state.ProblemCodeSearch == false) && (
                                    <div className="d-block">
                                        <h5 className="search-category title-font mb-2 mr-2 float-left ">
                                            <Trans>You searched for </Trans>:
                                        </h5>

                                        <h5 className="mx-2 ml-2 search-category title-font light-gray-text">
                                            {this.state.SearchKeyWord}
                                        </h5>
                                    </div>
                                )}

                                {(!ImageSearch && (IsProblemCodeSearch == false && this.state.ProblemCodeSearch == false)) ? (
                                    <div className="d-block">
                                        <h5 className="search-category d-block title-font font-14 font-regular">
                                            Did you mean <span>:</span>
                                            <a
                                                href="#"
                                                className="suggested-txt mx-2"
                                                onClick={(e) => this.DidyouMeanClick(this.state.DidyouMean1, e)}
                                            >
                                                {this.state.DidyouMean1}
                                            </a>
                                        </h5>
                                    </div>
                                ) : null}
                                <div className="col-lg-12">
                                    {ImageSearch ? (
                                        <div className=" mb-1 pl-1">
                                            <img src={ImageURL} width={50} height={50} />
                                            <span
                                                class="Img-txt cursor-pointer mt-2 ml-3"
                                                onClick={(e) => this.ManufactureDetails_click()}
                                            >
                                                <Trans>Matching part details</Trans>

                                            </span>
                                        </div>
                                    ) : null}
                                </div>

                                <div className="col-12 col-lg-12 py-2  search-histroy-parent">
                                    <div className="row">
                                        <div className="search-histroy-page">
                                            <div className="custom-search-histroy-container d-flex">
                                                <div className="input-group search-histroy-field">
                                                    <div className="search-filed-section position-relative">
                                                        <input
                                                            type="text"
                                                            className={`form-control ${this.state.isValidWO ? "disabledbutton" : ""}`}
                                                            placeholder={t("Enter WO#")}
                                                            id="WONUM"
                                                            maxLength="9"
                                                            onKeyDown={this.AnykeyWOPress}
                                                            ref={this.WOText}
                                                            pattern="[0-9]*"
                                                            value={this.state.WONum}
                                                            onChange={this.handleWOnum}
                                                        />

                                                        {this.state.WONum && (
                                                            <span
                                                                src="images/cancel-icon-black.svg" alt="cancel-icon-black"
                                                                className="search-histroy-field-cancel-btn search-cancel-header cursor-pointer"
                                                                style={{ right: "6px" }}
                                                                onClick={() => this.ClearWO()}
                                                            >
                                                            </span>
                                                        )}
                                                    </div>
                                                    <button className="btn search-histroy-field-btn" onClick={() => this.WOClick()} type="button">
                                                        <img className src="Images/black-search-icon.svg" alt="search" /></button>
                                                </div>


                                                {this.state.isValidWO && this.state.WO_Parts.length > 0 && (
                                                    <button
                                                        className="btn custom-btn-primary primary-btn w-sm-100 history-btn"
                                                        onClick={(e) => this.WO_Parts_ButtonClick(e)}
                                                        id="EditFavLink"
                                                    >
                                                        <img src="Images/history_icon.svg" alt="bin-icon" className="history-btn-icon" /><Trans> WO# History</Trans>
                                                    </button>
                                                )}
                                            </div>

                                            <div className={`work-order-switcher d-flex ${this.state.isValidWO == false ? "disabled" : ""}`}>
                                                <span>Suggested item(s) for the work order</span>
                                                <div className="form-check form-switch d-flex align-items-center me-4  pl-1">
                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            id="PcToggleInput"
                                                            className="cust-toggle"
                                                            onChange={(e) => this.onChangePC(e)}
                                                            checked={this.state.IsProblemCodeSearch}
                                                            disabled={this.state.isValidWO == false}
                                                        />
                                                        <span id="PcToggleSpan" className="slider round" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <span
                                            className="errorspan12 text-left mt-2"
                                            id="StatusMsgbilltostore"
                                        ></span>

                                        {this.state.isValidWO && (
                                            <>
                                                <div className="custom-work-order-store-trade">
                                                    <div className="search-result-logo-container justify-content-center d-flex">
                                                        <img src="Images/walmart-image.png" alt="" className="w-100" />
                                                    </div>
                                                    <div className="search-result-details">
                                                        <div>
                                                            <label htmlFor="" className="font-14 mb-1 ">Work order trade :</label>
                                                            <p className="font-14 m-0 sub-content">{CookieService.getLocalStorageValues("Trade") || "-"}</p>
                                                        </div>
                                                        <div>
                                                            <label htmlFor="" className="font-14 mb-1">Work order store :</label>
                                                            <p className="font-14 m-0 sub-content">{localStorage.getItem("StoreValue") ? JSON.parse(localStorage.getItem("StoreValue")) : "-"}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="custom-problem-code-section">
                                                    <p><span className="title">Problem code:</span> {descriptionToShow || "-"}
                                                        {desc?.length > 110 && (
                                                            <span
                                                                className="toggle-description view-details-item cursor-pointer ml-2"
                                                            >
                                                                <a
                                                                    className="view-details-items"
                                                                    onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
                                                                >
                                                                    {this.state.isExpanded ? "Show less" : "Show more"}
                                                                </a>
                                                            </span>
                                                        )}
                                                    </p>

                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="border-top pt-2" > </div>
                            </div>


                        </>
                    ) : null}

                    {this.state.PageLoadSearchResults.length < 1 ? (<section className="site-undercontruction col-md-12 container-responsive text-center center-panel-1">
                        <>
                            {this.state.ProblemCodeSearch ? (
                                IsProblemCodeSearch ? (
                                    <div className="search-histroy-error-section">
                                        <img
                                            className="search-histroy-error-image"
                                            src="images/search-result-error-image.png"
                                            alt="No results"
                                        />
                                        <div className="d-flex justify-content-center">
                                            <p><Trans>No Search Result found</Trans></p>
                                        </div>
                                    </div>
                                ) : this.state.isValidWO ? (
                                    <div className="search-histroy-error-section">
                                        <img
                                            className="search-histroy-error-image"
                                            src="images/search-result-error-image.png"
                                            alt="No results"
                                        />
                                        <div className="d-flex justify-content-center">
                                            <p>
                                                Please use keywords for your search or activate the
                                                suggested item(s) for the work order toggle.
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="search-histroy-error-section">
                                        <img
                                            className="search-histroy-error-image"
                                            src="images/search-result-error-image.png"
                                            alt="No results"
                                        />
                                        <div className="d-flex justify-content-center">
                                            <p>
                                                Please use keywords for your search or validate the work
                                                order to enable the suggested item(s) for the work order toggle.
                                            </p>
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div className="search-histroy-error-section">
                                    <img
                                        className="search-histroy-error-image"
                                        src="images/search-result-error-image.png"
                                        alt="No results"
                                    />
                                    <div className="d-flex justify-content-center">
                                        <p><Trans>No Search Result found</Trans></p>
                                    </div>
                                </div>
                            )}
                        </>
                    </section>
                    ) : (

                        <div className="col-md-12">
                            <div className="row">
                                {this.state.PageLoadSearchResults.length > 0 ? (
                                    <div
                                            className="col-sm-4 col-md-6 col-lg-3 my-3 mobile-filter"
                                        id="Advancefilterdiv"
                                    >
                                        <div
                                            id="accordion"
                                            className="accordion-container filters-search"
                                        >
                                            <h6 className="accordion-title mb-0">
                                                <Trans>Filter</Trans>
                                            </h6>
                                            <div className="card border-0">
                                                <div className="card-header custom-card-reset search-filter-index-reset card-custom-padding">
                                                    <div className="w-100 input-group dropdown-search pb-3">
                                                        <div className="input-group-prepend">
                                                            <button
                                                                className="btn dropdown-toggle"
                                                                type="button"
                                                                data-toggle="dropdown"
                                                                aria-haspopup="true"
                                                                aria-expanded="false"
                                                            >
                                                                <Trans>{this.state.filterAppliedType}</Trans>
                                                            </button>
                                                            <div className="dropdown-menu">
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() => this.FilterType(1, "All")}
                                                                >
                                                                    <Trans>All</Trans>
                                                                    <span> </span>
                                                                    <Trans>Categories</Trans>
                                                                </a>
                                                                {/* Ticket No-5614 regression test bug updating a label from item id to supplier part number [4/10/2025] Nachiappan */}
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() =>
                                                                        this.FilterType(2, "Supplier part number")
                                                                    }
                                                                >
                                                                        <Trans>Supplier part number</Trans>
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        onClick={() => this.FilterType(3, "Description")}
                                                                    >
                                                                        <Trans>Description</Trans>
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        onClick={() => this.FilterType(4, "MFG name")}
                                                                    >
                                                                        <Trans>MFG name</Trans>
                                                                    </a>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            this.FilterType(5, "MFG part number")
                                                                        }
                                                                    >
                                                                        <Trans>MFG part number</Trans>
                                                                </a>
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() => this.FilterType(6, "Supplier")}
                                                                >
                                                                    <Trans>Supplier</Trans>
                                                                </a>
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() => this.FilterType(7, "UOM")}
                                                                >
                                                                    UOM
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search"
                                                            aria-label="Text input with dropdown button"
                                                            id="searchTb"
                                                            onKeyDown={this.AnykeyPress}
                                                        />
                                                        <span
                                                            className="dropdown-search-icon"
                                                            onClick={() => this.Search()}
                                                        />
                                                    </div>
                                                    <label className="custom-radiobtn">
                                                        <Trans>Catalog Description</Trans>
                                                        <input
                                                            type="radio"
                                                            id="CatalogDesp"
                                                            checked={CatalogType}
                                                            name="radio1"
                                                            onChange={() => this.descriptioncahange(1)}
                                                        />
                                                        <span
                                                            className="checkmark checkmark-org"
                                                            style={{ top: "2px", left: "2px" }}
                                                        />
                                                    </label>
                                                    <label className="custom-radiobtn pb-3 mb-0">
                                                        <Trans>Client Description</Trans>
                                                        <input
                                                            type="radio"
                                                            id="ClientDesp"
                                                            checked={ClientType}
                                                            name="radio1"
                                                            onChange={() => this.descriptioncahange(0)}
                                                        />
                                                        <span
                                                            className="checkmark checkmark-org"
                                                            style={{ top: "2px", left: "2px" }}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="card-header custom-card-reset card-custom-padding">
                                                    <div>
                                                        <h5
                                                            className="search-category d-block title-font "
                                                            style={{ fontSize: "15px" }}
                                                        >
                                                            <Trans>Shipment Method</Trans>
                                                        </h5>

                                                        <label className="custom-radiobtn  ">
                                                            <Trans>Pickup</Trans>
                                                            <input
                                                                type="radio"
                                                                id="PICKUPRADO"
                                                                checked={this.state.pickUp == true ? true : false}
                                                                name="DELIVERY2"
                                                                onChange={() => this.pickupchange(0)}
                                                            />
                                                            <span
                                                                className="checkmark checkmark-org"
                                                                style={{ top: "2px", left: "2px" }}
                                                            />
                                                        </label>
                                                        <label className="custom-radiobtn pb-3 mb-0 ">
                                                            <Trans>Ship To</Trans>
                                                            <input
                                                                type="radio"
                                                                id="SHIPTORADIO"
                                                                checked={this.state.pickUp == false ? true : false}
                                                                name="DELIVERY"
                                                                onChange={() => this.pickupchange(1)}
                                                            />
                                                            <span
                                                                className="checkmark checkmark-org"
                                                                style={{ top: "3px", left: "3px" }}
                                                            />
                                                        </label>
                                                    </div>

                                                    <div className="row pl-1">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <label
                                                                    className="title-font col-lg-4 p-0 col-5"
                                                                    style={{ fontSize: "15px" }}
                                                                >
                                                                    <Trans>Warehouse</Trans>
                                                                </label>

                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="cust-toggle"
                                                                        onChange={() =>this.InventoryCheck(!this.state.inventory, "W")}
                                                                        checked={this.state.inventory}
                                                                    />
                                                                    <span id="PcToggleSpan" className="slider round" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row pl-1">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <label
                                                                    className="title-font col-lg-4 col-5 p-0"
                                                                    style={{ fontSize: "15px" }}
                                                                >
                                                                    <Trans>Truck Stock</Trans>
                                                                </label>

                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="cust-toggle"
                                                                        onChange={() => this.InventoryCheck(!this.state.TruckStock, "T")}
                                                                        checked={this.state.TruckStock}
                                                                    />
                                                                    <span id="PcToggleSpan" className="slider round" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card border-0 d-none">
                                                <div className="card-header p-0" id="headingOne1">
                                                    <h5 className="mb-0 accordion-header ">
                                                        <Trans>Catalog</Trans>
                                                        <span> </span> <Trans>Lookup</Trans>
                                                    </h5>
                                                    <span
                                                        className="accordion-heading collapsed"
                                                        data-toggle="collapse"
                                                        data-target="#collapseOne"
                                                        aria-expanded="false"
                                                        aria-controls="collapseOne"
                                                    />
                                                </div>
                                                <div
                                                    id="collapseOne"
                                                    className="collapse"
                                                    aria-labelledby="headingOne1"
                                                    data-parent="#accordion"
                                                    style={{}}
                                                >
                                                    <div className="input-group-prepend">
                                                        <button
                                                            className="btn catagoryFilterBtn"
                                                            type="button"
                                                            onClick={() => this.CHeckAll(1)}
                                                        >
                                                            <Trans>Check</Trans>
                                                            <span> </span>
                                                            <Trans>All</Trans>
                                                        </button>
                                                        <button
                                                            className="btn catagoryFilterBtn"
                                                            type="button"
                                                            onClick={() => this.CHeckAll(0)}
                                                        >
                                                            <Trans>De</Trans>
                                                            <span> </span>
                                                            <Trans>Check</Trans>
                                                            <span> </span>
                                                            <Trans>All</Trans>
                                                        </button>
                                                        <button
                                                            className="btn catagoryFilterBtn"
                                                            type="button"
                                                            onClick={() => this.ApplyCatagoryFilter()}
                                                        >
                                                            <Trans>Apply</Trans>
                                                        </button>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <CheckboxTree
                                                            nodes={this.state.CatalogTree}
                                                            iconsClass="fa4"
                                                            showNodeIcon={true}
                                                            checked={this.state.checked}
                                                            expanded={this.state.expanded}
                                                            onCheck={this.OnCheckTree}
                                                            onExpand={(expanded) => this.setState({ expanded })}
                                                            icons={{
                                                                check: <span className="rct-icon rct-icon-check" />,
                                                                uncheck: (
                                                                    <span className="rct-icon rct-icon-uncheck" />
                                                                ),
                                                                halfCheck: (
                                                                    <span className="rct-icon rct-icon-half-check" />
                                                                ),
                                                                expandClose: (
                                                                    <span className="rct-icon rct-icon-expand-close" />
                                                                ),
                                                                expandOpen: (
                                                                    <span className="rct-icon rct-icon-expand-open" />
                                                                ),
                                                                expandAll: (
                                                                    <span className="rct-icon rct-icon-expand-all" />
                                                                ),
                                                                collapseAll: (
                                                                    <span className="rct-icon rct-icon-collapse-all" />
                                                                ),
                                                                parentClose: (
                                                                    <span className="rct-icon rct-icon-parent-close" />
                                                                ),
                                                                parentOpen: (
                                                                    <span className="rct-icon rct-icon-parent-open" />
                                                                ),
                                                                leaf: <span className="rct-icon rct-icon-leaf" />,
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card border-0 ">
                                                <div className="card-header p-0" id="headingtwo">
                                                    <h5 className="mb-0 accordion-header ">
                                                        <Trans>Manufacturer</Trans>
                                                    </h5>
                                                    <span
                                                        className="accordion-heading collapsed"
                                                        onClick={() => this.ShowFIlter(1)}
                                                        id="ManufilterIcon"
                                                    />
                                                    {/*WW-508-trade service revert back changes-Show MFG countPriyanka */}
                                                    {this.state.mfgcount > 0 ? (
                                                        <span
                                                            className="filtercnt cntalign"
                                                            style={{
                                                                padding: "4px 3px",
                                                                width: "27px",
                                                                height: "25px",
                                                                "border-radius": "62%",
                                                            }}
                                                        >
                                                            {this.state.mfgcount > 99
                                                                ? Greaterthan99
                                                                : this.state.mfgcount}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div className="col-md-12 py-3 d-none" id="Manufilter">
                                                    <div class="col-md-14">
                                                        <div class="row mb-3">
                                                            <div class="col-md-5 float-left px-2">
                                                                <a
                                                                    className="filterlink p-0"
                                                                    onClick={() => this.selectall("Manufacture")}
                                                                    style={{
                                                                        color: "#007bff",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <Trans>
                                                                        {this.state.selectallMfg == true
                                                                            ? "Select All"
                                                                            : "UnSelect All"}
                                                                    </Trans>
                                                                </a>
                                                            </div>
                                                            {this.state.selectallMfg == true &&
                                                                this.state.mfgcount > 0 ? (
                                                                <div class="col-md-7 float-right SearchResultpx-1 SearchResultpx-4">
                                                                    <a
                                                                        className="filterlink p-0"
                                                                        onClick={() => this.Deselectall("Manufacture")}
                                                                        style={{
                                                                            color: "#007bff",
                                                                            textDecoration: "underline",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <Trans>Clear</Trans>
                                                                    </a>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <CheckboxTree
                                                        nodes={this.state.Manufacture}
                                                        iconsClass="fa4"
                                                        showNodeIcon={true}
                                                        checked={this.state.Manuchecked}
                                                        onCheck={this.OnCheckManuTree}
                                                        icons={{
                                                            check: <span className="rct-icon rct-icon-check" />,
                                                            uncheck: <span className="rct-icon rct-icon-uncheck" />,
                                                            halfCheck: (
                                                                <span className="rct-icon rct-icon-half-check" />
                                                            ),
                                                            expandClose: (
                                                                <span className="rct-icon rct-icon-expand-close" />
                                                            ),
                                                            expandOpen: (
                                                                <span className="rct-icon rct-icon-expand-open" />
                                                            ),
                                                            expandAll: (
                                                                <span className="rct-icon rct-icon-expand-all" />
                                                            ),
                                                            collapseAll: (
                                                                <span className="rct-icon rct-icon-collapse-all" />
                                                            ),
                                                            parentClose: (
                                                                <span className="rct-icon rct-icon-parent-close" />
                                                            ),
                                                            parentOpen: (
                                                                <span className="rct-icon rct-icon-parent-open" />
                                                            ),
                                                            leaf: <span className="rct-icon rct-icon-leaf" />,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="card border-0 ">
                                                <div className="card-header p-0" id="headingthree">
                                                    <h5 className="mb-0 accordion-header ">
                                                        <Trans>Attribute</Trans>
                                                    </h5>
                                                    <span
                                                        className="accordion-heading collapsed"
                                                        onClick={() => this.ShowFIlter(2)}
                                                        id="AttriFilterIcon"
                                                    />
                                                    {this.state.attricount > 0 ? (
                                                        <span
                                                            className="filtercnt cntalign"
                                                            style={{
                                                                padding: "4px 3px",
                                                                width: "27px",
                                                                height: "25px",
                                                                "border-radius": "62%",
                                                            }}
                                                        >
                                                            {this.state.attricount > 99
                                                                ? Greaterthan99
                                                                : this.state.attricount}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div className="col-md-12 py-3 d-none" id="AttriFilter">
                                                    <div class="col-md-14">
                                                        <div class="row">
                                                            <div class="col-md-5 float-left px-2">
                                                                <a
                                                                    className="filterlink p-0"
                                                                    onClick={() => this.selectall("Attribute")}
                                                                    style={{
                                                                        color: "#007bff",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <Trans>
                                                                        {this.state.selectallAtt == true
                                                                            ? "Select All"
                                                                            : "UnSelect All"}
                                                                    </Trans>
                                                                </a>
                                                            </div>
                                                            {this.state.selectallAtt == true &&
                                                                this.state.attricount > 0 ? (
                                                                <div class="col-md-7 float-right  SearchResultpx-1 SearchResultpx-4">
                                                                    <a
                                                                        className="filterlink p-0"
                                                                        onClick={() => this.Deselectall("Attribute")}
                                                                        style={{
                                                                            color: "#007bff",
                                                                            textDecoration: "underline",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <Trans>Clear</Trans>
                                                                    </a>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <CheckboxTree
                                                        nodes={this.state.AttributeTree}
                                                        iconsClass="fa4"
                                                        showNodeIcon={true}
                                                        checked={this.state.Attrichecked}
                                                        expanded={this.state.expanded}
                                                        onExpand={(expanded) => this.setState({ expanded })}
                                                        onCheck={this.OnCheckAttriTree}
                                                        icons={{
                                                            check: <span className="rct-icon rct-icon-check" />,
                                                            uncheck: <span className="rct-icon rct-icon-uncheck" />,
                                                            halfCheck: (
                                                                <span className="rct-icon rct-icon-half-check" />
                                                            ),
                                                            expandClose: (
                                                                <span className="rct-icon rct-icon-expand-close" />
                                                            ),
                                                            expandOpen: (
                                                                <span className="rct-icon rct-icon-expand-open" />
                                                            ),
                                                            expandAll: (
                                                                <span className="rct-icon rct-icon-expand-all" />
                                                            ),
                                                            collapseAll: (
                                                                <span className="rct-icon rct-icon-collapse-all" />
                                                            ),
                                                            parentClose: (
                                                                <span className="rct-icon rct-icon-parent-close" />
                                                            ),
                                                            parentOpen: (
                                                                <span className="rct-icon rct-icon-parent-open" />
                                                            ),
                                                            leaf: <span className="rct-icon rct-icon-leaf" />,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="card border-0 ">
                                                <div className="card-header p-0" id="headingfour">
                                                    <h5 className="mb-0 accordion-header ">
                                                        <Trans>Supplier</Trans>
                                                    </h5>
                                                    <span
                                                        className="accordion-heading collapsed"
                                                        onClick={() => this.ShowFIlter(3)}
                                                        id="SupplierFilterIcon"
                                                    />
                                                    {this.state.suppliercount > 0 ? (
                                                        <span
                                                            className="filtercnt cntalign"
                                                            style={{
                                                                padding: "4px 3px",
                                                                width: "27px",
                                                                height: "25px",
                                                                "border-radius": "62%",
                                                            }}
                                                        >
                                                            {this.state.suppliercount > 99
                                                                ? Greaterthan99
                                                                : this.state.suppliercount}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div className="col-md-12 py-3 d-none" id="SupplierFilter">
                                                    <div class="col-md-14">
                                                        <div class="row mb-3">
                                                            <div class="col-md-5 float-left px-2">
                                                                <a
                                                                    className="filterlink p-0"
                                                                    onClick={() => this.selectall("Supplier")}
                                                                    style={{
                                                                        color: "#007bff",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <Trans>
                                                                        {this.state.selectallSup == true
                                                                            ? "Select All"
                                                                            : "UnSelect All"}
                                                                    </Trans>
                                                                </a>
                                                            </div>
                                                            {this.state.selectallSup == true &&
                                                                this.state.suppliercount > 0 ? (
                                                                <div class="col-md-7 float-right SearchResultpx-1 SearchResultpx-4">
                                                                    <a
                                                                        className="filterlink p-0"
                                                                        onClick={() => this.Deselectall("Supplier")}
                                                                        style={{
                                                                            color: "#007bff",
                                                                            textDecoration: "underline",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <Trans>Clear</Trans>
                                                                    </a>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <CheckboxTree
                                                        nodes={this.state.SupplierTree}
                                                        iconsClass="fa4"
                                                        showNodeIcon={true}
                                                        checked={this.state.SupplierChecked}
                                                        onCheck={this.OnCheckSupplierTree}
                                                        icons={{
                                                            check: <span className="rct-icon rct-icon-check" />,
                                                            uncheck: <span className="rct-icon rct-icon-uncheck" />,
                                                            halfCheck: (
                                                                <span className="rct-icon rct-icon-half-check" />
                                                            ),
                                                            expandClose: (
                                                                <span className="rct-icon rct-icon-expand-close" />
                                                            ),
                                                            expandOpen: (
                                                                <span className="rct-icon rct-icon-expand-open" />
                                                            ),
                                                            expandAll: (
                                                                <span className="rct-icon rct-icon-expand-all" />
                                                            ),
                                                            collapseAll: (
                                                                <span className="rct-icon rct-icon-collapse-all" />
                                                            ),
                                                            parentClose: (
                                                                <span className="rct-icon rct-icon-parent-close" />
                                                            ),
                                                            parentOpen: (
                                                                <span className="rct-icon rct-icon-parent-open" />
                                                            ),
                                                            leaf: <span className="rct-icon rct-icon-leaf" />,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                    <div className="col-sm-8 col-md-12 col-lg-9 mt-3">
                                    {this.state.PageLoadSearchResults.length > 0 && ImageSearch ? (
                                        <div className="row mb-3 py-2 image-Search">
                                            <div className="col-md-4 col-lg-2  catgory-searchedimage image-size-search mb-2">
                                                <div className="row justify-content-center">
                                                    <img src={ImageURL} className="w-100 image-size-search" />
                                                </div>
                                            </div>
                                            <div className="col-md-8 col-lg-10 mobile-catalog mobile-catalog-search">
                                                <div className="row">
                                                    <div className="col-md-12 col-lg-9 p-0 search-content">
                                                        <div className="col-md-12 float-left">
                                                            <div className="row">
                                                                <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content">
                                                                    <label className="catalog-label float-left">
                                                                        <Trans>Showing results for your image</Trans>
                                                                        <span>:</span>
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content">
                                                                    {this.state.showpagination ? (
                                                                        <span className="list-count w-100 float-left">
                                                                            <span className="mr-1">
                                                                                {this.state.itemperpage}
                                                                            </span>
                                                                            <Trans>Items</Trans>
                                                                            <span> </span> <Trans> In</Trans>
                                                                            <span className="mx-1">1</span>
                                                                            <Trans>page</Trans> (
                                                                            <span className="mr-1">
                                                                                {this.state.TotalItemCount}
                                                                            </span>
                                                                            <Trans>items in</Trans>
                                                                            <span className="mx-1">
                                                                                {this.state.pageCount}
                                                                            </span>
                                                                            <Trans>Page</Trans>
                                                                            <span> </span>)
                                                                        </span>
                                                                    ) : (
                                                                        <span className="list-count w-100 float-left">
                                                                            <span className="mr-1">
                                                                                {this.state.TotalItemCount}
                                                                            </span>
                                                                            <Trans>Items</Trans>
                                                                            <span> </span> <Trans> In</Trans>
                                                                            <span className="mx-1">
                                                                                {this.state.pageCount}
                                                                            </span>
                                                                            <Trans>page</Trans>
                                                                        </span>
                                                                    )}
                                                                </div>

                                                                <div className="col-md-12 col-lg-8 col-12 col-sm-12 fav-maintence custom-search-content mt-1">
                                                                    <span
                                                                        class="Img-txt cursor-pointer mt-2 "
                                                                        onClick={(e) => this.ManufactureDetails_click()}
                                                                    >
                                                                        <Trans>Matching part details</Trans>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    <>
                                        <div className="row">
                                            <div className="col-md-12 float-left">
                                                {(IsProblemCodeSearch == false && this.state.ProblemCodeSearch == false) && (
                                                    <div className="d-block">
                                                        <h5 className="search-category title-font mb-2  mr-2 float-left">
                                                            <Trans>You searched for</Trans>:
                                                        </h5>

                                                        <h5 className="mx-2 ml-2 search-category title-font light-gray-text">
                                                            {this.state.SearchKeyWord}
                                                        </h5>
                                                    </div>
                                                )}


                                                {this.state.PageLoadSearchResults.length < 5 &&
                                                    this.state.ShowDidyoumean !== false &&
                                                    (IsProblemCodeSearch == false && this.state.ProblemCodeSearch == false) ? (
                                                    <div className="d-block">
                                                        <h5 className="search-category d-block title-font font-14 font-regular">
                                                            Did you mean <span>:</span>
                                                            <a
                                                                href="#"
                                                                className="suggested-txt mx-2"
                                                                onClick={(e) => this.DidyouMeanClick(this.state.DidyouMean1, e)}
                                                            >
                                                                {this.state.DidyouMean1}
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="suggested-txt mx-2"
                                                                onClick={(e) => this.DidyouMeanClick(this.state.DidyouMean2, e)}
                                                            >
                                                                {this.state.DidyouMean2}
                                                            </a>
                                                            <a
                                                                href="#"
                                                                className="suggested-txt mx-2"
                                                                onClick={(e) => this.DidyouMeanClick(this.state.DidyouMean3, e)}
                                                            >
                                                                {this.state.DidyouMean3}
                                                            </a>
                                                        </h5>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </>


                                    <div className="col-12 col-lg-12 py-2  search-histroy-parent">
                                        <div className="row">
                                            <div className="search-histroy-page">
                                                <div className="custom-search-histroy-container d-flex">
                                                    <div className="input-group search-histroy-field">
                                                        <div className="search-filed-section position-relative">
                                                            <input
                                                                type="text"
                                                                className={`form-control ${this.state.isValidWO ? "disabledbutton" : ""}`}
                                                                placeholder={t("Enter WO#")}
                                                                id="WONUM"
                                                                maxLength="9"
                                                                onKeyDown={this.AnykeyWOPress}
                                                                ref={this.WOText}
                                                                pattern="[0-9]*"
                                                                value={this.state.WONum}
                                                                onChange={this.handleWOnum}
                                                            />

                                                            {this.state.WONum && (
                                                                <span
                                                                    src="images/cancel-icon-black.svg" alt="cancel-icon-black"
                                                                    className="search-histroy-field-cancel-btn search-cancel-header cursor-pointer"
                                                                    style={{ right: "6px" }}
                                                                    onClick={() => this.ClearWO()}
                                                                >
                                                                </span>
                                                            )}
                                                        </div>
                                                        <button className="btn search-histroy-field-btn" onClick={() => this.WOClick()} type="button">
                                                            <img className src="Images/black-search-icon.svg" alt="search" /></button>
                                                    </div>


                                                    {this.state.isValidWO && this.state.WO_Parts.length > 0 && (
                                                        <button
                                                            className="btn custom-btn-primary primary-btn w-sm-100 history-btn"
                                                            onClick={(e) => this.WO_Parts_ButtonClick(e)}
                                                            id="EditFavLink"
                                                        >
                                                            <img src="Images/history_icon.svg" alt="bin-icon" className="history-btn-icon" /><Trans> WO# History</Trans>
                                                        </button>
                                                    )}
                                                </div>

                                                <div className={`work-order-switcher d-flex ${this.state.isValidWO == false ? "disabled" : ""}`}>
                                                    <span>Suggested item(s) for the work order</span>
                                                    <div className="form-check form-switch d-flex align-items-center me-4 pl-1">
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                id="PcToggleInput"
                                                                className="cust-toggle"
                                                                onChange={(e) => this.onChangePC(e)}
                                                                checked={this.state.IsProblemCodeSearch}
                                                                disabled={this.state.isValidWO == false}
                                                            />
                                                            <span id="PcToggleSpan" className="slider round" />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <span
                                                className="errorspan12 text-left mt-2"
                                                id="StatusMsgbilltostore"
                                            ></span>

                                            {this.state.isValidWO && (
                                                <>
                                                    <div className="custom-work-order-store-trade">
                                                        <div className="search-result-logo-container justify-content-center d-flex">
                                                            <img src="Images/walmart-image.png" alt="" className="w-100" />
                                                        </div>
                                                        <div className="search-result-details">
                                                            <div>
                                                                <label htmlFor="" className="font-14 mb-1 ">Work order trade :</label>
                                                                <p className="font-14 m-0 sub-content">{CookieService.getLocalStorageValues("Trade") || "-"}</p>
                                                            </div>
                                                            <div>
                                                                <label htmlFor="" className="font-14 mb-1">Work order store :</label>
                                                                <p className="font-14 m-0 sub-content">{localStorage.getItem("StoreValue") ? JSON.parse(localStorage.getItem("StoreValue")) : "-"}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="custom-problem-code-section">
                                                        <p><span className="title">Problem code:</span> {descriptionToShow || "-"}
                                                            {desc?.length > 110 && (
                                                                <span
                                                                    className="toggle-description view-details-item cursor-pointer ml-2"
                                                                >
                                                                    <a
                                                                        className="view-details-items"
                                                                        onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
                                                                    >
                                                                        {this.state.isExpanded ? "Show less" : "Show more"}
                                                                    </a>
                                                                </span>
                                                            )}
                                                        </p>

                                                        </div>
                                                </>
                                            )}

                                                <div className="custom-pagination-search-result border-top pt-2">
                                                        <a
                                                            href="#"
                                                            className="float-right mx-2 filter-icon-toggle"
                                                            onClick={(e) => this.mobAdvfiltershow(e)}
                                                        >
                                                            <img
                                                                src="images/filter-icon.png"
                                                                alt="Filter Icon"
                                                            />
                                                        </a>

                                                <div className="custom-pagination-search-result">
                                                    {this.state.FilterValuedata.length > 0 ? (
                                                        <div className="custom-layout-change">
                                                            <a
                                                                className="search-layout-icons mr-2 cursor-pointer"
                                                                onClick={() => this.GridChange(1)}
                                                                title="List view"
                                                            >
                                                                <img
                                                                    src={this.state.GridType == 1 ? "images/search-layout-one-image-active.svg" : "images/search-layout-one-image.svg"}
                                                                    alt="List Icon"
                                                                />
                                                            </a>

                                                            <a
                                                                className="search-layout-icons cursor-pointer"
                                                                onClick={() => this.GridChange(0)}
                                                                title="Grid view"
                                                            >
                                                                <img
                                                                    src={this.state.GridType != 1 ? "images/search-layout-two-image-active.svg" : "images/search-layout-two-image.svg"}
                                                                    alt="Grid Icon"
                                                                />
                                                            </a>
                                                        </div>    ): null}


                                                    <nav>
                                                        {this.state.showpagination && !ImageSearch ? (
                                                            <span className="pagination-search-result-details">
                                                                <span className="mr-1">
                                                                    {this.state.itemperpage}
                                                                </span>
                                                                <Trans>Items</Trans>
                                                                <span> </span> <Trans> In</Trans>
                                                                <span className="mx-1">1</span>
                                                                <Trans>page</Trans> (
                                                                <span className="mr-1">
                                                                    {this.state.TotalItemCount}
                                                                </span>
                                                                <Trans>items in</Trans>
                                                                <span className="mx-1">
                                                                    {this.state.pageCount}
                                                                </span>
                                                                <Trans>Page</Trans>
                                                                <span> </span>)
                                                            </span>
                                                        ) : null}

                                                        {!ImageSearch &&
                                                            !this.state.showpagination ? (
                                                            <span className="list-count w-100 float-left">
                                                                <span className="mr-1">
                                                                    {this.state.TotalItemCount}
                                                                </span>
                                                                <Trans>Items</Trans>
                                                                <span> </span> <Trans> In</Trans>
                                                                <span className="mx-1">
                                                                    {this.state.pageCount}
                                                                </span>
                                                                <Trans>page</Trans>
                                                            </span>
                                                        ) : null}

                                                        <ul className="custom-pagination pagination float-right mb-2 mt-1 mobile-pagination">
                                                            {this.state.showpagination ? (
                                                                <ReactPaginate
                                                                    previousLabel={
                                                                        <span className="right-pagination-arrow" />
                                                                    }
                                                                    nextLabel={
                                                                        <span className="left-pagination-arrow" />
                                                                    }
                                                                    previousClassName={"page-item"}
                                                                    nextClassName={"page-item"}
                                                                    previousLinkClassName={"page-link"}
                                                                    nextLinkClassName={"page-link"}
                                                                    disabledClassName={"disabled"}
                                                                    breakLabel={"..."}
                                                                    breakClassName={"page-item"}
                                                                    breakLinkClassName={"page-link"}
                                                                    pageCount={this.state.pageCount}
                                                                    marginPagesDisplayed={1}
                                                                    pageRangeDisplayed={2}
                                                                    onPageChange={this.handlePageClick}
                                                                    containerClassName={
                                                                        "custom-pagination pagination float-right"
                                                                    }
                                                                    pageClassName={"page-item"}
                                                                    pageLinkClassName={"page-link"}
                                                                    activeClassName={"active"}
                                                                    hrefBuilder={() => "#"}
                                                                    forcePage={this.state.pageNo - 1}
                                                                />
                                                            ) : null}
                                                        </ul>
                                                    </nav>
                                                    </div>
                                            </div>

                                        </div>
                                    </div>


                                        <div className="col-md-12">
                                        <div className="row justify-content-between align-items-center mt-2">
                                        </div>
                                    </div>

                                    <div className="col-md-12 my-3">
                                        {this.state.FilterValuedata.length > 0 ? (
                                            <div>
                                                {this.state.GridType == 1 ? (
                                                    this.bindSearchResultsGridView()
                                                ) : (
                                                    <div className="row mb-1 py-2 gridlayout-container">
                                                        {this.bindSearchResults()}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <section className="site-undercontruction container-responsive text-center center-panel-1">
                                                <div className="search-histroy-error-section">
                                                    <img
                                                        className="search-histroy-error-image"
                                                        src="images/search-result-error-image.png"
                                                        alt="No results"
                                                    />
                                                    <div className="d-flex justify-content-center">
                                                        <p><Trans>No Search Result found</Trans></p>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                    </div>

                                    <div className="col-md-12 border-top">
                                        {this.state.showpagination ? (
                                            <span className="list-count float-left mt-3  mb-2">
                                                <span className="mr-1">{this.state.itemperpage}</span>
                                                <Trans>items in</Trans>
                                                <span className="mx-1">1</span>
                                                <Trans>Page</Trans>
                                                <span> </span>(
                                                <span className="mr-1">{this.state.TotalItemCount}</span>
                                                items in
                                                <span className="mx-1">{this.state.pageCount}</span>page )
                                            </span>
                                        ) : (
                                            <span className="list-count">
                                                <span className="mr-1">{this.state.TotalItemCount}</span>
                                                <Trans>items in</Trans>
                                                <span className="mx-1">{this.state.pageCount}</span>
                                                <Trans>Page</Trans>
                                                <span> </span>
                                            </span>
                                        )}
                                        {this.state.FilterValuedata.length > 10 ? (
                                            <div>
                                                {this.state.GridType == 1 ? (
                                                    <select
                                                        className="form-control itemPerPage item-per-page  mx-0"
                                                        id="itemperpagecount"
                                                        style={{ widht: "65px" }}
                                                        defaultValue={this.state.itemperpage}
                                                        onChange={() => this.handlePageCOunt()}
                                                    >
                                                        {/*21/8/2023, 3966 - changed the default value to the item per page, Divis Kumar R K*/}
                                                        <option value="10">10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                    </select>
                                                ) : (
                                                    <select
                                                        className="form-control  itemPerPage item-per-page  mx-0"
                                                        id="itemperpagecount"
                                                        style={{ widht: "65px" }}
                                                        defaultValue={this.state.itemperpage}
                                                        onChange={() => this.handlePageCOunt()}
                                                    >
                                                        {/*21/8/2023, 3966 - changed the default value to the item per page, Divis Kumar R K*/}
                                                        <option value="12">12</option>
                                                        <option value="24">24</option>
                                                        <option value="60">60</option>
                                                    </select>
                                                )}
                                            </div>
                                        ) : null}
                                        <ul className="custom-pagination pagination float-right mb-2 mt-3">
                                            {this.state.showpagination ? (
                                                <ReactPaginate
                                                    previousLabel={
                                                        <span className="right-pagination-arrow" />
                                                    }
                                                    nextLabel={<span className="left-pagination-arrow" />}
                                                    previousClassName={"page-item"}
                                                    nextClassName={"page-item"}
                                                    previousLinkClassName={"page-link"}
                                                    nextLinkClassName={"page-link"}
                                                    disabledClassName={"disabled"}
                                                    breakLabel={"..."}
                                                    breakClassName={"page-item"}
                                                    breakLinkClassName={"page-link"}
                                                    pageCount={this.state.pageCount}
                                                    marginPagesDisplayed={1}
                                                    pageRangeDisplayed={2}
                                                    onPageChange={this.handlePageClick}
                                                    containerClassName={
                                                        "custom-pagination pagination float-right"
                                                    }
                                                    pageClassName={"page-item"}
                                                    pageLinkClassName={"page-link"}
                                                    activeClassName={"active"}
                                                    hrefBuilder={() => "#"}
                                                    forcePage={this.state.pageNo - 1}
                                                />
                                            ) : null}
                                        </ul>
                                    </div>

                                </div>

                            </div>
                        </div>
                    )}
                </div>
            </div>





            {/*Favourite Item Pop up*/}
            <div className="modal" id="add-fav-popup" data-backdrop="static" data-keyboard="false">

                <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1"><Trans>Add to favorite item</Trans></h4>
                            <button type="button" className="btn close-btn" data-dismiss="modal">
                                X
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row mt-3">
                                <div className="col-12 edit-desc-field mb-3">
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans>Item ID</Trans></label>
                                        <label className="col-md-7 quick-value" id="FavItemId" >{this.state.FavMFGPartNUMPopUp}</label>
                                    </div>
                                    {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans>Manufacturer</Trans></label>
                                        <label className="col-md-7 quick-value" id="FavMFG" >{this.state.FavMFGPopUp}</label>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label indicate-alert"><Trans>Category</Trans></label>
                                        {/*<div className="col-md-7">
                                            <textarea className="form-control custom-textarea" id="FavYourCatg" maxLength="40" rows={3} defaultValue={''} />
                                        </div>*/}
                                        {/**WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna*/}
                                        <div className="float-left search-autocomplete col-md-7 home-search" style={{ zIndex: "9999" }}>
                                            {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                            {this.bindCat()}
                                            <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />
                                            {this.state.CategoryErr ? <span className=" W-100 errorspan mr-3" style={{ fontSize: '15px' }}><Trans>Enter Category</Trans></span> : null}
                                        </div>


                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label indicate-alert"><Trans>Sub Category</Trans></label>
                                        {/*<div className="col-md-7">
                                            <textarea className="form-control custom-textarea" id="FavYourCatg" maxLength="40" rows={3} defaultValue={''} />
                                        </div>*/}
                                        {/**WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna*/}
                                        <div className="float-left search-autocomplete col-md-7 home-search">
                                            {/*<input type="text" className="form-control " placeholder="Enter Category" id="Cat_Id" maxLength="10" name="FavOrdCat" onChange={(e) => this.handleCatChange(e)} value={this.state.FavOrdCat} />*/}
                                            <Autocomplete
                                                getItemValue={this.getItemValue}
                                                items={this.state.subCategoryResults}
                                                renderItem={this.renderItem}
                                                value={this.state.FavSubCategory}
                                                onChange={e => this.onChange(e, "Subcat")}
                                                onSelect={e => this.onSelect(e, "Subcat")}
                                                inputProps={{ placeholder: t("Search"), className: "form-control float-left" }}
                                                maxLength="40"
                                            />
                                            <span className="errorspan1" style={{ fontSize: '10px' }} id="favordsubcatid" />
                                            {this.state.SubCategoryErr ? <span className=" W-100 errorspan1 text-left " style={{ fontSize: '15px' }}><Trans>Enter Sub Category</Trans></span> : null}
                                        </div>


                                    </div>
                                    <div className="row mb-3">
                                        {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                        <label className="col-md-5 quick-label"><Trans>Description</Trans></label>
                                        <label className="col-md-7 quick-value" id="FavItemDescrip" >{this.state.FavItemDescripPopUp}</label>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans>Notes</Trans></label>
                                        <div className="col-md-7">
                                            <textarea className="form-control custom-textarea" id="FavYourDescrip" maxLength="100" rows={5} defaultValue={''} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><Trans>Supplier</Trans></label>
                                        <label className="col-md-7 quick-value" id="FavSup" >{this.state.FavSupplierPopUp}</label>
                                    </div>
                                    {/*//[6/7/2023], WW-722, LABEL CHANGE PAVITHRA R*/}
                                    <div className="row mb-3">
                                        {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                        <label className="col-md-5 quick-label"><Trans>Supplier Part#</Trans></label>
                                        <label className="col-md-7 quick-value" id="FavSupPartNUM" >{this.state.FavItemIdPopUp}</label>
                                    </div>

                                    <div className="row mb-3">
                                        <label className="col-md-5 quick-label"><span><Trans>Choose Your Own image</Trans></span></label>
                                        <div className="col-md-7 input-group">
                                            <input type="file" title=" " accept="image/jpeg, image/png" style={{ "font-size": "10px" }} id="customFile" name="filename" onChange={this.handleAttachment} onClick={(event) => { event.target.value = null }} />
                                            <label className="custom-file-label mx-3 sdi-font-12" htmlFor="customFile"><Trans>Choose File</Trans></label>
                                            {this.bindAttachments()}
                                            <label className="priority-alert mt-3" id="lblerror">{this.state.lblerror}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4" id="FavSaveBtn" onClick={() => this.AddfavItem()}><Trans>save_key</Trans></button>
                                </div>
                                <div>
                                    <label id="txtUOMHide" >{this.state.txtUOMHidePopUp}</label>
                                    <label id="txtMfgItemidHide" >{this.state.txtMfgItemidHidePopUp}</label>
                                    <label id="txtItemidHide" >{this.state.txtItemidHidePopUp}</label>
                                    <label id="txtMFGHide" >{this.state.txtMFGHidePopUp}</label>
                                    <label id="ItemType" >{this.state.ItemType}</label>
                                </div>
                            </div>
                        </div>
                        {/*Cheaper Item*/}

                    </div>
                </div>
            </div>
            {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
            {/*Core Charge Pop Up*/}
            <div className="modal fade" id="CoreChargePopUp" tabIndex={-1}
                role="dialog"
                ari=""
                overflow-autoa-hidden="true">

                <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1" />
                            <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}>
                                X
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row text-center">
                                <div className="col-md-12 my-4">
                                    <span className="question-mark-icon" />
                                </div>
                                <div className="col-12 mb-4">
                                    <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                    <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}><Trans>Cancel</Trans></button>{/**Added SelectedItemForCheaper to addtocart (which throwed exception)(9/5/2022)-Aparna*/}
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => {
                                        if (cartpickUp == true) {
                                            this.CoreChargeProceedClick(e)
                                        }
                                        else {
                                            this.TradeServiceAddClick(e, ItemArray, false, false);


                                        }
                                    }
                                    }><Trans>Proceed</Trans></button>
                                    { /* this.AddOrder(e, this.state.index1CC, this.state.catalogIdCC, this.state.ManuPartNumCC, this.state.manufacturerCC, this.state.ItemPriceCC, this.state.suppliernameCC, "", "", "Proceed"); this.Addtocart(this.state.catalogIdCC, this.state.ManuPartNumCC, "1", "", this.state.SelectedItemForCheaper); */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="modal" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1"><Trans>Cheaper Option</Trans></h4>
                            <button type="button" className="btn close-btn" data-dismiss="modal">
                                X
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row">

                                <div className="col-md-4 col-lg-4 order-summary-image category-search-image category-search-image-height">
                                    <div className="row justify-content-center">

                                        <Image
                                            src={this.state.cheaperItemImage}
                                            width={150}
                                            height={150}
                                            style={style.image}
                                            id="cheaper-img"
                                        //noImageSrc="/Images/noimage_new.png"
                                        /></div>
                                    {/*<img src={imagePath} alt="fav_item" onClick={() => this.showitemdetails(indexval, val.clientPartNumber, val.ItemAttributeId, FavItem)} />*/}
                                </div>
                                <div className="col-md-4 col-lg-8 order-summary-image category-search-image category-search-image-height">
                                    <div className="row float-left ml-3">
                                        <label>Id : {this.state.cheaperItem.clientPartNumber}</label>
                                    </div>
                                    <div className="row float-left ml-3">
                                        <label><Trans>Manufacturer</Trans><span> </span><Trans>Part</Trans><span> # : </span>{this.state.cheaperItem.manfPartNumber}</label>
                                    </div>
                                    <div className="row float-left ml-3">
                                        <label><Trans>Supplier</Trans><span> : </span>{this.state.cheaperItem.supplierName}</label>
                                    </div>
                                    <div className="row float-left ml-3">
                                        <label><Trans>Price</Trans><span> : $  </span> {this.state.cheaperItem.ItemPrice}</label>
                                    </div>
                                    {/*<img src={imagePath} alt="fav_item" onClick={() => this.showitemdetails(indexval, val.clientPartNumber, val.ItemAttributeId, FavItem)} />*/}
                                </div>
                                <div className="col-md-4 col-lg-12 order-summary-image category-search-image category-search-image-height">
                                    <div className="row justify-content-center">
                                        <div className="float-left my-2">
                                            <span className="float-left mt-2 price-calc"><Trans>No, thanks.</Trans></span>
                                            {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                            <a className="search-results-cart-button float-left ml-2" onClick={(e) => { this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, "no", ""); this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1", ""); }}><span className="cart-icon" /></a>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="float-left my-2">
                                            <span className="float-left mt-2 price-calc">Qty:</span>
                                            {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                            <input type="text" value={this.state.QuantityOrdered == null || this.state.QuantityOrdered == "" ? "" : this.state.QuantityOrdered} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, "yes", "", "")} />
                                            <a className="search-results-cart-button float-left ml-2" onClick={(e) => this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1")}><span className="cart-icon" /></a>
                                        </div>
                                    </div>
                                    {/*<img src={imagePath} alt="fav_item" onClick={() => this.showitemdetails(indexval, val.clientPartNumber, val.ItemAttributeId, FavItem)} />*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal" id="add-fav-Img">

                <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1" />
                            <button type="button" className="btn close-btn" data-dismiss="modal">
                                X
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row text-center">
                                <div className="col-md-12 my-4">
                                    <span className="question-mark-icon" />
                                </div>
                                <div className="col-12 mb-4">
                                    <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                    <label className="confirm-content d-block"><Trans>Do you want to add Image for this item?</Trans></label>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.AddfavItem(true)} ><Trans>No</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.BindFavForm(this.state.eventFav, this.state.favexist, this.state.Itemtype, "Yes")}><Trans>Yes</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/*cheaper items*/}
            <div className="modal" id="cheaperitem-popup" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1" />
                            <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.cheaperpopupclose}>
                                X
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className=" modB">
                            <div className="row">
                                <div className="col-md-6 ">
                                    <label className="" style={{ marginLeft: '3rem', fontWeight: '600' }}><Trans>Cheaper Item</Trans></label>
                                    <div className="row mb-1 py-2 ml-4 " >
                                        <div className="order-summary-image category-search-image mx-4" style={{ width: '200px', height: 'fit-content', maxHeight: '290px' }}>
                                            <button className="border image-background px-0 " onClick={() => this.showitemdetails(this.state.cheaperItem.actual_qty, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.ItemAttributeId, this.state.cheaperItem.mfg_std, this.state.cheaperItem.vendor_id, this.state.Itemdetailfav)} style={{ height: '100px' }}>

                                                <Image
                                                    src={this.state.cheaperItemImage}
                                                    width={90}
                                                    height={85}
                                                    style={style.image}
                                                    id="ex-img"
                                                //noImageSrc="/Images/noimage_new.png"
                                                />
                                            </button>
                                        </div>
                                        <div className="col-md-12  mobile-catalog mobile-catalog-search " style={hei}>
                                            <div className="row" style={{ marginLeft: '-10px' }}>
                                                <div className="col-lg-12 mx-1 p-0 search-content">
                                                    <div className="col-md-12 float-left content-spacing">
                                                        <span className="fav-item-title"><a href="#" className="float-left mt-2 category-id category-search-id" onClick={(e) => this.showitemdetails(this.state.cheaperItem.actual_qty, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.ItemAttributeId, this.state.cheaperItem.mfg_std, this.state.cheaperItem.vendor_id, this.state.Itemdetailfav, e)}>{this.state.cheaperItem.clientPartNumber}</a>
                                                        </span>
                                                    </div>
                                                    <label className="col-md-12 item-details-value content-width float-left">
                                                        {this.state.DescriptionType == "1" ? this.state.cheaperItem.longdescriptionone != "\N" || this.state.cheaperItem.longdescriptionone != null ? this.state.cheaperItem.longdescriptionone : "NA" : "NA"}

                                                    </label>
                                                    <div className="col-md-12 float-left">
                                                        <div className="row" style={{ marginLeft: '-15px' }}>
                                                            <div className="col-md-12 search-category-field">
                                                                {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                                                <label className="catalog-label"><Trans>Manufacturer:</Trans></label>
                                                                <label className="item-details-value">{this.state.cheaperItem.manufacturer}</label>
                                                            </div>
                                                            <div className="col-md-12 search-category-field">
                                                                <label className="catalog-label"><span>MFG </span><Trans>part number</Trans><span>:</span></label>
                                                                <label className="item-details-value">{this.state.cheaperItem.manfPartNumber}</label>
                                                            </div>
                                                            <div className="col-md-12 search-category-field">
                                                                <label className="catalog-label">UOM:</label>
                                                                <label className="item-details-value">{this.state.cheaperItem.UOM}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 float-left">
                                                        <span className="catalog-label"><Trans>Supplier</Trans><span>:</span><span className="mx-1">{this.state.cheaperItem.supplierName}</span>
                                                        </span>

                                                    </div>
                                                    <div className="col-md-12 float-left">
                                                        <div className="mt-2">
                                                            <span className="float-left mt-2 price-calc">Qty:</span>
                                                            {/*[12/13/21, PC_SRC_01, WW-275- Added Inc & Decr for qty in cheaper pop up, Poornima S]*/}
                                                            <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                                {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                                                <input type="button" value="-" class="minus" onClick={(e) => this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, this.state.cheaperItem.supplierName, "yes", "", "")} style={{ "backgroundColor": "white" }} />
                                                                <input type="number" step={this.state.CheapItemMinQty} class="minus" min={this.state.CheapItemMinQty} max={this.state.CheapItemMaxQty} name="quantity" value={this.state.QuantityOrdered == null || this.state.QuantityOrdered == "" ? "" : this.state.QuantityOrdered} title="Qty" size="4" pattern="" onChange={(e) => this.EditQuantity(e, true, 0)} inputmode="" id="quantityidCheap" style={{ "width": "45%", "borderLeft": "0" }} />
                                                                <input type="button" value="+" class="plus" onClick={(e) => this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, this.state.cheaperItem.supplierName, "yes", "", "")} style={{ "backgroundColor": "white" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-right mb-2 mt-2" style={{ bottom: "0px" }}>
                                        <div className="float-left  ml-4 mr-5">
                                            {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-4 ml-2 float-left" onClick={(e) => { this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, this.state.cheaperItem.supplierName, "yes", "yes", ""); this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1", "cheap-yes") }}><Trans>Add To Cart</Trans></button>

                                        </div>
                                    </div>

                                </div>
                                {/* <div className="col-md-6">
                                <div className="col-md-12 text-right mb-2 mt-2">
                                   
                                    
                                </div>
                                   </div>
                                {/****expensive item****/}
                                <div className="col-md-6 ">
                                    <label className="" style={{ marginLeft: '3rem', fontWeight: '600' }} ><Trans>Item you choose</Trans></label>
                                    <div className="row mb-1 py-2 ml-4 "  >
                                        <div className=" order-summary-image category-search-image mx-4" style={{ width: '200px', height: 'fit-content', maxHeight: '290px' }}>
                                            <button className="border image-background px-0 " onClick={() => this.showitemdetails(this.state.SelectedItemForCheaper.actual_qty, this.state.cheaperIndex, this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.ItemAttributeId, this.state.SelectedItemForCheaper.mfg_std, this.state.SelectedItemForCheaper.vendor_id, this.state.selectedfav)} style={{ height: '100px' }}>

                                                <Image
                                                    src={this.state.SelectedItemForCheaperImg}
                                                    width={90}
                                                    height={85}
                                                    style={style.image}
                                                    id="cheaper-img"
                                                //noImageSrc="/Images/noimage_new.png"
                                                />
                                            </button>
                                        </div>
                                        <div className="col-md-12   mobile-catalog mobile-catalog-search " style={hei}>
                                            <div className="row" style={{ marginLeft: '-10px' }}>
                                                <div className="col-lg-12 mx-1 p-0 search-content">
                                                    <div className="col-md-12 float-left content-spacing">
                                                        <span className="fav-item-title"><a href="#" className="float-left mt-2 category-id category-search-id" onClick={(e) => this.showitemdetails(this.state.SelectedItemForCheaper.actual_qty, this.state.cheaperIndex, this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.ItemAttributeId, this.state.SelectedItemForCheaper.mfg_std, this.state.SelectedItemForCheaper.vendor_id, this.state.selectedfav, e)}>{this.state.SelectedItemForCheaper.clientPartNumber}</a>
                                                        </span>
                                                    </div>
                                                    <label className="col-md-12 item-details-value content-width float-left">
                                                        {this.state.DescriptionType == "1" ? this.state.SelectedItemForCheaper.longdescriptionone != "\N" || this.state.SelectedItemForCheaper.longdescriptionone != null ? this.state.SelectedItemForCheaper.longdescriptionone : "NA" : "NA"}
                                                    </label>
                                                    <div className="col-md-12 float-left">
                                                        <div className="row" style={{ marginLeft: '-15px' }}>
                                                            <div className="col-md-12 search-category-field">
                                                                {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                                                <label className="catalog-label"><Trans>Manufacturer</Trans>:</label>
                                                                <label className="item-details-value">{this.state.SelectedItemForCheaper.manufacturer}</label>
                                                            </div>
                                                            <div className="col-md-12 search-category-field">
                                                                <label className="catalog-label"><span>MFG </span><Trans>part number</Trans><span>:</span></label>
                                                                <label className="item-details-value">{this.state.SelectedItemForCheaper.manfPartNumber}</label>
                                                            </div>
                                                            <div className="col-md-12 search-category-field">
                                                                <label className="catalog-label">UOM:</label>
                                                                <label className="item-details-value">{this.state.SelectedItemForCheaper.UOM}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 float-left">
                                                        <span className="catalog-label"><Trans>Supplier</Trans><span>:</span><span className="mx-1">{this.state.SelectedItemForCheaper.supplierName}</span>
                                                        </span>

                                                    </div>
                                                    <div className="col-md-12 float-left">
                                                        <div className="mt-2">
                                                            <span className="float-left mt-2 price-calc"><Trans>Qty </Trans>:</span>
                                                            <span className="float-left mt-2 price-calc">{this.state.SelectedItemForCheaper.QuantityOrdered}</span>
                                                            {/* <input type="text" value={this.state.SelectedItemForCheaper.QuantityOrdered == null || this.state.SelectedItemForCheaper.QuantityOrdered == "" ? "" : this.state.SelectedItemForCheaper.QuantityOrdered} className="form-control float-left catalog-inline-qty" maxLength="8" onChange={(e) => this.AddOrder(e, this.state.cheaperIndex, this.state.SelectedItemForCheaper.clientPartNumber, this.state.SelectedItemForCheaper.manfPartNumber, this.state.SelectedItemForCheaper.manufacturer, this.state.cheaperItem.ItemPrice, "yes")} />*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-right mb-2 mt-2" style={{ bottom: "0px" }}>

                                        <div className="float-left  ml-4">
                                            {/*[12/30/21], PC_SR_14, WW-286, Dhevanesam R*/}
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 float-left ml-2" data-dismiss="modal" onClick={(e) => { this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, this.state.cheaperItem.supplierName, "no", "", ""); this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1", "cheap-no"); }}><Trans>Proceed with this item</Trans></button>

                                        </div>
                                    </div>

                                </div>
                                {/***END**/}

                                {/* <div className="col-md-12 text-right mb-2 mt-2">
                                        <div className="float-left col-md-5 ml-4 mr-5">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-4 float-left" onClick={(e) => this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1", "cheap-yes")}>Add To Cart</button>

                                        </div>
                                    <div className="float-left col-md-5 ml-4">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 float-left" data-dismiss="modal" onClick={(e) => { this.AddOrder(e, this.state.cheaperIndex, this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, this.state.cheaperItem.mfg_std, this.state.cheaperItem.ItemPrice, "no"); this.Addtocart(this.state.cheaperItem.clientPartNumber, this.state.cheaperItem.manfPartNumber, "1"); }}>Proceed with this item</button>

                                        </div>
                                    </div>*/}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal" id="SupplierSuggestionId" data-backdrop="static" data-keyboard="false">
                {this.state.ShowSupplierSugg ? <SupplierSuggestionComponent SupplierSuugMFG={this.state.SupplierSuugMFG} SupplierSugMfgName={this.state.SupplierSugMfgName} SuppIsFromFav={this.state.SuppIsFromFav} SuppFavItemPage={this.state.SuppFavItemPage} SuppLongDesc={this.state.SuppLongDesc} {...this.props} /> : null}
            </div>
            {/**********NEW*******wal-158*******/}
            <div className="modal userid" id="WorkOrder" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog  custom-popup modal-dialog-centered">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title mt-1">WO#</h4>
                            <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.WOClose()}>
                                X
                            </button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-md-11 my-3">
                                    <div className="row">
                                        <label className="col-md-5 form-label catalog-label"><Trans>workorder_key</Trans><span> #</span></label>
                                        <div className="col-md-7">
                                            <input type="text" className="form-control " placeholder="Enter work order number" name="WorkOrderNo" onChange={this.handleWOnum} />
                                            {this.state.WOmsg ? <span id="WOError" className="DropDown-Font-Size errorcolour"><Trans>Enter valid WO number</Trans></span> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 text-center mb-2">

                                <button className="btn btn-primary custom-btn-primary primary-btn" id="WOOK" onClick={() => this.WOClick()}><Trans>Ok</Trans></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal  p-0" id="EnersysEmployee" data-backdrop="static">
                <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header bg-white border-0">
                            <h4 class="modal-title mt-1"></h4>
                            <button type="button" className="btn close-btn bg-white" data-dismiss="modal">
                                X
                            </button>
                        </div>
                        {/* Modal body */}

                        <div className="text-center px-4 my-4">
                            <span className="info-label">{this.state.EnersysEmp}</span>
                        </div>


                        <div className="col-md-12 text-right mb-2">
                            <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn mr-2" data-dismiss="modal" onClick={e => this.EnersysyEmp("No")}><Trans>No</Trans></button>{/*[01/30/22, PC_EF_05, Priyanka.D]*/}
                            <button className="btn btn-primary custom-btn-primary primary-btn" onClick={e => this.EnersysyEmp("Yes")}><Trans>Yes</Trans></button>{/*[01/30/22, PC_EF_05, Priyanka.D]*/}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal  p-0" id="Manufacturer_details" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-md" role="document">
                    <div className="modal-content" style={{ height: "610px", overflow: "hidden" }}>
                        <div className="modal-header sp-delv-header">
                            <h5 className="modal-title" id="exampleModalLongTitle"><Trans>Matching part details</Trans></h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body orderitem-slim-scroll" >
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className=" px-1">
                                        {/*Order Card starts here*/}
                                        {this.Mfg_parts()}

                                        {/*Order Card Endss here*/}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal" id="NotanEnersysEmp" data-backdrop="static">
                <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                    <div className="modal-content" style={{ "marginLeft": "78px" }}>
                        {/* Modal Header */}
                        <div className="modal-header bg-white border-0">
                            <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "362px" }}>
                                X
                            </button>
                        </div>
                        {/* Modal body */}

                        <div className="text-center my-4">
                            <span className="info-label"><Trans>Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause</Trans></span>
                        </div>


                        <div className="col-md-12 text-center mb-2">
                            <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={e => this.NotAnEnersysyEmp()}><Trans>Ok</Trans></button>{/*[01/30/22, PC_EF_07, Priyanka.D]*/}
                        </div>
                    </div>
                </div>
            </div>

            {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
            <div className="modal fade p-0" id="SearchMixedOrderConfirmPopup" data-backdrop="static"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                    <div className="modal-content border-0">
                        <div className="modal-header sp-delv-header align-items-center px-4">
                            <h5 className="modal-title" id="exampleModalLongTitle">
                                <Trans>Confirmation</Trans>
                            </h5>
                        </div>
                        <div className="modal-body font-15 px-4">
                            <Trans>{this.state.cartConfirmationPopupTxt}</Trans>
                        </div>

                        {/*button*/}
                        <div className="modal-footer border-0 px-4">
                            <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                type="button"
                                data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  ><Trans>No</Trans></button>

                            <button
                                className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                type="button"><Trans>Yes</Trans></button>

                        </div>
                        {/*button*/}
                    </div>
                </div>
            </div>
            {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}


            {/***/}
            <div className="modal" id="WO_Parts_Popup" >
                {this.state.isValidWO && this.state.WO_Parts.length > 0 ?
                    <WOPartsComponent closePopup={this.WOHistoryClose}  {...this.props} /> : null}
            </div>
        </React.Fragment >
        );

    };
}
export default withTranslation()(SearchResults);



